// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */
html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline;
}

audio:not([controls]) {
  display: none;
  height: 0;
}

[hidden],
template {
  display: none;
}

a {
  background-color: transparent;
}

a:active,
a:hover {
  outline: 0;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

dfn {
  font-style: italic;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

mark {
  background: #ff0;
  color: #000;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

img {
  border: 0;
}

svg:not(:root) {
  overflow: hidden;
}

figure {
  margin: 1em 40px;
}

hr {
  -webkit-box-sizing: content-box;
          box-sizing: content-box;
  height: 0;
}

pre {
  overflow: auto;
}

code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}

button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}

button {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button-moz-focus-inner,
input-moz-focus-inner {
  border: 0;
  padding: 0;
}

input {
  line-height: normal;
}

input[type="checkbox"],
input[type="radio"] {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 0;
}

input[type="number"] -webkit-inner-spin-button,
input[type="number"] -webkit-outer-spin-button {
  height: auto;
}

input[type="search"] {
  -webkit-appearance: textfield;
  -webkit-box-sizing: content-box;
          box-sizing: content-box;
}

input[type="search"] -webkit-search-cancel-button,
input[type="search"] -webkit-search-decoration {
  -webkit-appearance: none;
}

fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

legend {
  border: 0;
  padding: 0;
}

textarea {
  overflow: auto;
}

optgroup {
  font-weight: bold;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  padding: 0;
}

/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */
@media print {
  *,
  *:before,
  *:after {
    background: transparent !important;
    color: #000 !important;
    -webkit-box-shadow: none !important;
            box-shadow: none !important;
    text-shadow: none !important;
  }

  a,
  a:visited {
    text-decoration: underline;
  }

  a[href]:after {
    content: " (" attr(href) ")";
  }

  abbr[title]:after {
    content: " (" attr(title) ")";
  }

  a[href^="#"]:after,
  a[href^="javascript:"]:after {
    content: "";
  }

  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
  }

  thead {
    display: table-header-group;
  }

  tr,
  img {
    page-break-inside: avoid;
  }

  img {
    max-width: 100% !important;
  }

  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }

  h2,
  h3 {
    page-break-after: avoid;
  }

  .navbar {
    display: none;
  }

  .btn > .caret,
  .dropup > .btn > .caret {
    border-top-color: #000 !important;
  }

  .label {
    border: 1px solid #000;
  }

  .table {
    border-collapse: collapse !important;
  }

  .table td,
  .table th {
    background-color: #fff !important;
  }

  .table-bordered th,
  .table-bordered td {
    border: 1px solid #ddd !important;
  }
}

* {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

*:before,
*:after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

html {
  font-size: 10px;
  -webkit-tap-highlight-color: transparent;
}

body {
  /* font-family: Lato, sans-serif; */
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  line-height: 1.78571;
  color: #333333;
  background-color: #fff;
}

input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

a {
  color: #2eb398;
  text-decoration: none;
}

a:hover,
a:focus {
  color: #2e6b5e;
  text-decoration: none;
}

a:focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

figure {
  margin: 0;
}

img {
  vertical-align: middle;
}

.img-responsive {
  display: block;
  max-width: 100%;
  height: auto;
}

.img-rounded {
  border-radius: 6px;
}

.img-thumbnail {
  padding: 4px;
  line-height: 1.78571;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  display: inline-block;
  max-width: 100%;
  height: auto;
}

.img-circle {
  border-radius: 50%;
}

hr {
  margin-top: 25px;
  margin-bottom: 25px;
  border: 0;
  border-top: 1px solid #eeeeee;
}

.sr-only,
.bootstrap-datetimepicker-widget .btn[data-action="incrementHours"] after,
.bootstrap-datetimepicker-widget .btn[data-action="incrementMinutes"] after,
.bootstrap-datetimepicker-widget .btn[data-action="decrementHours"] after,
.bootstrap-datetimepicker-widget .btn[data-action="decrementMinutes"] after,
.bootstrap-datetimepicker-widget .btn[data-action="showHours"] after,
.bootstrap-datetimepicker-widget .btn[data-action="showMinutes"] after,
.bootstrap-datetimepicker-widget .btn[data-action="togglePeriod"] after,
.bootstrap-datetimepicker-widget .btn[data-action="clear"] after,
.bootstrap-datetimepicker-widget .btn[data-action="today"] after,
.bootstrap-datetimepicker-widget .picker-switchafter,
.bootstrap-datetimepicker-widget table th.prevafter,
.bootstrap-datetimepicker-widget table th.nextafter {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}

[role="button"] {
  cursor: pointer;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

h1 small,
h1 .small,
h2 small,
h2 .small,
h3 small,
h3 .small,
h4 small,
h4 .small,
h5 small,
h5 .small,
h6 small,
h6 .small,
.h1 small,
.h1 .small,
.h2 small,
.h2 .small,
.h3 small,
.h3 .small,
.h4 small,
.h4 .small,
.h5 small,
.h5 .small,
.h6 small,
.h6 .small {
  font-weight: normal;
  line-height: 1;
  color: #777777;
}

h1,
.h1,
h2,
.h2,
h3,
.h3 {
  margin-top: 25px;
  margin-bottom: 12.5px;
}

h1 small,
h1 .small,
.h1 small,
.h1 .small,
h2 small,
h2 .small,
.h2 small,
.h2 .small,
h3 small,
h3 .small,
.h3 small,
.h3 .small {
  font-size: 65%;
}

h4,
.h4,
h5,
.h5,
h6,
.h6 {
  margin-top: 12.5px;
  margin-bottom: 12.5px;
}

h4 small,
h4 .small,
.h4 small,
.h4 .small,
h5 small,
h5 .small,
.h5 small,
.h5 .small,
h6 small,
h6 .small,
.h6 small,
.h6 .small {
  font-size: 75%;
}

h1,
.h1 {
  font-size: 36px;
}

h2,
.h2 {
  font-size: 30px;
}

h3,
.h3 {
  font-size: 24px;
}

h4,
.h4 {
  font-size: 18px;
}

h5,
.h5 {
  font-size: 14px;
}

h6,
.h6 {
  font-size: 12px;
}

p {
  margin: 0 0 12.5px;
}

.lead {
  margin-bottom: 25px;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.4;
}

@media (min-width: 990px) {
  .lead {
    font-size: 21px;
  }
}

small,
.small {
  font-size: 85%;
}

mark,
.mark {
  background-color: #fcf8e3;
  padding: 0.2em;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.text-justify {
  text-align: justify;
}

.text-nowrap {
  white-space: nowrap;
}

.text-lowercase {
  text-transform: lowercase;
}

.text-uppercase,
.initialism {
  text-transform: uppercase;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-muted {
  color: #777777;
}

.text-primary {
  color: #428bca;
}

a.text-primary:hover,
a.text-primary:focus {
  color: #3071a9;
}

.text-success {
  color: #3c763d;
}

a.text-success:hover,
a.text-success:focus {
  color: #2b542c;
}

.text-info {
  color: #31708f;
}

a.text-info:hover,
a.text-info:focus {
  color: #245269;
}

.text-warning {
  color: #8a6d3b;
}

a.text-warning:hover,
a.text-warning:focus {
  color: #66512c;
}

.text-danger {
  color: #a94442;
}

a.text-danger:hover,
a.text-danger:focus {
  color: #843534;
}

.bg-primary {
  color: #fff;
}

.bg-primary {
  background-color: #428bca;
}

a.bg-primary:hover,
a.bg-primary:focus {
  background-color: #3071a9;
}

.bg-success {
  background-color: #dff0d8;
}

a.bg-success:hover,
a.bg-success:focus {
  background-color: #c1e2b3;
}

.bg-info {
  background-color: #d9edf7;
}

a.bg-info:hover,
a.bg-info:focus {
  background-color: #afd9ee;
}

.bg-warning {
  background-color: #fcf8e3;
}

a.bg-warning:hover,
a.bg-warning:focus {
  background-color: #f7ecb5;
}

.bg-danger {
  background-color: #f2dede;
}

a.bg-danger:hover,
a.bg-danger:focus {
  background-color: #e4b9b9;
}

.page-header {
  padding-bottom: 11.5px;
  margin: 50px 0 25px;
  border-bottom: 1px solid #eeeeee;
}

ul,
ol {
  margin-top: 0;
  margin-bottom: 12.5px;
}

ul ul,
ul ol,
ol ul,
ol ol {
  margin-bottom: 0;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
  margin-left: -5px;
}

.list-inline > li {
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
}

dl {
  margin-top: 0;
  margin-bottom: 25px;
}

dt,
dd {
  line-height: 1.78571;
}

dt {
  font-weight: bold;
}

dd {
  margin-left: 0;
}

.dl-horizontal dd:before,
.dl-horizontal dd:after {
  content: " ";
  display: table;
}

.dl-horizontal dd:after {
  clear: both;
}

@media (min-width: 990px) {
  .dl-horizontal dt {
    float: left;
    width: 160px;
    clear: left;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .dl-horizontal dd {
    margin-left: 180px;
  }
}

abbr[title],
abbr[data-original-title] {
  cursor: help;
  border-bottom: 1px dotted #777777;
}

.initialism {
  font-size: 90%;
}

blockquote {
  padding: 12.5px 25px;
  margin: 0 0 25px;
  font-size: 17.5px;
  border-left: 5px solid #eeeeee;
}

blockquote p:last-child,
blockquote ul:last-child,
blockquote ol:last-child {
  margin-bottom: 0;
}

blockquote footer,
blockquote small,
blockquote .small {
  display: block;
  font-size: 80%;
  line-height: 1.78571;
  color: #777777;
}

blockquote footer:before,
blockquote small:before,
blockquote .small:before {
  content: "\\2014 \\00A0";
}

.blockquote-reverse,
blockquote.pull-right {
  padding-right: 15px;
  padding-left: 0;
  border-right: 5px solid #eeeeee;
  border-left: 0;
  text-align: right;
}

.blockquote-reverse footer:before,
.blockquote-reverse small:before,
.blockquote-reverse .small:before,
blockquote.pull-right footer:before,
blockquote.pull-right small:before,
blockquote.pull-right .small:before {
  content: "";
}

.blockquote-reverse footer:after,
.blockquote-reverse small:after,
.blockquote-reverse .small:after,
blockquote.pull-right footer:after,
blockquote.pull-right small:after,
blockquote.pull-right .small:after {
  content: "\\00A0 \\2014";
}

address {
  margin-bottom: 25px;
  font-style: normal;
  line-height: 1.78571;
}

code,
kbd,
pre,
samp {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
}

code {
  padding: 2px 4px;
  font-size: 90%;
  color: #c7254e;
  background-color: #f9f2f4;
  border-radius: 4px;
  -webkit-box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
          box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
}

code[class*="language-"],
pre[class*="language-"] {
  -webkit-box-shadow: none;
          box-shadow: none;
}

kbd {
  padding: 2px 4px;
  font-size: 90%;
  color: #fff;
  background-color: #333;
  border-radius: 3px;
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.25);
          box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.25);
}

kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: bold;
  -webkit-box-shadow: none;
          box-shadow: none;
}

pre {
  display: block;
  padding: 12px;
  margin: 0 0 12.5px;
  font-size: 13px;
  line-height: 1.78571;
  word-break: break-all;
  word-wrap: break-word;
  color: #333333;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
}

pre code {
  padding: 0;
  font-size: inherit;
  color: inherit;
  white-space: pre-wrap;
  background-color: transparent;
  border-radius: 0;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container {
  margin-right: auto;
  margin-left: auto;
  padding-left: 25px;
  padding-right: 25px;
}

.container:before,
.container:after {
  content: " ";
  display: table;
}

.container:after {
  clear: both;
}

@media (min-width: 990px) {
  .container {
    width: 990px;
  }
}

@media (min-width: 1152px) {
  .container {
    width: 990px;
  }
}

@media (min-width: 1366px) {
  .container {
    width: 990px;
  }
}

.container-fluid {
  margin-right: auto;
  margin-left: auto;
  padding-left: 25px;
  padding-right: 25px;
}

.container-fluid:before,
.container-fluid:after {
  content: " ";
  display: table;
}

.container-fluid:after {
  clear: both;
}

.row {
  margin-left: -25px;
  margin-right: -25px;
}

.row:before,
.row:after {
  content: " ";
  display: table;
}

.row:after {
  clear: both;
}

.col-xs-1,
.col-sm-1,
.col-md-1,
.col-lg-1,
.col-xs-2,
.col-sm-2,
.col-md-2,
.col-lg-2,
.col-xs-3,
.col-sm-3,
.col-md-3,
.col-lg-3,
.col-xs-4,
.col-sm-4,
.col-md-4,
.col-lg-4,
.col-xs-5,
.col-sm-5,
.col-md-5,
.col-lg-5,
.col-xs-6,
.col-sm-6,
.col-md-6,
.col-lg-6,
.col-xs-7,
.col-sm-7,
.col-md-7,
.col-lg-7,
.col-xs-8,
.col-sm-8,
.col-md-8,
.col-lg-8,
.col-xs-9,
.col-sm-9,
.col-md-9,
.col-lg-9,
.col-xs-10,
.col-sm-10,
.col-md-10,
.col-lg-10,
.col-xs-11,
.col-sm-11,
.col-md-11,
.col-lg-11,
.col-xs-12,
.col-sm-12,
.col-md-12,
.col-lg-12 {
  position: relative;
  min-height: 1px;
  padding-left: 25px;
  padding-right: 25px;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
}

.col-xs-1 {
  width: 8.33333%;
}

.col-xs-2 {
  width: 16.66667%;
}

.col-xs-3 {
  width: 25%;
}

.col-xs-4 {
  width: 33.33333%;
}

.col-xs-5 {
  width: 41.66667%;
}

.col-xs-6 {
  width: 50%;
}

.col-xs-7 {
  width: 58.33333%;
}

.col-xs-8 {
  width: 66.66667%;
}

.col-xs-9 {
  width: 75%;
}

.col-xs-10 {
  width: 83.33333%;
}

.col-xs-11 {
  width: 91.66667%;
}

.col-xs-12 {
  width: 100%;
}

.col-xs-pull-0 {
  right: auto;
}

.col-xs-pull-1 {
  right: 8.33333%;
}

.col-xs-pull-2 {
  right: 16.66667%;
}

.col-xs-pull-3 {
  right: 25%;
}

.col-xs-pull-4 {
  right: 33.33333%;
}

.col-xs-pull-5 {
  right: 41.66667%;
}

.col-xs-pull-6 {
  right: 50%;
}

.col-xs-pull-7 {
  right: 58.33333%;
}

.col-xs-pull-8 {
  right: 66.66667%;
}

.col-xs-pull-9 {
  right: 75%;
}

.col-xs-pull-10 {
  right: 83.33333%;
}

.col-xs-pull-11 {
  right: 91.66667%;
}

.col-xs-pull-12 {
  right: 100%;
}

.col-xs-push-0 {
  left: auto;
}

.col-xs-push-1 {
  left: 8.33333%;
}

.col-xs-push-2 {
  left: 16.66667%;
}

.col-xs-push-3 {
  left: 25%;
}

.col-xs-push-4 {
  left: 33.33333%;
}

.col-xs-push-5 {
  left: 41.66667%;
}

.col-xs-push-6 {
  left: 50%;
}

.col-xs-push-7 {
  left: 58.33333%;
}

.col-xs-push-8 {
  left: 66.66667%;
}

.col-xs-push-9 {
  left: 75%;
}

.col-xs-push-10 {
  left: 83.33333%;
}

.col-xs-push-11 {
  left: 91.66667%;
}

.col-xs-push-12 {
  left: 100%;
}

.col-xs-offset-0 {
  margin-left: 0%;
}

.col-xs-offset-1 {
  margin-left: 8.33333%;
}

.col-xs-offset-2 {
  margin-left: 16.66667%;
}

.col-xs-offset-3 {
  margin-left: 25%;
}

.col-xs-offset-4 {
  margin-left: 33.33333%;
}

.col-xs-offset-5 {
  margin-left: 41.66667%;
}

.col-xs-offset-6 {
  margin-left: 50%;
}

.col-xs-offset-7 {
  margin-left: 58.33333%;
}

.col-xs-offset-8 {
  margin-left: 66.66667%;
}

.col-xs-offset-9 {
  margin-left: 75%;
}

.col-xs-offset-10 {
  margin-left: 83.33333%;
}

.col-xs-offset-11 {
  margin-left: 91.66667%;
}

.col-xs-offset-12 {
  margin-left: 100%;
}

@media (min-width: 990px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
  }

  .col-sm-1 {
    width: 8.33333%;
  }

  .col-sm-2 {
    width: 16.66667%;
  }

  .col-sm-3 {
    width: 25%;
  }

  .col-sm-4 {
    width: 33.33333%;
  }

  .col-sm-5 {
    width: 41.66667%;
  }

  .col-sm-6 {
    width: 50%;
  }

  .col-sm-7 {
    width: 58.33333%;
  }

  .col-sm-8 {
    width: 66.66667%;
  }

  .col-sm-9 {
    width: 75%;
  }

  .col-sm-10 {
    width: 83.33333%;
  }

  .col-sm-11 {
    width: 91.66667%;
  }

  .col-sm-12 {
    width: 100%;
  }

  .col-sm-pull-0 {
    right: auto;
  }

  .col-sm-pull-1 {
    right: 8.33333%;
  }

  .col-sm-pull-2 {
    right: 16.66667%;
  }

  .col-sm-pull-3 {
    right: 25%;
  }

  .col-sm-pull-4 {
    right: 33.33333%;
  }

  .col-sm-pull-5 {
    right: 41.66667%;
  }

  .col-sm-pull-6 {
    right: 50%;
  }

  .col-sm-pull-7 {
    right: 58.33333%;
  }

  .col-sm-pull-8 {
    right: 66.66667%;
  }

  .col-sm-pull-9 {
    right: 75%;
  }

  .col-sm-pull-10 {
    right: 83.33333%;
  }

  .col-sm-pull-11 {
    right: 91.66667%;
  }

  .col-sm-pull-12 {
    right: 100%;
  }

  .col-sm-push-0 {
    left: auto;
  }

  .col-sm-push-1 {
    left: 8.33333%;
  }

  .col-sm-push-2 {
    left: 16.66667%;
  }

  .col-sm-push-3 {
    left: 25%;
  }

  .col-sm-push-4 {
    left: 33.33333%;
  }

  .col-sm-push-5 {
    left: 41.66667%;
  }

  .col-sm-push-6 {
    left: 50%;
  }

  .col-sm-push-7 {
    left: 58.33333%;
  }

  .col-sm-push-8 {
    left: 66.66667%;
  }

  .col-sm-push-9 {
    left: 75%;
  }

  .col-sm-push-10 {
    left: 83.33333%;
  }

  .col-sm-push-11 {
    left: 91.66667%;
  }

  .col-sm-push-12 {
    left: 100%;
  }

  .col-sm-offset-0 {
    margin-left: 0%;
  }

  .col-sm-offset-1 {
    margin-left: 8.33333%;
  }

  .col-sm-offset-2 {
    margin-left: 16.66667%;
  }

  .col-sm-offset-3 {
    margin-left: 25%;
  }

  .col-sm-offset-4 {
    margin-left: 33.33333%;
  }

  .col-sm-offset-5 {
    margin-left: 41.66667%;
  }

  .col-sm-offset-6 {
    margin-left: 50%;
  }

  .col-sm-offset-7 {
    margin-left: 58.33333%;
  }

  .col-sm-offset-8 {
    margin-left: 66.66667%;
  }

  .col-sm-offset-9 {
    margin-left: 75%;
  }

  .col-sm-offset-10 {
    margin-left: 83.33333%;
  }

  .col-sm-offset-11 {
    margin-left: 91.66667%;
  }

  .col-sm-offset-12 {
    margin-left: 100%;
  }
}

@media (min-width: 1152px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
  }

  .col-md-1 {
    width: 8.33333%;
  }

  .col-md-2 {
    width: 16.66667%;
  }

  .col-md-3 {
    width: 25%;
  }

  .col-md-4 {
    width: 33.33333%;
  }

  .col-md-5 {
    width: 41.66667%;
  }

  .col-md-6 {
    width: 50%;
  }

  .col-md-7 {
    width: 58.33333%;
  }

  .col-md-8 {
    width: 66.66667%;
  }

  .col-md-9 {
    width: 75%;
  }

  .col-md-10 {
    width: 83.33333%;
  }

  .col-md-11 {
    width: 91.66667%;
  }

  .col-md-12 {
    width: 100%;
  }

  .col-md-pull-0 {
    right: auto;
  }

  .col-md-pull-1 {
    right: 8.33333%;
  }

  .col-md-pull-2 {
    right: 16.66667%;
  }

  .col-md-pull-3 {
    right: 25%;
  }

  .col-md-pull-4 {
    right: 33.33333%;
  }

  .col-md-pull-5 {
    right: 41.66667%;
  }

  .col-md-pull-6 {
    right: 50%;
  }

  .col-md-pull-7 {
    right: 58.33333%;
  }

  .col-md-pull-8 {
    right: 66.66667%;
  }

  .col-md-pull-9 {
    right: 75%;
  }

  .col-md-pull-10 {
    right: 83.33333%;
  }

  .col-md-pull-11 {
    right: 91.66667%;
  }

  .col-md-pull-12 {
    right: 100%;
  }

  .col-md-push-0 {
    left: auto;
  }

  .col-md-push-1 {
    left: 8.33333%;
  }

  .col-md-push-2 {
    left: 16.66667%;
  }

  .col-md-push-3 {
    left: 25%;
  }

  .col-md-push-4 {
    left: 33.33333%;
  }

  .col-md-push-5 {
    left: 41.66667%;
  }

  .col-md-push-6 {
    left: 50%;
  }

  .col-md-push-7 {
    left: 58.33333%;
  }

  .col-md-push-8 {
    left: 66.66667%;
  }

  .col-md-push-9 {
    left: 75%;
  }

  .col-md-push-10 {
    left: 83.33333%;
  }

  .col-md-push-11 {
    left: 91.66667%;
  }

  .col-md-push-12 {
    left: 100%;
  }

  .col-md-offset-0 {
    margin-left: 0%;
  }

  .col-md-offset-1 {
    margin-left: 8.33333%;
  }

  .col-md-offset-2 {
    margin-left: 16.66667%;
  }

  .col-md-offset-3 {
    margin-left: 25%;
  }

  .col-md-offset-4 {
    margin-left: 33.33333%;
  }

  .col-md-offset-5 {
    margin-left: 41.66667%;
  }

  .col-md-offset-6 {
    margin-left: 50%;
  }

  .col-md-offset-7 {
    margin-left: 58.33333%;
  }

  .col-md-offset-8 {
    margin-left: 66.66667%;
  }

  .col-md-offset-9 {
    margin-left: 75%;
  }

  .col-md-offset-10 {
    margin-left: 83.33333%;
  }

  .col-md-offset-11 {
    margin-left: 91.66667%;
  }

  .col-md-offset-12 {
    margin-left: 100%;
  }
}

@media (min-width: 1366px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
  }

  .col-lg-1 {
    width: 8.33333%;
  }

  .col-lg-2 {
    width: 16.66667%;
  }

  .col-lg-3 {
    width: 25%;
  }

  .col-lg-4 {
    width: 33.33333%;
  }

  .col-lg-5 {
    width: 41.66667%;
  }

  .col-lg-6 {
    width: 50%;
  }

  .col-lg-7 {
    width: 58.33333%;
  }

  .col-lg-8 {
    width: 66.66667%;
  }

  .col-lg-9 {
    width: 75%;
  }

  .col-lg-10 {
    width: 83.33333%;
  }

  .col-lg-11 {
    width: 91.66667%;
  }

  .col-lg-12 {
    width: 100%;
  }

  .col-lg-pull-0 {
    right: auto;
  }

  .col-lg-pull-1 {
    right: 8.33333%;
  }

  .col-lg-pull-2 {
    right: 16.66667%;
  }

  .col-lg-pull-3 {
    right: 25%;
  }

  .col-lg-pull-4 {
    right: 33.33333%;
  }

  .col-lg-pull-5 {
    right: 41.66667%;
  }

  .col-lg-pull-6 {
    right: 50%;
  }

  .col-lg-pull-7 {
    right: 58.33333%;
  }

  .col-lg-pull-8 {
    right: 66.66667%;
  }

  .col-lg-pull-9 {
    right: 75%;
  }

  .col-lg-pull-10 {
    right: 83.33333%;
  }

  .col-lg-pull-11 {
    right: 91.66667%;
  }

  .col-lg-pull-12 {
    right: 100%;
  }

  .col-lg-push-0 {
    left: auto;
  }

  .col-lg-push-1 {
    left: 8.33333%;
  }

  .col-lg-push-2 {
    left: 16.66667%;
  }

  .col-lg-push-3 {
    left: 25%;
  }

  .col-lg-push-4 {
    left: 33.33333%;
  }

  .col-lg-push-5 {
    left: 41.66667%;
  }

  .col-lg-push-6 {
    left: 50%;
  }

  .col-lg-push-7 {
    left: 58.33333%;
  }

  .col-lg-push-8 {
    left: 66.66667%;
  }

  .col-lg-push-9 {
    left: 75%;
  }

  .col-lg-push-10 {
    left: 83.33333%;
  }

  .col-lg-push-11 {
    left: 91.66667%;
  }

  .col-lg-push-12 {
    left: 100%;
  }

  .col-lg-offset-0 {
    margin-left: 0%;
  }

  .col-lg-offset-1 {
    margin-left: 8.33333%;
  }

  .col-lg-offset-2 {
    margin-left: 16.66667%;
  }

  .col-lg-offset-3 {
    margin-left: 25%;
  }

  .col-lg-offset-4 {
    margin-left: 33.33333%;
  }

  .col-lg-offset-5 {
    margin-left: 41.66667%;
  }

  .col-lg-offset-6 {
    margin-left: 50%;
  }

  .col-lg-offset-7 {
    margin-left: 58.33333%;
  }

  .col-lg-offset-8 {
    margin-left: 66.66667%;
  }

  .col-lg-offset-9 {
    margin-left: 75%;
  }

  .col-lg-offset-10 {
    margin-left: 83.33333%;
  }

  .col-lg-offset-11 {
    margin-left: 91.66667%;
  }

  .col-lg-offset-12 {
    margin-left: 100%;
  }
}

table {
  background-color: transparent;
}

caption {
  padding-top: 8px;
  padding-bottom: 8px;
  color: #777777;
  text-align: left;
}

th {
  text-align: left;
}

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 25px;
}

.table > thead > tr > th,
.table > thead > tr > td,
.table > tbody > tr > th,
.table > tbody > tr > td,
.table > tfoot > tr > th,
.table > tfoot > tr > td {
  padding: 8px;
  line-height: 1.78571;
  vertical-align: top;
  border-top: 1px solid #ddd;
}

.table > thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #ddd;
}

.table > caption + thead > tr:first-child > th,
.table > caption + thead > tr:first-child > td,
.table > colgroup + thead > tr:first-child > th,
.table > colgroup + thead > tr:first-child > td,
.table > thead:first-child > tr:first-child > th,
.table > thead:first-child > tr:first-child > td {
  border-top: 0;
}

.table > tbody + tbody {
  border-top: 2px solid #ddd;
}

.table .table {
  background-color: #fff;
}

.table-condensed > thead > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > tbody > tr > th,
.table-condensed > tbody > tr > td,
.table-condensed > tfoot > tr > th,
.table-condensed > tfoot > tr > td {
  padding: 5px;
}

.table-bordered {
  border: 1px solid #ddd;
}

.table-bordered > thead > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > tbody > tr > th,
.table-bordered > tbody > tr > td,
.table-bordered > tfoot > tr > th,
.table-bordered > tfoot > tr > td {
  border: 1px solid #ddd;
}

.table-bordered > thead > tr > th,
.table-bordered > thead > tr > td {
  border-bottom-width: 2px;
}

.table-spatiented > tbody > tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}

.table-hover > tbody > tr:hover {
  background-color: #f5f5f5;
}

table col[class*="col-"] {
  position: static;
  float: none;
  display: table-column;
}

table td[class*="col-"],
table th[class*="col-"] {
  position: static;
  float: none;
  display: table-cell;
}

.table > thead > tr > td.active,
.table > thead > tr > th.active,
.table > thead > tr.active > td,
.table > thead > tr.active > th,
.table > tbody > tr > td.active,
.table > tbody > tr > th.active,
.table > tbody > tr.active > td,
.table > tbody > tr.active > th,
.table > tfoot > tr > td.active,
.table > tfoot > tr > th.active,
.table > tfoot > tr.active > td,
.table > tfoot > tr.active > th {
  background-color: #f5f5f5;
}

.table-hover > tbody > tr > td.active:hover,
.table-hover > tbody > tr > th.active:hover,
.table-hover > tbody > tr.active:hover > td,
.table-hover > tbody > tr:hover > .active,
.table-hover > tbody > tr.active:hover > th {
  background-color: #e8e8e8;
}

.table > thead > tr > td.success,
.table > thead > tr > th.success,
.table > thead > tr.success > td,
.table > thead > tr.success > th,
.table > tbody > tr > td.success,
.table > tbody > tr > th.success,
.table > tbody > tr.success > td,
.table > tbody > tr.success > th,
.table > tfoot > tr > td.success,
.table > tfoot > tr > th.success,
.table > tfoot > tr.success > td,
.table > tfoot > tr.success > th {
  background-color: #dff0d8;
}

.table-hover > tbody > tr > td.success:hover,
.table-hover > tbody > tr > th.success:hover,
.table-hover > tbody > tr.success:hover > td,
.table-hover > tbody > tr:hover > .success,
.table-hover > tbody > tr.success:hover > th {
  background-color: #d0e9c6;
}

.table > thead > tr > td.info,
.table > thead > tr > th.info,
.table > thead > tr.info > td,
.table > thead > tr.info > th,
.table > tbody > tr > td.info,
.table > tbody > tr > th.info,
.table > tbody > tr.info > td,
.table > tbody > tr.info > th,
.table > tfoot > tr > td.info,
.table > tfoot > tr > th.info,
.table > tfoot > tr.info > td,
.table > tfoot > tr.info > th {
  background-color: #d9edf7;
}

.table-hover > tbody > tr > td.info:hover,
.table-hover > tbody > tr > th.info:hover,
.table-hover > tbody > tr.info:hover > td,
.table-hover > tbody > tr:hover > .info,
.table-hover > tbody > tr.info:hover > th {
  background-color: #c4e3f3;
}

.table > thead > tr > td.warning,
.table > thead > tr > th.warning,
.table > thead > tr.warning > td,
.table > thead > tr.warning > th,
.table > tbody > tr > td.warning,
.table > tbody > tr > th.warning,
.table > tbody > tr.warning > td,
.table > tbody > tr.warning > th,
.table > tfoot > tr > td.warning,
.table > tfoot > tr > th.warning,
.table > tfoot > tr.warning > td,
.table > tfoot > tr.warning > th {
  background-color: #fcf8e3;
}

.table-hover > tbody > tr > td.warning:hover,
.table-hover > tbody > tr > th.warning:hover,
.table-hover > tbody > tr.warning:hover > td,
.table-hover > tbody > tr:hover > .warning,
.table-hover > tbody > tr.warning:hover > th {
  background-color: #faf2cc;
}

.table > thead > tr > td.danger,
.table > thead > tr > th.danger,
.table > thead > tr.danger > td,
.table > thead > tr.danger > th,
.table > tbody > tr > td.danger,
.table > tbody > tr > th.danger,
.table > tbody > tr.danger > td,
.table > tbody > tr.danger > th,
.table > tfoot > tr > td.danger,
.table > tfoot > tr > th.danger,
.table > tfoot > tr.danger > td,
.table > tfoot > tr.danger > th {
  background-color: #f2dede;
}

.table-hover > tbody > tr > td.danger:hover,
.table-hover > tbody > tr > th.danger:hover,
.table-hover > tbody > tr.danger:hover > td,
.table-hover > tbody > tr:hover > .danger,
.table-hover > tbody > tr.danger:hover > th {
  background-color: #ebcccc;
}

.table-responsive {
  overflow-x: auto;
  min-height: 0.01%;
}

@media screen and (max-width: 989px), (max-width: 1280px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 18.75px;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #ddd;
  }

  .table-responsive > .table {
    margin-bottom: 0;
  }

  .table-responsive > .table > thead > tr > th,
  .table-responsive > .table > thead > tr > td,
  .table-responsive > .table > tbody > tr > th,
  .table-responsive > .table > tbody > tr > td,
  .table-responsive > .table > tfoot > tr > th,
  .table-responsive > .table > tfoot > tr > td {
    white-space: nowrap;
  }

  .table-responsive > .table-bordered {
    border: 0;
  }

  .table-responsive > .table-bordered > thead > tr > th:first-child,
  .table-responsive > .table-bordered > thead > tr > td:first-child,
  .table-responsive > .table-bordered > tbody > tr > th:first-child,
  .table-responsive > .table-bordered > tbody > tr > td:first-child,
  .table-responsive > .table-bordered > tfoot > tr > th:first-child,
  .table-responsive > .table-bordered > tfoot > tr > td:first-child {
    border-left: 0;
  }

  .table-responsive > .table-bordered > thead > tr > th:last-child,
  .table-responsive > .table-bordered > thead > tr > td:last-child,
  .table-responsive > .table-bordered > tbody > tr > th:last-child,
  .table-responsive > .table-bordered > tbody > tr > td:last-child,
  .table-responsive > .table-bordered > tfoot > tr > th:last-child,
  .table-responsive > .table-bordered > tfoot > tr > td:last-child {
    border-right: 0;
  }

  .table-responsive > .table-bordered > tbody > tr:last-child > th,
  .table-responsive > .table-bordered > tbody > tr:last-child > td,
  .table-responsive > .table-bordered > tfoot > tr:last-child > th,
  .table-responsive > .table-bordered > tfoot > tr:last-child > td {
    border-bottom: 0;
  }
}

.table-top-align td,
.table-top-align th {
  vertical-align: top !important;
}

.table-middle-align td,
.table-middle-align th {
  vertical-align: middle !important;
}

.table-bottom-align td,
.table-bottom-align th {
  vertical-align: bottom !important;
}

.table-collapsed {
  margin: 0;
}

fieldset {
  padding: 0;
  margin: 0;
  border: 0;
  min-width: 0;
}

legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 25px;
  font-size: 21px;
  line-height: inherit;
  color: #333333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}

label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  /* font-weight: bold; */
}

input[type="search"] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

input[type="radio"],
input[type="checkbox"] {
  margin: 4px 0 0;
  margin-top: 1px \\9;
  line-height: normal;
}

input[type="file"] {
  display: block;
}

input[type="range"] {
  display: block;
  width: 100%;
}

select[multiple],
select[size] {
  height: auto;
}

input[type="file"]:focus,
input[type="radio"]:focus,
input[type="checkbox"]:focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

output {
  display: block;
  padding-top: 7px;
  font-size: 14px;
  line-height: 1.78571;
  color: #555555;
}

.form-control {
  display: block;
  width: 100%;
  height: 38px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.78571;
  color: #555555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
}

.form-control:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}

.form-control-moz-placeholder {
  color: #999;
  opacity: 1;
}

.form-control:-ms-input-placeholder {
  color: #999;
}

.form-control-webkit-input-placeholder {
  color: #999;
}

.form-control-ms-expand {
  border: 0;
  background-color: transparent;
}

.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  background-color: #eeeeee;
  opacity: 1;
}

.form-control[disabled],
fieldset[disabled] .form-control {
  cursor: not-allowed;
}

textarea.form-control {
  height: auto;
}

input[type="search"] {
  -webkit-appearance: none;
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  input[type="date"].form-control,
  input[type="time"].form-control,
  input[type="datetime-local"].form-control,
  input[type="month"].form-control {
    line-height: 38px;
  }

  input[type="date"].input-sm,
  .input-group-sm > input[type="date"].form-control,
  .input-group-sm > input[type="date"].input-group-addon,
  .input-group-sm > .input-group-btn > input[type="date"].btn,
  .input-group-sm input[type="date"],
  input[type="time"].input-sm,
  .input-group-sm > input[type="time"].form-control,
  .input-group-sm > input[type="time"].input-group-addon,
  .input-group-sm > .input-group-btn > input[type="time"].btn,
  .input-group-sm input[type="time"],
  input[type="datetime-local"].input-sm,
  .input-group-sm > input[type="datetime-local"].form-control,
  .input-group-sm > input[type="datetime-local"].input-group-addon,
  .input-group-sm > .input-group-btn > input[type="datetime-local"].btn,
  .input-group-sm input[type="datetime-local"],
  input[type="month"].input-sm,
  .input-group-sm > input[type="month"].form-control,
  .input-group-sm > input[type="month"].input-group-addon,
  .input-group-sm > .input-group-btn > input[type="month"].btn,
  .input-group-sm input[type="month"] {
    line-height: 30px;
  }

  input[type="date"].input-lg,
  .input-group-lg > input[type="date"].form-control,
  .input-group-lg > input[type="date"].input-group-addon,
  .input-group-lg > .input-group-btn > input[type="date"].btn,
  .input-group-lg input[type="date"],
  input[type="time"].input-lg,
  .input-group-lg > input[type="time"].form-control,
  .input-group-lg > input[type="time"].input-group-addon,
  .input-group-lg > .input-group-btn > input[type="time"].btn,
  .input-group-lg input[type="time"],
  input[type="datetime-local"].input-lg,
  .input-group-lg > input[type="datetime-local"].form-control,
  .input-group-lg > input[type="datetime-local"].input-group-addon,
  .input-group-lg > .input-group-btn > input[type="datetime-local"].btn,
  .input-group-lg input[type="datetime-local"],
  input[type="month"].input-lg,
  .input-group-lg > input[type="month"].form-control,
  .input-group-lg > input[type="month"].input-group-addon,
  .input-group-lg > .input-group-btn > input[type="month"].btn,
  .input-group-lg input[type="month"] {
    line-height: 46px;
  }
}

.form-group {
  margin-bottom: 15px;
}

.radio,
.checkbox {
  position: relative;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
}

.radio label,
.checkbox label {
  min-height: 25px;
  padding-left: 20px;
  margin-bottom: 0;
  font-weight: normal;
  cursor: pointer;
}

.radio input[type="radio"],
.radio-inline input[type="radio"],
.checkbox input[type="checkbox"],
.checkbox-inline input[type="checkbox"] {
  position: absolute;
  margin-left: -20px;
  margin-top: 4px \\9;
}

.radio + .radio,
.checkbox + .checkbox {
  margin-top: -5px;
}

.radio-inline,
.checkbox-inline {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  margin-bottom: 0;
  vertical-align: middle;
  font-weight: normal;
  cursor: pointer;
}

.radio-inline + .radio-inline,
.checkbox-inline + .checkbox-inline {
  margin-top: 0;
  margin-left: 10px;
}

input[type="radio"][disabled],
input[type="radio"].disabled,
fieldset[disabled] input[type="radio"],
input[type="checkbox"][disabled],
input[type="checkbox"].disabled,
fieldset[disabled] input[type="checkbox"] {
  cursor: not-allowed;
}

.radio-inline.disabled,
fieldset[disabled] .radio-inline,
.checkbox-inline.disabled,
fieldset[disabled] .checkbox-inline {
  cursor: not-allowed;
}

.radio.disabled label,
fieldset[disabled] .radio label,
.checkbox.disabled label,
fieldset[disabled] .checkbox label {
  cursor: not-allowed;
}

.form-control-static {
  padding-top: 7px;
  padding-bottom: 7px;
  margin-bottom: 0;
  min-height: 39px;
}

.form-control-static.input-lg,
.input-group-lg > .form-control-static.form-control,
.input-group-lg > .form-control-static.input-group-addon,
.input-group-lg > .input-group-btn > .form-control-static.btn,
.form-control-static.input-sm,
.input-group-sm > .form-control-static.form-control,
.input-group-sm > .form-control-static.input-group-addon,
.input-group-sm > .input-group-btn > .form-control-static.btn {
  padding-left: 0;
  padding-right: 0;
}

.input-sm,
.input-group-sm > .form-control,
.input-group-sm > .input-group-addon,
.input-group-sm > .input-group-btn > .btn {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}

select.input-sm,
.input-group-sm > select.form-control,
.input-group-sm > select.input-group-addon,
.input-group-sm > .input-group-btn > select.btn {
  height: 30px;
  line-height: 30px;
}

textarea.input-sm,
.input-group-sm > textarea.form-control,
.input-group-sm > textarea.input-group-addon,
.input-group-sm > .input-group-btn > textarea.btn,
select[multiple].input-sm,
.input-group-sm > select[multiple].form-control,
.input-group-sm > select[multiple].input-group-addon,
.input-group-sm > .input-group-btn > select[multiple].btn {
  height: auto;
}

.form-group-sm .form-control {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}

.form-group-sm select.form-control {
  height: 30px;
  line-height: 30px;
}

.form-group-sm textarea.form-control,
.form-group-sm select[multiple].form-control {
  height: auto;
}

.form-group-sm .form-control-static {
  height: 30px;
  min-height: 37px;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.input-lg,
.input-group-lg > .form-control,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .btn {
  height: 46px;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33333;
  border-radius: 6px;
}

select.input-lg,
.input-group-lg > select.form-control,
.input-group-lg > select.input-group-addon,
.input-group-lg > .input-group-btn > select.btn {
  height: 46px;
  line-height: 46px;
}

textarea.input-lg,
.input-group-lg > textarea.form-control,
.input-group-lg > textarea.input-group-addon,
.input-group-lg > .input-group-btn > textarea.btn,
select[multiple].input-lg,
.input-group-lg > select[multiple].form-control,
.input-group-lg > select[multiple].input-group-addon,
.input-group-lg > .input-group-btn > select[multiple].btn {
  height: auto;
}

.form-group-lg .form-control {
  height: 46px;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33333;
  border-radius: 6px;
}

.form-group-lg select.form-control {
  height: 46px;
  line-height: 46px;
}

.form-group-lg textarea.form-control,
.form-group-lg select[multiple].form-control {
  height: auto;
}

.form-group-lg .form-control-static {
  height: 46px;
  min-height: 43px;
  padding: 11px 16px;
  font-size: 18px;
  line-height: 1.33333;
}

.has-feedback {
  position: relative;
}

.has-feedback .form-control {
  padding-right: 47.5px;
}

.form-control-feedback {
  position: absolute !important;
  top: 0;
  right: 0;
  z-index: 2;
  display: block;
  width: 38px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  pointer-events: none;
}

.input-lg + .form-control-feedback,
.input-group-lg > .form-control + .form-control-feedback,
.input-group-lg > .input-group-addon + .form-control-feedback,
.input-group-lg > .input-group-btn > .btn + .form-control-feedback,
.input-group-lg + .form-control-feedback,
.form-group-lg .form-control + .form-control-feedback {
  width: 46px;
  height: 46px;
  line-height: 46px;
}

.input-sm + .form-control-feedback,
.input-group-sm > .form-control + .form-control-feedback,
.input-group-sm > .input-group-addon + .form-control-feedback,
.input-group-sm > .input-group-btn > .btn + .form-control-feedback,
.input-group-sm + .form-control-feedback,
.form-group-sm .form-control + .form-control-feedback {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.has-success .help-block,
.has-success .control-label,
.has-success .radio,
.has-success .checkbox,
.has-success .radio-inline,
.has-success .checkbox-inline,
.has-success.radio label,
.has-success.checkbox label,
.has-success.radio-inline label,
.has-success.checkbox-inline label {
  color: #3c763d;
}

.has-success .form-control {
  border-color: #3c763d !important;
}

.has-success .form-control:focus {
  border-color: #2b542c;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;
}

.has-success .input-group-addon {
  color: #3c763d;
  border-color: #3c763d;
  background-color: #dff0d8;
}

.has-success .form-control-feedback {
  color: #3c763d;
}

.has-warning .help-block,
.has-warning .control-label,
.has-warning .radio,
.has-warning .checkbox,
.has-warning .radio-inline,
.has-warning .checkbox-inline,
.has-warning.radio label,
.has-warning.checkbox label,
.has-warning.radio-inline label,
.has-warning.checkbox-inline label {
  color: #8a6d3b;
}

.has-warning .form-control {
  border-color: #8a6d3b !important;
}

.has-warning .form-control:focus {
  border-color: #66512c;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;
}

.has-warning .input-group-addon {
  color: #8a6d3b;
  border-color: #8a6d3b;
  background-color: #fcf8e3;
}

.has-warning .form-control-feedback {
  color: #8a6d3b;
}

.has-error .help-block,
.has-error .control-label,
.has-error .radio,
.has-error .checkbox,
.has-error .radio-inline,
.has-error .checkbox-inline,
.has-error.radio label,
.has-error.checkbox label,
.has-error.radio-inline label,
.has-error.checkbox-inline label {
  color: #a94442;
}

.has-error .form-control {
  border-color: #a94442 !important;
}

.has-error .select__control {
  border-color: #a94442 !important;
}

.has-no-error .form-control {
  border-color: #cccccc !important;
}

.has-error .form-control:focus {
  border-color: #843534;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;
}

.has-error .input-group-addon {
  color: #a94442;
  border-color: #a94442;
  background-color: #f2dede;
}

.has-error .form-control-feedback {
  color: #a94442;
}

.has-feedback label ~ .form-control-feedback {
  top: 30px;
}

.has-feedback label.sr-only ~ .form-control-feedback,
.has-feedback
  .bootstrap-datetimepicker-widget
  label.btn[data-action="incrementHours"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .has-feedback
  label.btn[data-action="incrementHours"]
  after
  ~ .form-control-feedback,
.has-feedback
  .bootstrap-datetimepicker-widget
  label.btn[data-action="incrementMinutes"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .has-feedback
  label.btn[data-action="incrementMinutes"]
  after
  ~ .form-control-feedback,
.has-feedback
  .bootstrap-datetimepicker-widget
  label.btn[data-action="decrementHours"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .has-feedback
  label.btn[data-action="decrementHours"]
  after
  ~ .form-control-feedback,
.has-feedback
  .bootstrap-datetimepicker-widget
  label.btn[data-action="decrementMinutes"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .has-feedback
  label.btn[data-action="decrementMinutes"]
  after
  ~ .form-control-feedback,
.has-feedback
  .bootstrap-datetimepicker-widget
  label.btn[data-action="showHours"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .has-feedback
  label.btn[data-action="showHours"]
  after
  ~ .form-control-feedback,
.has-feedback
  .bootstrap-datetimepicker-widget
  label.btn[data-action="showMinutes"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .has-feedback
  label.btn[data-action="showMinutes"]
  after
  ~ .form-control-feedback,
.has-feedback
  .bootstrap-datetimepicker-widget
  label.btn[data-action="togglePeriod"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .has-feedback
  label.btn[data-action="togglePeriod"]
  after
  ~ .form-control-feedback,
.has-feedback
  .bootstrap-datetimepicker-widget
  label.btn[data-action="clear"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .has-feedback
  label.btn[data-action="clear"]
  after
  ~ .form-control-feedback,
.has-feedback
  .bootstrap-datetimepicker-widget
  label.btn[data-action="today"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .has-feedback
  label.btn[data-action="today"]
  after
  ~ .form-control-feedback,
.has-feedback
  .bootstrap-datetimepicker-widget
  label.picker-switchafter
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .has-feedback
  label.picker-switchafter
  ~ .form-control-feedback {
  top: 0;
}

.help-block {
  display: block;
  margin-top: 5px;
  margin-bottom: 10px;
  color: #737373;
}

@media (min-width: 990px) {
  .form-inline .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle;
  }

  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }

  .form-inline .form-control-static {
    display: inline-block;
  }

  .form-inline .input-group {
    display: inline-table;
    vertical-align: middle;
  }

  .form-inline .input-group .input-group-addon,
  .form-inline .input-group .input-group-btn,
  .form-inline .input-group .form-control {
    width: auto;
  }

  .form-inline .input-group > .form-control {
    width: 100%;
  }

  .form-inline .control-label {
    margin-bottom: 0;
    vertical-align: middle;
  }

  .form-inline .radio,
  .form-inline .checkbox {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: middle;
  }

  .form-inline .radio label,
  .form-inline .checkbox label {
    padding-left: 0;
  }

  .form-inline .radio input[type="radio"],
  .form-inline .checkbox input[type="checkbox"] {
    position: relative;
    margin-left: 0;
  }

  .form-inline .has-feedback .form-control-feedback {
    top: 0;
  }
}

.form-horizontal .radio,
.form-horizontal .checkbox,
.form-horizontal .radio-inline,
.form-horizontal .checkbox-inline {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 7px;
}

.form-horizontal .radio,
.form-horizontal .checkbox {
  min-height: 32px;
}

.form-horizontal .form-group {
  margin-left: -25px;
  margin-right: -25px;
}

.form-horizontal .form-group:before,
.form-horizontal .form-group:after {
  content: " ";
  display: table;
}

.form-horizontal .form-group:after {
  clear: both;
}

@media (min-width: 990px) {
  .form-horizontal .control-label {
    text-align: right;
    margin-bottom: 0;
    padding-top: 7px;
  }
}

.form-horizontal .has-feedback .form-control-feedback {
  right: 25px;
}

@media (min-width: 990px) {
  .form-horizontal .form-group-lg .control-label {
    padding-top: 11px;
    font-size: 18px;
  }
}

@media (min-width: 990px) {
  .form-horizontal .form-group-sm .control-label {
    padding-top: 6px;
    font-size: 12px;
  }
}

.btn {
  height: 30px;
  display: inline-block;
  margin-bottom: 0;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  text-align: center;
  vertical-align: middle;
  letter-spacing: 1px;
  text-transform: uppercase;
  -ms-touch-action: manipulation;
      touch-action: manipulation;
  cursor: pointer;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  background-image: none;
  border: 2px solid transparent;
  white-space: nowrap;
  padding: 2px 15px;
  font-size: 12px;
  line-height: 1.78571;
  border-radius: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding-top: 3px;
}

.btn.btn-rounded {
  height: auto;
  line-height: 1;
  border-radius: 100px;
  padding: 15px !important;
}

.btn.btn-onlyOnHover {
  border-color: #eee;
}

.btn .caret {
  margin-top: -2px;
}

.btn .rubix-icon {
  line-height: 1;
  font-size: 18px;
}

.btn .rubix-icon ~ span {
  vertical-align: top;
}

.btn:focus,
.btn.focus,
.btn:active:focus,
.btn:active.focus,
.btn.active:focus,
.btn.active.focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

.btn:hover,
.btn:focus,
.btn.focus {
  color: #b4b7b9;
  text-decoration: none;
}

.btn:active,
.btn.active {
  outline: 0;
  background-image: none;
}

.btn.disabled,
.btn[disabled],
fieldset[disabled] .btn {
  cursor: not-allowed;
  opacity: 0.65;
  filter: alpha(opacity=65);
}

a.btn.disabled,
fieldset[disabled] a.btn {
  pointer-events: none;
}

.btn-default {
  background: #b4b7b9;
  color: white;
  border-color: #b4b7b9;
}

.btn-default.btn-outlined {
  color: #b4b7b9;
  background: none;
}

.btn-default.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}

.btn-default.btn-outlined.btn-onlyOnHover:hover,
.btn-default.btn-outlined.btn-onlyOnHover:focus,
.btn-default.btn-outlined.btn-onlyOnHover.active {
  color: white;
}

.btn-default.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}

.btn-default.btn-outlined.btn-inverse:hover,
.btn-default.btn-outlined.btn-inverse:focus,
.btn-default.btn-outlined.btn-inverse.active {
  color: #b4b7b9;
  background: white;
}

.btn-default.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-default.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-default.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #b4b7b9;
  color: white;
  border-color: #b4b7b9;
}

.btn-default.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-default.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-default.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #85898d;
  border-color: #666b6e;
}

.btn-default:focus,
.btn-default.focus,
.btn-default:hover,
.btn-default.active {
  color: white;
  background: #ced0d2;
  border-color: #ced0d2;
}

.btn-default:active,
.btn-default.active,
.btn-default[aria-expanded="true"],
.btn-default.active:hover,
.btn-default.active:focus,
.btn-default[aria-expanded="true"]:hover,
.btn-default[aria-expanded="true"]:focus,
.open > .btn-default.dropdown-toggle {
  color: white;
  background: #85898d;
  border-color: #666b6e;
  background-image: none;
}

.btn-default.dropdown-toggle + ul li.active a {
  color: white;
  background: #b4b7b9;
}

.btn-default.disabled,
.btn-default[disabled],
fieldset[disabled] .btn-default {
  pointer-events: none;
}

.btn-default .badge {
  color: #b4b7b9;
  background-color: #b4b7b9;
}

.btn-primary {
  background: #428bca;
  color: white;
  border-color: #428bca;
}

.btn-primary.btn-outlined {
  color: #428bca;
  background: none;
}

.btn-primary.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}

.btn-primary.btn-outlined.btn-onlyOnHover:hover,
.btn-primary.btn-outlined.btn-onlyOnHover:focus,
.btn-primary.btn-outlined.btn-onlyOnHover.active {
  color: white;
}

.btn-primary.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}

.btn-primary.btn-outlined.btn-inverse:hover,
.btn-primary.btn-outlined.btn-inverse:focus,
.btn-primary.btn-outlined.btn-inverse.active {
  color: #428bca;
  background: white;
}

.btn-primary.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-primary.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-primary.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #428bca;
  color: white;
  border-color: #428bca;
}

.btn-primary.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-primary.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-primary.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #275c8a;
  border-color: #193c5a;
}

.btn-primary:focus,
.btn-primary.focus,
.btn-primary:hover,
.btn-primary.active {
  color: white;
  background: #6aa3d5;
  border-color: #6aa3d5;
}

.btn-primary:active,
.btn-primary.active,
.btn-primary[aria-expanded="true"],
.btn-primary.active:hover,
.btn-primary.active:focus,
.btn-primary[aria-expanded="true"]:hover,
.btn-primary[aria-expanded="true"]:focus,
.open > .btn-primary.dropdown-toggle {
  color: white;
  background: #275c8a;
  border-color: #193c5a;
  background-image: none;
}

.btn-primary.dropdown-toggle + ul li.active a {
  color: white;
  background: #428bca;
}

.btn-primary.disabled,
.btn-primary[disabled],
fieldset[disabled] .btn-primary {
  pointer-events: none;
}

.btn-primary .badge {
  color: #428bca;
  background-color: #428bca;
}

.btn-success {
  background: #5cb85c;
  color: white;
  border-color: #5cb85c;
}

.btn-success.btn-outlined {
  color: #5cb85c;
  background: none;
}

.btn-success.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}

.btn-success.btn-outlined.btn-onlyOnHover:hover,
.btn-success.btn-outlined.btn-onlyOnHover:focus,
.btn-success.btn-outlined.btn-onlyOnHover.active {
  color: white;
}

.btn-success.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}

.btn-success.btn-outlined.btn-inverse:hover,
.btn-success.btn-outlined.btn-inverse:focus,
.btn-success.btn-outlined.btn-inverse.active {
  color: #5cb85c;
  background: white;
}

.btn-success.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-success.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-success.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #5cb85c;
  color: white;
  border-color: #5cb85c;
}

.btn-success.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-success.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-success.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #388038;
  border-color: #255625;
}

.btn-success:focus,
.btn-success.focus,
.btn-success:hover,
.btn-success.active {
  color: white;
  background: #80c780;
  border-color: #80c780;
}

.btn-success:active,
.btn-success.active,
.btn-success[aria-expanded="true"],
.btn-success.active:hover,
.btn-success.active:focus,
.btn-success[aria-expanded="true"]:hover,
.btn-success[aria-expanded="true"]:focus,
.open > .btn-success.dropdown-toggle {
  color: white;
  background: #388038;
  border-color: #255625;
  background-image: none;
}

.btn-success.dropdown-toggle + ul li.active a {
  color: white;
  background: #5cb85c;
}

.btn-success.disabled,
.btn-success[disabled],
fieldset[disabled] .btn-success {
  pointer-events: none;
}

.btn-success .badge {
  color: #5cb85c;
  background-color: #5cb85c;
}

.btn-info {
  background: #5bc0de;
  color: white;
  border-color: #5bc0de;
}

.btn-info.btn-outlined {
  color: #5bc0de;
  background: none;
}

.btn-info.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}

.btn-info.btn-outlined.btn-onlyOnHover:hover,
.btn-info.btn-outlined.btn-onlyOnHover:focus,
.btn-info.btn-outlined.btn-onlyOnHover.active {
  color: white;
}

.btn-info.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}

.btn-info.btn-outlined.btn-inverse:hover,
.btn-info.btn-outlined.btn-inverse:focus,
.btn-info.btn-outlined.btn-inverse.active {
  color: #5bc0de;
  background: white;
}

.btn-info.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-info.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-info.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #5bc0de;
  color: white;
  border-color: #5bc0de;
}

.btn-info.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-info.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-info.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #2596b8;
  border-color: #1b6d85;
}

.btn-info:focus,
.btn-info.focus,
.btn-info:hover,
.btn-info.active {
  color: white;
  background: #85d0e7;
  border-color: #85d0e7;
}

.btn-info:active,
.btn-info.active,
.btn-info[aria-expanded="true"],
.btn-info.active:hover,
.btn-info.active:focus,
.btn-info[aria-expanded="true"]:hover,
.btn-info[aria-expanded="true"]:focus,
.open > .btn-info.dropdown-toggle {
  color: white;
  background: #2596b8;
  border-color: #1b6d85;
  background-image: none;
}

.btn-info.dropdown-toggle + ul li.active a {
  color: white;
  background: #5bc0de;
}

.btn-info.disabled,
.btn-info[disabled],
fieldset[disabled] .btn-info {
  pointer-events: none;
}

.btn-info .badge {
  color: #5bc0de;
  background-color: #5bc0de;
}

.btn-warning {
  background: #f0ad4e;
  color: white;
  border-color: #f0ad4e;
}

.btn-warning.btn-outlined {
  color: #f0ad4e;
  background: none;
}

.btn-warning.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}

.btn-warning.btn-outlined.btn-onlyOnHover:hover,
.btn-warning.btn-outlined.btn-onlyOnHover:focus,
.btn-warning.btn-outlined.btn-onlyOnHover.active {
  color: white;
}

.btn-warning.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}

.btn-warning.btn-outlined.btn-inverse:hover,
.btn-warning.btn-outlined.btn-inverse:focus,
.btn-warning.btn-outlined.btn-inverse.active {
  color: #f0ad4e;
  background: white;
}

.btn-warning.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-warning.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-warning.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #f0ad4e;
  color: white;
  border-color: #f0ad4e;
}

.btn-warning.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-warning.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-warning.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #d18212;
  border-color: #985f0d;
}

.btn-warning:focus,
.btn-warning.focus,
.btn-warning:hover,
.btn-warning.active {
  color: white;
  background: #f4c37d;
  border-color: #f4c37d;
}

.btn-warning:active,
.btn-warning.active,
.btn-warning[aria-expanded="true"],
.btn-warning.active:hover,
.btn-warning.active:focus,
.btn-warning[aria-expanded="true"]:hover,
.btn-warning[aria-expanded="true"]:focus,
.open > .btn-warning.dropdown-toggle {
  color: white;
  background: #d18212;
  border-color: #985f0d;
  background-image: none;
}

.btn-warning.dropdown-toggle + ul li.active a {
  color: white;
  background: #f0ad4e;
}

.btn-warning.disabled,
.btn-warning[disabled],
fieldset[disabled] .btn-warning {
  pointer-events: none;
}

.btn-warning .badge {
  color: #f0ad4e;
  background-color: #f0ad4e;
}

.btn-danger {
  background: #d9534f;
  color: white;
  border-color: #d9534f;
}

.btn-danger.btn-outlined {
  color: #d9534f;
  background: none;
}

.btn-danger.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}

.btn-danger.btn-outlined.btn-onlyOnHover:hover,
.btn-danger.btn-outlined.btn-onlyOnHover:focus,
.btn-danger.btn-outlined.btn-onlyOnHover.active {
  color: white;
}

.btn-danger.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}

.btn-danger.btn-outlined.btn-inverse:hover,
.btn-danger.btn-outlined.btn-inverse:focus,
.btn-danger.btn-outlined.btn-inverse.active {
  color: #d9534f;
  background: white;
}

.btn-danger.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-danger.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-danger.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #d9534f;
  color: white;
  border-color: #d9534f;
}

.btn-danger.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-danger.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-danger.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #a82824;
  border-color: #761c19;
}

.btn-danger:focus,
.btn-danger.focus,
.btn-danger:hover,
.btn-danger.active {
  color: white;
  background: #e27c79;
  border-color: #e27c79;
}

.btn-danger:active,
.btn-danger.active,
.btn-danger[aria-expanded="true"],
.btn-danger.active:hover,
.btn-danger.active:focus,
.btn-danger[aria-expanded="true"]:hover,
.btn-danger[aria-expanded="true"]:focus,
.open > .btn-danger.dropdown-toggle {
  color: white;
  background: #a82824;
  border-color: #761c19;
  background-image: none;
}

.btn-danger.dropdown-toggle + ul li.active a {
  color: white;
  background: #d9534f;
}

.btn-danger.disabled,
.btn-danger[disabled],
fieldset[disabled] .btn-danger {
  pointer-events: none;
}

.btn-danger .badge {
  color: #d9534f;
  background-color: #d9534f;
}

.btn-link {
  color: #89949b;
  font-weight: normal;
  border-radius: 0;
}

.btn-link,
.btn-link:active,
.btn-link.active,
.btn-link[disabled],
fieldset[disabled] .btn-link {
  background-color: transparent;
}

.btn-link,
.btn-link:hover,
.btn-link:focus,
.btn-link:active {
  border-color: transparent;
}

.btn-link:hover,
.btn-link:focus {
  color: #2e6b5e;
  text-decoration: none;
  background-color: transparent;
}

.btn-link[disabled]:hover,
.btn-link[disabled]:focus,
fieldset[disabled] .btn-link:hover,
fieldset[disabled] .btn-link:focus {
  color: #777777;
  text-decoration: none;
}

.btn-lg,
.btn-group-lg > .btn {
  height: auto;
  padding: 10px 25px;
  font-size: 20px;
  line-height: initial;
  border-radius: 10px;
  line-height: 21.4285px;
  padding: 10px 25px !important;
}

.btn-lg.btn-rounded,
.btn-group-lg > .btn-rounded.btn {
  line-height: 1;
  padding: 25px;
}

.btn-sm,
.btn-group-sm > .btn {
  height: auto;
  padding: 2px 15px;
  font-size: 10px;
  line-height: 1.5;
  border-radius: 20px;
}

.btn-xs,
.btn-group-xs > .btn {
  height: auto;
  padding: 2px 15px;
  font-size: 8px;
  line-height: 1.5;
  border-radius: 20px;
}

.btn-rounded.btn.btn-sm,
.btn-group-sm > .btn-rounded.btn,
.btn-rounded.btn.btn-xs,
.btn-group-xs > .btn-rounded.btn {
  padding: 15px;
  line-height: 1;
}

.btn-block {
  display: block;
  width: 100%;
}

.btn-block + .btn-block {
  margin-top: 5px;
}

input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%;
}

.btn.btn-outlined {
  outline: none;
  background: none;
  padding: 3px 15px 2px 15px;
}

.btn.btn-outlined:hover,
.btn.btn-outlined:focus {
  outline: none;
}

.btn.btn-icon {
  line-height: 0;
  font-size: 30px;
  min-width: 45px;
  min-height: 45px;
  border-radius: 100px;
  width: auto !important;
  height: auto !important;
  padding: 5px 10px !important;
}

.fade {
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}

.fade.in {
  opacity: 1;
}

.collapse {
  display: none;
}

.collapse.in {
  display: block;
}

tr.collapse.in {
  display: table-row;
}

tbody.collapse.in {
  display: table-row-group;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  -webkit-transition-property: height, visibility;
  transition-property: height, visibility;
  -webkit-transition-duration: 0.35s;
  transition-duration: 0.35s;
  -webkit-transition-timing-function: ease;
  transition-timing-function: ease;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \\9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.dropup,
.dropdown {
  position: relative;
  width: 100%;
}

.dropdown-toggle:focus {
  outline: 0;
}

.dropdown-menu {
  position: absolute;
  /* top: 100%; */
  bottom: 40px;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  /* min-width: 200px; */
  padding: 10px 0;
  overflow: hidden;
  margin: 2px 0 0;
  list-style: none;
  font-size: 14px;
  text-align: left;
  background-color: #fff;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;
  /* margin-top: -300px !important; */
  width: 100px;
  position: absolute;
  margin-left: 10px !important;
}

.dropdown-menu.pull-right {
  right: 0;
  left: auto;
}

.dropdown-menu .divider {
  height: 1px;
  margin: 11.5px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}

.dropdown-menu li > a {
  display: block;
  padding: 4px 25px;
  clear: both;
  border: none;
  font-weight: normal;
  line-height: 1.78571;
  color: #89949b;
  white-space: pre-line;
}

.dropdown-menu li > a:hover,
.dropdown-menu li > a:focus {
  text-decoration: none;
  color: #262626;
  background-color: rgba(180, 183, 185, 0.05);
}

.dropdown-menu .active > a,
.dropdown-menu .active > a:hover,
.dropdown-menu .active > a:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  background-color: #428bca;
}

.dropdown-menu .disabled > a,
.dropdown-menu .disabled > a:hover,
.dropdown-menu .disabled > a:focus {
  color: #777777;
}

.dropdown-menu .disabled > a:hover,
.dropdown-menu .disabled > a:focus {
  text-decoration: none;
  background-color: transparent;
  background-image: none;
  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
  cursor: not-allowed;
}

.open > .dropdown-menu {
  display: block;
}

.open > a {
  outline: 0;
}

.dropdown-menu-right {
  left: auto;
  right: 0;
}

.dropdown-menu-left {
  left: 0;
  right: auto;
}

.dropdown-header {
  display: block;
  padding: 6px 25px;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: bold;
  color: #98a0a3;
  line-height: 1.78571;
  color: #777777;
  white-space: nowrap;
  background-color: #f9fafb;
  border-bottom: 1px solid #f2f2f2;
}

.dropdown-header:first-child {
  margin-top: -10px;
}

.dropdown-backdrop {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 990;
}

.pull-right > .dropdown-menu {
  right: 0;
  left: auto;
}

.dropup .caret,
.navbar-fixed-bottom .dropdown .caret {
  border-top: 0;
  border-bottom: 4px dashed;
  border-bottom: 4px solid \\9;
  content: "";
}

.dropup .dropdown-menu,
.navbar-fixed-bottom .dropdown .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-bottom: 2px;
}

@media (min-width: 990px) {
  .navbar-right .dropdown-menu {
    right: 0;
    left: auto;
  }

  .navbar-right .dropdown-menu-left {
    left: 0;
    right: auto;
  }
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.btn-group > .btn,
.btn-group > rubix-button > .btn,
.btn-group-vertical > .btn,
.btn-group-vertical > rubix-button > .btn {
  position: relative;
  float: left;
}

.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group > rubix-button > .btn:hover,
.btn-group > rubix-button > .btn:focus,
.btn-group > rubix-button > .btn:active,
.btn-group > rubix-button > .btn.active,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active,
.btn-group-vertical > rubix-button > .btn:hover,
.btn-group-vertical > rubix-button > .btn:focus,
.btn-group-vertical > rubix-button > .btn:active,
.btn-group-vertical > rubix-button > .btn.active {
  z-index: 2;
}

.btn-group .btn + .btn,
.btn-group .btn + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .btn-group + .btn-group {
  margin-left: -1px;
}

.btn-toolbar {
  position: relative;
  margin-left: -12.5px;
}

.btn-toolbar:before,
.btn-toolbar:after {
  content: " ";
  display: table;
}

.btn-toolbar:after {
  clear: both;
}

.btn-toolbar > .btn,
.btn-toolbar > .btn-group,
.btn-toolbar > .input-group,
.btn-toolbar > rubix-menu,
.btn-toolbar > rubix-button > .btn,
.btn-toolbar > rubix-button-group {
  float: left;
  margin-left: 12.5px;
}

.btn-group > rubix-button {
  float: left;
}

.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle),
.btn-group > rubix-button:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}

.btn-group > .btn:first-child {
  margin-left: 0;
}

.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.btn-group > rubix-button:first-child:not(:last-child) > .btn {
  margin-left: 0;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.btn-group > .btn:last-child:not(:first-child),
.btn-group > rubix-button:last-child:not(:first-child) > .btn,
.btn-group > .dropdown-toggle:not(:first-child) {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.btn-group > .btn-group,
.btn-group > rubix-menu {
  float: left;
}

.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn,
.btn-group > rubix-menu:not(:first-child):not(:last-child) .btn {
  border-radius: 0;
}

.btn-group > .btn-group:first-child:not(:last-child) > .btn:last-child,
.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle,
.btn-group > rubix-menu:first-child:not(:last-child) > .btn:last-child,
.btn-group > rubix-menu:first-child:not(:last-child) > .dropdown-toggle {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child,
.btn-group > rubix-menu:last-child:not(:first-child) .btn:first-child {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.btn-group .dropdown-toggle:active,
.btn-group.open .dropdown-toggle {
  outline: 0;
}

.btn-group > .btn + .dropdown-toggle {
  padding-left: 8px;
  padding-right: 8px;
}

.btn-group > .btn-lg + .dropdown-toggle,
.btn-group-lg.btn-group > .btn + .dropdown-toggle {
  padding-left: 12px;
  padding-right: 12px;
}

.btn-group.open .dropdown-toggle {
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

.btn-group.open .dropdown-toggle.btn-link {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.dropdown > .btn:after,
.dropdown > .dropdown-toggle:after {
  content: " ";
  left: 0;
  width: 100%;
  height: 10px;
  bottom: -10px;
  position: absolute;
}

.dropup > .btn:after,
.dropup > .dropdown-toggle:after {
  content: " ";
  left: 0;
  top: -10px;
  width: 100%;
  height: 10px;
  bottom: auto;
  position: absolute;
}

.btn .caret {
  margin-left: 0;
}

.btn-lg .caret,
.btn-group-lg > .btn .caret {
  border-width: 5px 5px 0;
  border-bottom-width: 0;
}

.dropup .btn-lg .caret,
.dropup .btn-group-lg > .btn .caret {
  border-width: 0 5px 5px;
}

.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group,
.btn-group-vertical > .btn-group > .btn,
.btn-group-vertical > rubix-button > .btn {
  display: block;
  float: none;
  width: 100%;
  max-width: 100%;
}

.btn-group-vertical > .btn-group:before,
.btn-group-vertical > .btn-group:after,
.btn-group-vertical > rubix-menu:before,
.btn-group-vertical > rubix-menu:after {
  content: " ";
  display: table;
}

.btn-group-vertical > .btn-group:after,
.btn-group-vertical > rubix-menu:after {
  clear: both;
}

.btn-group-vertical > .btn-group > .btn,
.btn-group-vertical > rubix-menu > .btn {
  float: none;
}

.btn-group-vertical > .btn + .btn,
.btn-group-vertical > rubix-button + rubix-button,
.btn-group-vertical > .btn + .btn-group,
.btn-group-vertical > rubix-button + rubix-menu,
.btn-group-vertical > .btn-group + .btn,
.btn-group-vertical > rubix-menu + rubix-button,
.btn-group-vertical > .btn-group + .btn-group,
.btn-group-vertical > rubix-menu + rubix-menu {
  margin-top: -1px;
  margin-left: 0;
}

.btn-group-vertical > .btn:not(:first-child):not(:last-child) {
  border-radius: 0;
}

.btn-group-vertical > .btn:first-child:not(:last-child) {
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn:last-child:not(:first-child) {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}

.btn-group-vertical > rubix-button:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}

.btn-group-vertical > rubix-button:first-child:not(:last-child) > .btn {
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > rubix-button:last-child:not(:first-child) > .btn {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}

.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn,
.btn-group-vertical > rubix-menu:not(:first-child):not(:last-child) .btn {
  border-radius: 0;
}

.btn-group-vertical > .btn-group:first-child:not(:last-child) .btn:last-child,
.btn-group-vertical > .btn-group:first-child:not(:last-child) .dropdown-toggle,
.btn-group-vertical > rubix-menu:first-child:not(:last-child) .btn:last-child,
.btn-group-vertical > rubix-menu:first-child:not(:last-child) .dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical
  > .btn-group:last-child:not(:first-child)
  > .btn:first-child,
.btn-group-vertical > rubix-menu:last-child:not(:first-child) .btn:first-child {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}

.btn-group-justified {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
}

.btn-group-justified > .btn,
.btn-group-justified > .btn-group,
.btn-group-justified > rubix-button,
.btn-group-justified > rubix-menu {
  float: none;
  display: table-cell;
  width: 1%;
}

.btn-group-justified > .btn-group .btn,
.btn-group-justified > rubix-menu .btn,
.btn-group-justified > rubix-menu .dropdown,
.btn-group-justified > rubix-button .btn {
  width: 100%;
}

.btn-group-justified > .btn-group .dropdown-menu,
.btn-group-justified > rubix-menu .dropdown-menu {
  left: auto;
}

[data-toggle="buttons"] > .btn input[type="radio"],
[data-toggle="buttons"] > .btn input[type="checkbox"],
[data-toggle="buttons"] > .btn-group > .btn input[type="radio"],
[data-toggle="buttons"] > .btn-group > .btn input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: table;
  border-collapse: separate;
}

.input-group[class*="col-"] {
  float: none;
  padding-left: 0;
  padding-right: 0;
}

.input-group .form-control {
  position: relative;
  z-index: 2;
  float: left;
  width: 100%;
  margin-bottom: 0;
}

.input-group .form-control:focus {
  z-index: 3;
}

.input-group-addon,
.input-group-btn,
.input-group .form-control {
  display: table-cell;
}

.input-group-addon:not(:first-child):not(:last-child),
.input-group-btn:not(:first-child):not(:last-child),
.input-group .form-control:not(:first-child):not(:last-child) {
  border-radius: 0;
}

.input-group-addon,
.input-group-btn {
  width: 1%;
  white-space: nowrap;
  vertical-align: middle;
}

.input-group-addon {
  padding: 6px 12px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1;
  color: #555555;
  text-align: center;
  background-color: #eeeeee;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.input-group-addon.input-sm,
.input-group-sm > .input-group-addon,
.input-group-sm > .input-group-btn > .input-group-addon.btn {
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 3px;
}

.input-group-addon.input-lg,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .input-group-addon.btn {
  padding: 10px 16px;
  font-size: 18px;
  border-radius: 6px;
}

.input-group-addon input[type="radio"],
.input-group-addon input[type="checkbox"] {
  margin-top: 0;
}

.input-group-btn .btn-group > .btn {
  margin-left: -2px;
}

.input-group-btn + .form-control {
  margin-left: -2px;
}

.input-group .form-control:first-child,
.input-group-addon:first-child,
.input-group-btn:first-child .btn,
.input-group-btn:first-child .btn-group > .btn,
.input-group-btn:first-child rubix-menu > .btn-group > .btn,
.input-group-btn:first-child .dropdown-toggle,
.input-group-btn:last-child .btn:not(:last-child):not(.dropdown-toggle),
.input-group-btn:last-child
  rubix-button:not(:last-child)
  .btn:not(.dropdown-toggle),
.input-group-btn:last-child .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.input-group-addon:first-child {
  border-right: 0;
}

.input-group .form-control:last-child,
.input-group-addon:last-child,
.input-group-btn:last-child .btn,
.input-group-btn:last-child .btn-group > .btn,
.input-group-btn:last-child rubix-menu > .btn-group > .btn,
.input-group-btn:last-child .dropdown-toggle,
.input-group-btn:first-child .btn:not(:first-child),
.input-group-btn:first-child rubix-button:not(:first-child) .btn,
.input-group-btn:first-child .btn-group:not(:first-child) > .btn {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.input-group-addon:last-child {
  border-left: 0;
}

.input-group-btn {
  position: relative;
  font-size: 0;
  white-space: nowrap;
}

.input-group-btn > .btn {
  position: relative;
}

.input-group-btn > .btn + .btn {
  margin-left: -1px;
}

.input-group-btn > .btn:hover,
.input-group-btn > .btn:focus,
.input-group-btn > .btn:active {
  z-index: 2;
}

.input-group-btn > rubix-button > .btn {
  position: relative;
}

.input-group-btn > rubix-button > .btn:hover,
.input-group-btn > rubix-button > .btn:focus,
.input-group-btn > rubix-button > .btn:active {
  z-index: 2;
}

.input-group-btn > rubix-button + rubix-button > .btn {
  margin-left: -1px;
}

.input-group-btn:first-child > .btn,
.input-group-btn:first-child > .btn-group {
  margin-right: -1px;
}

.input-group-btn:last-child > .btn,
.input-group-btn:last-child > .btn-group {
  z-index: 2;
  margin-left: -1px;
}

.nav {
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
}

.nav:before,
.nav:after {
  content: " ";
  display: table;
}

.nav:after {
  clear: both;
}

.nav > li,
.nav > rubix-nav-item > li,
.nav > rubix-menu > li {
  position: relative;
  display: block;
}

.nav > li > a,
.nav > rubix-nav-item > li > a,
.nav > rubix-menu > li > a {
  position: relative;
  display: block;
  padding: 4px 25px;
  color: #aaa;
}

.nav > li > a:hover,
.nav > li > a:focus,
.nav > rubix-nav-item > li > a:hover,
.nav > rubix-nav-item > li > a:focus,
.nav > rubix-menu > li > a:hover,
.nav > rubix-menu > li > a:focus {
  text-decoration: none;
  background-color: #f5f5f5;
}

.nav > li.disabled > a,
.nav > rubix-nav-item > li.disabled > a,
.nav > rubix-menu > li.disabled > a {
  color: rgba(119, 119, 119, 0.3);
  border-top: none;
  border-left: none;
  border-right: none;
}

.nav > li.disabled > a:hover,
.nav > li.disabled > a:focus,
.nav > rubix-nav-item > li.disabled > a:hover,
.nav > rubix-nav-item > li.disabled > a:focus,
.nav > rubix-menu > li.disabled > a:hover,
.nav > rubix-menu > li.disabled > a:focus {
  color: rgba(119, 119, 119, 0.3);
  text-decoration: none;
  background-color: transparent;
  cursor: not-allowed;
}

.nav .open > a,
.nav .open > a:hover,
.nav .open > a:focus {
  color: #333;
  background-color: #f5f5f5;
}

.nav .nav-divider {
  height: 1px;
  margin: 11.5px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}

.nav > li > a > img,
.nav > rubix-menu > a > img,
.nav > rubix-nav-item > a > img {
  max-width: none;
}

.nav-tabs {
  border-bottom: 1px solid #ddd;
}

.nav-tabs > li,
.nav-tabs > rubix-menu > li,
.nav-tabs > rubix-nav-item > li {
  float: left;
  margin-bottom: -1px;
}

.nav-tabs > li > a,
.nav-tabs > rubix-menu > li > a,
.nav-tabs > rubix-nav-item > li > a {
  margin-right: 2px;
  text-align: center;
  line-height: 1.78571;
  border: 1px solid transparent;
  border-radius: 4px 4px 0 0;
}

.nav-tabs > li > a:hover,
.nav-tabs > rubix-menu > li > a:hover,
.nav-tabs > rubix-nav-item > li > a:hover {
  border-color: #f5f5f5 #f5f5f5 #ddd;
}

.nav-tabs > li.disabled > a:hover,
.nav-tabs > rubix-menu > li.disabled > a:hover,
.nav-tabs > rubix-nav-item > li.disabled > a:hover {
  border-bottom-width: 0px;
}

.nav-tabs > li.active > a,
.nav-tabs > rubix-menu > li.active > a,
.nav-tabs > rubix-nav-item > li.active > a {
  color: #555555;
  background-color: #fff;
  border: 1px solid #ddd;
  border-bottom-color: transparent;
  cursor: default;
}

.nav-pills > li,
.nav-pills > rubix-nav-item > li,
.nav-pills > rubix-menu > li {
  float: left;
}

.nav-pills > li > a,
.nav-pills > rubix-nav-item > li > a,
.nav-pills > rubix-menu > li > a {
  border-radius: 4px;
}

.nav-pills > li + li,
.nav-pills > rubix-nav-item > li + li,
.nav-pills > rubix-menu > li + li {
  margin-left: 2px;
}

.nav-pills > li.active > a,
.nav-pills > rubix-nav-item > li.active > a,
.nav-pills > rubix-menu > li.active > a {
  color: #fff;
  background-color: #428bca;
}

.nav-stacked > li,
.nav-stacked > rubix-nav-item > li,
.nav-stacked > rubix-menu > li {
  float: none;
}

.nav-stacked > li + li,
.nav-stacked > rubix-nav-item > li + li,
.nav-stacked > rubix-menu > li + li {
  margin-top: 2px;
  margin-left: 0;
}

.nav-justified,
.nav-tabs.nav-justified {
  width: 100%;
}

.nav-justified > li,
.nav-tabs.nav-justified > li {
  float: none;
}

.nav-justified > rubix-menu > a,
.nav-tabs.nav-justified > rubix-menu > a,
.nav-justified > rubix-menu > li > a,
.nav-tabs.nav-justified > rubix-menu > li > a,
.nav-justified > rubix-nav-item > a,
.nav-tabs.nav-justified > rubix-nav-item > a,
.nav-justified > rubix-nav-item > li > a,
.nav-tabs.nav-justified > rubix-nav-item > li > a,
.nav-justified > li > a,
.nav-tabs.nav-justified > li > a,
.nav-justified > li > li > a,
.nav-tabs.nav-justified > li > li > a {
  text-align: center;
  margin-bottom: 5px;
  border-bottom-width: 0px;
}

.nav-justified > rubix-menu,
.nav-tabs.nav-justified > rubix-menu,
.nav-justified > rubix-nav-item,
.nav-tabs.nav-justified > rubix-nav-item {
  display: block;
  width: auto;
}

.nav-justified > rubix-menu > li,
.nav-tabs.nav-justified > rubix-menu > li,
.nav-justified > rubix-nav-item > li,
.nav-tabs.nav-justified > rubix-nav-item > li {
  width: 100%;
}

.nav-justified > .dropdown .dropdown-menu {
  top: auto;
  left: auto;
}

@media (min-width: 990px) {
  .nav-justified > rubix-menu,
  .nav-tabs.nav-justified > rubix-menu,
  .nav-justified > rubix-nav-item,
  .nav-tabs.nav-justified > rubix-nav-item {
    display: table-cell;
    width: 1%;
  }

  .nav-justified > rubix-menu > li,
  .nav-tabs.nav-justified > rubix-menu > li,
  .nav-justified > rubix-nav-item > li,
  .nav-tabs.nav-justified > rubix-nav-item > li {
    width: 100%;
  }

  .nav-justified > rubix-menu > li.disabled > a:hover,
  .nav-justified > rubix-nav-item > li.disabled > a:hover {
    border-bottom-width: 1px;
  }

  .nav-justified > li a:hover {
    border-bottom-width: 1px;
  }

  .nav-justified > li.disabled > a:hover {
    border-bottom-width: 1px;
  }

  .nav-justified > li,
  .nav-tabs.nav-justified > li,
  .nav-justified > rubix-menu,
  .nav-tabs.nav-justified > rubix-menu,
  .nav-justified > rubix-nav-item,
  .nav-tabs.nav-justified > rubix-nav-item {
    display: table-cell;
    width: 1%;
  }

  .nav-justified > li > a,
  .nav-tabs.nav-justified > li > a,
  .nav-justified > li > li > a,
  .nav-tabs.nav-justified > li > li > a,
  .nav-justified > rubix-menu > a,
  .nav-tabs.nav-justified > rubix-menu > a,
  .nav-justified > rubix-menu > li > a,
  .nav-tabs.nav-justified > rubix-menu > li > a,
  .nav-justified > rubix-nav-item > a,
  .nav-tabs.nav-justified > rubix-nav-item > a,
  .nav-justified > rubix-nav-item > li > a,
  .nav-tabs.nav-justified > rubix-nav-item > li > a {
    margin-bottom: 0;
  }
}

.nav-tabs-justified,
.nav-tabs.nav-justified {
  border-bottom: 0;
}

.nav-tabs-justified > li > a,
.nav-tabs.nav-justified > li > a,
.nav-tabs-justified > rubix-nav-item > li > a,
.nav-tabs.nav-justified > rubix-nav-item > li > a,
.nav-tabs-justified > rubix-menu > li > a,
.nav-tabs.nav-justified > rubix-menu > li > a {
  margin-right: 0;
  border-radius: 4px;
}

.nav-tabs-justified > .active > a,
.nav-tabs.nav-justified > .active > a,
.nav-tabs-justified > .active > a:hover,
.nav-tabs.nav-justified > .active > a:hover,
.nav-tabs-justified > .active > a:focus,
.nav-tabs.nav-justified > .active > a:focus,
.nav-tabs-justified > rubix-menu .active > a,
.nav-tabs.nav-justified > rubix-menu .active > a,
.nav-tabs-justified > rubix-menu .active > a:hover,
.nav-tabs.nav-justified > rubix-menu .active > a:hover,
.nav-tabs-justified > rubix-menu .active > a:focus,
.nav-tabs.nav-justified > rubix-menu .active > a:focus,
.nav-tabs-justified > rubix-nav-item .active > a,
.nav-tabs.nav-justified > rubix-nav-item .active > a,
.nav-tabs-justified > rubix-nav-item .active > a:hover,
.nav-tabs.nav-justified > rubix-nav-item .active > a:hover,
.nav-tabs-justified > rubix-nav-item .active > a:focus,
.nav-tabs.nav-justified > rubix-nav-item .active > a:focus {
  border: 1px solid #ddd;
}

@media (min-width: 990px) {
  .nav-tabs-justified > li > a,
  .nav-tabs.nav-justified > li > a,
  .nav-tabs-justified > rubix-nav-item > li > a,
  .nav-tabs.nav-justified > rubix-nav-item > li > a,
  .nav-tabs-justified > rubix-menu > li > a,
  .nav-tabs.nav-justified > rubix-menu > li > a {
    border-bottom: 1px solid #ddd;
    border-radius: 4px 4px 0 0;
  }

  .nav-tabs-justified > rubix-menu .active > a,
  .nav-tabs.nav-justified > rubix-menu .active > a,
  .nav-tabs-justified > rubix-menu .active > a:hover,
  .nav-tabs.nav-justified > rubix-menu .active > a:hover,
  .nav-tabs-justified > rubix-menu .active > a:focus,
  .nav-tabs.nav-justified > rubix-menu .active > a:focus,
  .nav-tabs-justified > rubix-nav-item .active > a,
  .nav-tabs.nav-justified > rubix-nav-item .active > a,
  .nav-tabs-justified > rubix-nav-item .active > a:hover,
  .nav-tabs.nav-justified > rubix-nav-item .active > a:hover,
  .nav-tabs-justified > rubix-nav-item .active > a:focus,
  .nav-tabs.nav-justified > rubix-nav-item .active > a:focus {
    border-bottom-color: #fff;
  }
}

.tab-content > .tab-pane,
.tab-content rubix-tab-pane > .tab-pane {
  display: none;
}

.tab-content > .active,
.tab-content rubix-tab-pane > .active {
  display: block;
}

.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}

.navbar {
  position: relative;
  min-height: 75px;
  margin-bottom: 25px;
  border: 1px solid transparent;
}

.navbar:before,
.navbar:after {
  content: " ";
  display: table;
}

.navbar:after {
  clear: both;
}

@media (min-width: 990px) {
  .navbar {
    border-radius: 4px;
  }
}

.navbar-header:before,
.navbar-header:after {
  content: " ";
  display: table;
}

.navbar-header:after {
  clear: both;
}

@media (min-width: 990px) {
  .navbar-header {
    float: left;
  }
}

.navbar-collapse {
  overflow-x: visible;
  padding-right: 25px;
  padding-left: 25px;
  border-top: 1px solid transparent;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
  -webkit-overflow-scrolling: touch;
}

.navbar-collapse:before,
.navbar-collapse:after {
  content: " ";
  display: table;
}

.navbar-collapse:after {
  clear: both;
}

.navbar-collapse.in {
  overflow-y: auto;
}

@media (min-width: 990px) {
  .navbar-collapse {
    width: auto;
    border-top: 0;
    -webkit-box-shadow: none;
            box-shadow: none;
  }

  .navbar-collapse.collapse {
    display: block !important;
    height: auto !important;
    padding-bottom: 0;
    overflow: visible !important;
  }

  .navbar-collapse.in {
    overflow-y: visible;
  }

  .navbar-fixed-top .navbar-collapse,
  .navbar-static-top .navbar-collapse,
  .navbar-fixed-bottom .navbar-collapse {
    padding-left: 0;
    padding-right: 0;
  }
}

.navbar-fixed-top .navbar-collapse,
.navbar-fixed-bottom .navbar-collapse {
  max-height: 340px;
}

@media (max-device-width: 480px) and (orientation: landscape) {
  .navbar-fixed-top .navbar-collapse,
  .navbar-fixed-bottom .navbar-collapse {
    max-height: 200px;
  }
}

.container .navbar-header,
.container .navbar-collapse,
.container-fluid .navbar-header,
.container-fluid .navbar-collapse {
  margin-right: -25px;
  margin-left: -25px;
}

@media (min-width: 990px) {
  .container .navbar-header,
  .container .navbar-collapse,
  .container-fluid .navbar-header,
  .container-fluid .navbar-collapse {
    margin-right: 0;
    margin-left: 0;
  }
}

.navbar-static-top {
  z-index: 1000;
  border-width: 0 0 1px;
}

@media (min-width: 990px) {
  .navbar-static-top {
    border-radius: 0;
  }
}

.navbar-fixed-top,
.navbar-fixed-bottom {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1030;
}

@media (min-width: 990px) {
  .navbar-fixed-top,
  .navbar-fixed-bottom {
    border-radius: 0;
  }
}

.navbar-fixed-top {
  top: 0;
  border-width: 0 0 1px;
}

.navbar-fixed-bottom {
  bottom: 0;
  margin-bottom: 0;
  border-width: 1px 0 0;
}

.navbar-brand {
  float: left;
  padding: 25px 25px;
  font-size: 18px;
  line-height: 25px;
  height: 75px;
}

.navbar-brand:hover,
.navbar-brand:focus {
  text-decoration: none;
}

.navbar-brand > img {
  display: block;
}

@media (min-width: 990px) {
  .navbar > .container .navbar-brand,
  .navbar > .container-fluid .navbar-brand {
    margin-left: -25px;
  }
}

.navbar-toggle {
  position: relative;
  float: right;
  margin-right: 25px;
  padding: 9px 10px;
  margin-top: 20.5px;
  margin-bottom: 20.5px;
  background-color: transparent;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}

.navbar-toggle:focus {
  outline: 0;
}

.navbar-toggle .icon-bar {
  display: block;
  width: 22px;
  height: 2px;
  border-radius: 1px;
}

.navbar-toggle .icon-bar + .icon-bar {
  margin-top: 4px;
}

@media (min-width: 990px) {
  .navbar-toggle {
    display: none;
  }
}

.navbar-nav {
  margin: 12.5px -25px;
}

.navbar-nav > li > a,
.navbar-nav > rubix-menu > li > a,
.navbar-nav > rubix-nav-item > li > a {
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 25px;
}

@media (max-width: 989px) {
  .navbar-nav .open .dropdown-menu {
    position: static;
    float: none;
    width: auto;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    -webkit-box-shadow: none;
            box-shadow: none;
  }

  .navbar-nav .open .dropdown-menu > li > a,
  .navbar-nav .open .dropdown-menu .dropdown-header {
    padding: 5px 15px 5px 25px;
  }

  .navbar-nav .open .dropdown-menu > li > a {
    line-height: 25px;
  }

  .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-nav .open .dropdown-menu > li > a:focus {
    background-image: none;
  }
}

@media (min-width: 990px) {
  .navbar-nav {
    float: left;
    margin: 0;
  }

  .navbar-nav > li,
  .navbar-nav > rubix-menu,
  .navbar-nav > rubix-nav-item {
    float: left;
  }

  .navbar-nav > li > a,
  .navbar-nav > li > li > a,
  .navbar-nav > rubix-menu > a,
  .navbar-nav > rubix-menu > li > a,
  .navbar-nav > rubix-nav-item > a,
  .navbar-nav > rubix-nav-item > li > a {
    padding-top: 25px;
    padding-bottom: 25px;
  }
}

.navbar-form {
  margin-left: -25px;
  margin-right: -25px;
  padding: 10px 25px;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1),
    0 1px 0 rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1),
    0 1px 0 rgba(255, 255, 255, 0.1);
  margin-top: 23px;
  margin-bottom: 23px;
}

@media (min-width: 990px) {
  .navbar-form .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle;
  }

  .navbar-form .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }

  .navbar-form .form-control-static {
    display: inline-block;
  }

  .navbar-form .input-group {
    display: inline-table;
    vertical-align: middle;
  }

  .navbar-form .input-group .input-group-addon,
  .navbar-form .input-group .input-group-btn,
  .navbar-form .input-group .form-control {
    width: auto;
  }

  .navbar-form .input-group > .form-control {
    width: 100%;
  }

  .navbar-form .control-label {
    margin-bottom: 0;
    vertical-align: middle;
  }

  .navbar-form .radio,
  .navbar-form .checkbox {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: middle;
  }

  .navbar-form .radio label,
  .navbar-form .checkbox label {
    padding-left: 0;
  }

  .navbar-form .radio input[type="radio"],
  .navbar-form .checkbox input[type="checkbox"] {
    position: relative;
    margin-left: 0;
  }

  .navbar-form .has-feedback .form-control-feedback {
    top: 0;
  }
}

@media (max-width: 989px) {
  .navbar-form .form-group {
    margin-bottom: 5px;
  }

  .navbar-form .form-group:last-child {
    margin-bottom: 0;
  }
}

@media (min-width: 990px) {
  .navbar-form {
    width: auto;
    border: 0;
    margin-left: 0;
    margin-right: 0;
    padding-top: 0;
    padding-bottom: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
}

.navbar-nav > li > .dropdown-menu {
  margin-top: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-radius: 10px;
  -webkit-box-shadow: 0px 5px 5px rgb(0 0 0 / 25%);
          box-shadow: 0px 5px 5px rgb(0 0 0 / 25%);
}

.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {
  margin-bottom: 0;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.navbar-btn {
  margin-top: 23px;
}

.navbar-btn.btn-sm,
.btn-group-sm > .navbar-btn.btn {
  margin-top: 27px;
}

.navbar-btn.btn-xs,
.btn-group-xs > .navbar-btn.btn {
  margin-top: 29px;
}

.navbar-text {
  margin-top: 25px;
  margin-bottom: 25px;
}

@media (min-width: 990px) {
  .navbar-text {
    float: left;
    margin-left: 25px;
    margin-right: 25px;
  }
}

@media (min-width: 990px) {
  .navbar-left {
    float: left !important;
  }

  .navbar-right {
    float: right !important;
    margin-right: -25px;
  }

  .navbar-right ~ .navbar-right {
    margin-right: 0;
  }
}

.navbar-default {
  background-color: #fff;
  border-color: #eeeeee;
}

.navbar-default .navbar-brand {
  color: #777;
}

.navbar-default .navbar-brand:hover,
.navbar-default .navbar-brand:focus {
  color: #5e5e5e;
  background-color: transparent;
}

.navbar-default .navbar-text {
  color: #777;
}

.navbar-default .navbar-nav > li > a,
.navbar-default .navbar-nav > rubix-menu > li > a,
.navbar-default .navbar-nav > rubix-nav-item > li > a {
  color: #777;
}

.navbar-default .navbar-nav > li > a:hover,
.navbar-default .navbar-nav > li > a:focus,
.navbar-default .navbar-nav > rubix-menu > li > a:hover,
.navbar-default .navbar-nav > rubix-menu > li > a:focus,
.navbar-default .navbar-nav > rubix-nav-item > li > a:hover,
.navbar-default .navbar-nav > rubix-nav-item > li > a:focus {
  color: #333;
  background-color: transparent;
}

.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:hover,
.navbar-default .navbar-nav > .active > a:focus,
.navbar-default .navbar-nav > rubix-menu > .active > a,
.navbar-default .navbar-nav > rubix-menu > .active > a:hover,
.navbar-default .navbar-nav > rubix-menu > .active > a:focus,
.navbar-default .navbar-nav > rubix-nav-item > .active > a,
.navbar-default .navbar-nav > rubix-nav-item > .active > a:hover,
.navbar-default .navbar-nav > rubix-nav-item > .active > a:focus {
  color: #555;
  background-color: #eeeeee;
}

.navbar-default .navbar-nav > .disabled > a,
.navbar-default .navbar-nav > .disabled > a:hover,
.navbar-default .navbar-nav > .disabled > a:focus,
.navbar-default .navbar-nav > rubix-menu > .disabled > a,
.navbar-default .navbar-nav > rubix-menu > .disabled > a:hover,
.navbar-default .navbar-nav > rubix-menu > .disabled > a:focus,
.navbar-default .navbar-nav > rubix-nav-item > .disabled > a,
.navbar-default .navbar-nav > rubix-nav-item > .disabled > a:hover,
.navbar-default .navbar-nav > rubix-nav-item > .disabled > a:focus {
  color: #ccc;
  background-color: transparent;
}

.navbar-default .navbar-toggle {
  border-color: #ddd;
}

.navbar-default .navbar-toggle:hover,
.navbar-default .navbar-toggle:focus {
  background-color: #ddd;
}

.navbar-default .navbar-toggle .icon-bar {
  background-color: #888;
}

.navbar-default .navbar-collapse,
.navbar-default .navbar-form {
  border-color: #eeeeee;
}

.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:hover,
.navbar-default .navbar-nav > .open > a:focus,
.navbar-default .navbar-nav > rubix-menu > .open > a,
.navbar-default .navbar-nav > rubix-menu > .open > a:hover,
.navbar-default .navbar-nav > rubix-menu > .open > a:focus {
  background-color: #eeeeee;
  color: #555;
}

@media (max-width: 989px) {
  .navbar-default .navbar-nav .open .dropdown-menu > li > a,
  .navbar-default .navbar-nav .open .dropdown-menu > rubix-menu-item > li > a {
    color: #777;
  }

  .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus,
  .navbar-default
    .navbar-nav
    .open
    .dropdown-menu
    > rubix-menu-item
    > li
    > a:hover,
  .navbar-default
    .navbar-nav
    .open
    .dropdown-menu
    > rubix-menu-item
    > li
    > a:focus {
    color: #333;
    background-color: transparent;
  }

  .navbar-default .navbar-nav .open .dropdown-menu > .active > a,
  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus,
  .navbar-default
    .navbar-nav
    .open
    .dropdown-menu
    > rubix-menu-item
    > .active
    > a,
  .navbar-default
    .navbar-nav
    .open
    .dropdown-menu
    > rubix-menu-item
    > .active
    > a:hover,
  .navbar-default
    .navbar-nav
    .open
    .dropdown-menu
    > rubix-menu-item
    > .active
    > a:focus {
    color: #555;
    background-color: #eeeeee;
  }

  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a,
  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus,
  .navbar-default
    .navbar-nav
    .open
    .dropdown-menu
    > rubix-menu-item
    > .disabled
    > a,
  .navbar-default
    .navbar-nav
    .open
    .dropdown-menu
    > rubix-menu-item
    > .disabled
    > a:hover,
  .navbar-default
    .navbar-nav
    .open
    .dropdown-menu
    > rubix-menu-item
    > .disabled
    > a:focus {
    color: #ccc;
    background-color: transparent;
  }
}

.navbar-default .navbar-link {
  color: #777;
}

.navbar-default .navbar-link:hover {
  color: #333;
}

.navbar-default .btn-link {
  color: #777;
}

.navbar-default .btn-link:hover,
.navbar-default .btn-link:focus {
  color: #333;
}

.navbar-default .btn-link[disabled]:hover,
.navbar-default .btn-link[disabled]:focus,
fieldset[disabled] .navbar-default .btn-link:hover,
fieldset[disabled] .navbar-default .btn-link:focus {
  color: #ccc;
}

.navbar-inverse {
  background-color: #222;
  border-color: #090909;
}

.navbar-inverse .navbar-brand {
  color: #9d9d9d;
}

.navbar-inverse .navbar-brand:hover,
.navbar-inverse .navbar-brand:focus {
  color: #fff;
  background-color: transparent;
}

.navbar-inverse .navbar-text {
  color: #9d9d9d;
}

.navbar-inverse .navbar-nav > li > a,
.navbar-inverse .navbar-nav > rubix-menu > li > a,
.navbar-inverse .navbar-nav > rubix-nav-item > li > a {
  color: #9d9d9d;
}

.navbar-inverse .navbar-nav > li > a:hover,
.navbar-inverse .navbar-nav > li > a:focus,
.navbar-inverse .navbar-nav > rubix-menu > li > a:hover,
.navbar-inverse .navbar-nav > rubix-menu > li > a:focus,
.navbar-inverse .navbar-nav > rubix-nav-item > li > a:hover,
.navbar-inverse .navbar-nav > rubix-nav-item > li > a:focus {
  color: #fff;
  background-color: transparent;
}

.navbar-inverse .navbar-nav > .active > a,
.navbar-inverse .navbar-nav > .active > a:hover,
.navbar-inverse .navbar-nav > .active > a:focus,
.navbar-inverse .navbar-nav > rubix-menu > .active > a,
.navbar-inverse .navbar-nav > rubix-menu > .active > a:hover,
.navbar-inverse .navbar-nav > rubix-menu > .active > a:focus,
.navbar-inverse .navbar-nav > rubix-nav-item > .active > a,
.navbar-inverse .navbar-nav > rubix-nav-item > .active > a:hover,
.navbar-inverse .navbar-nav > rubix-nav-item > .active > a:focus {
  color: #fff;
  background-color: #090909;
}

.navbar-inverse .navbar-nav > .disabled > a,
.navbar-inverse .navbar-nav > .disabled > a:hover,
.navbar-inverse .navbar-nav > .disabled > a:focus,
.navbar-inverse .navbar-nav > rubix-menu > .disabled > a,
.navbar-inverse .navbar-nav > rubix-menu > .disabled > a:hover,
.navbar-inverse .navbar-nav > rubix-menu > .disabled > a:focus,
.navbar-inverse .navbar-nav > rubix-nav-item > .disabled > a,
.navbar-inverse .navbar-nav > rubix-nav-item > .disabled > a:hover,
.navbar-inverse .navbar-nav > rubix-nav-item > .disabled > a:focus {
  color: #444;
  background-color: transparent;
}

.navbar-inverse .navbar-toggle {
  border-color: #333;
}

.navbar-inverse .navbar-toggle:hover,
.navbar-inverse .navbar-toggle:focus {
  background-color: #333;
}

.navbar-inverse .navbar-toggle .icon-bar {
  background-color: #fff;
}

.navbar-inverse .navbar-collapse,
.navbar-inverse .navbar-form {
  border-color: #101010;
}

.navbar-inverse .navbar-nav > .open > a,
.navbar-inverse .navbar-nav > .open > a:hover,
.navbar-inverse .navbar-nav > .open > a:focus {
  background-color: #090909;
  color: #fff;
}

@media (max-width: 989px) {
  .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {
    border-color: #090909;
  }

  .navbar-inverse .navbar-nav .open .dropdown-menu .divider {
    background-color: #090909;
  }

  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {
    color: #9d9d9d;
  }

  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {
    color: #fff;
    background-color: transparent;
  }

  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {
    color: #fff;
    background-color: #090909;
  }

  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {
    color: #444;
    background-color: transparent;
  }
}

.navbar-inverse .navbar-link {
  color: #9d9d9d;
}

.navbar-inverse .navbar-link:hover {
  color: #fff;
}

.navbar-inverse .btn-link {
  color: #9d9d9d;
}

.navbar-inverse .btn-link:hover,
.navbar-inverse .btn-link:focus {
  color: #fff;
}

.navbar-inverse .btn-link[disabled]:hover,
.navbar-inverse .btn-link[disabled]:focus,
fieldset[disabled] .navbar-inverse .btn-link:hover,
fieldset[disabled] .navbar-inverse .btn-link:focus {
  color: #444;
}

.breadcrumb {
  padding: 8px 15px;
  margin-bottom: 25px;
  list-style: none;
  background-color: #fff;
  border-radius: 4px;
}

.breadcrumb > li,
.breadcrumb > rubix-breadcrumb-item,
.breadcrumb > rubix-breadcrumb-item > li {
  display: inline-block;
}

.breadcrumb > li + li:before,
.breadcrumb > li + rubix-breadcrumb-item:before,
.breadcrumb > rubix-breadcrumb-item + li:before,
.breadcrumb > rubix-breadcrumb-item + rubix-breadcrumb-item:before,
.breadcrumb > rubix-breadcrumb-item > li + li:before,
.breadcrumb > rubix-breadcrumb-item > li + rubix-breadcrumb-item:before {
  content: "/\\A0";
  padding: 0 5px;
  padding-left: 10px;
  color: #ccc;
}

.breadcrumb > .active,
.breadcrumb > rubix-breadcrumb-item > .active {
  color: #777777;
}

.pagination {
  display: inline-block;
  padding-left: 0;
  margin: 25px 0;
  border-radius: 4px;
}

.pagination > li,
.pagination > rubix-page-item > li {
  display: inline;
}

.pagination > li > a,
.pagination > li > span,
.pagination > rubix-page-item > li > a,
.pagination > rubix-page-item > li > span {
  position: relative;
  float: left;
  padding: 6px 12px;
  line-height: 1.78571;
  text-decoration: none;
  color: #2eb398;
  background-color: #fff;
  border: 1px solid #ddd;
  margin-left: -1px;
}

.pagination > li:first-child > a,
.pagination > li:first-child > span,
.pagination > li:first-child > li > a,
.pagination > li:first-child > li > span,
.pagination > rubix-page-item:first-child > a,
.pagination > rubix-page-item:first-child > span,
.pagination > rubix-page-item:first-child > li > a,
.pagination > rubix-page-item:first-child > li > span {
  margin-left: 0;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}

.pagination > li:last-child > a,
.pagination > li:last-child > span,
.pagination > li:last-child > li > a,
.pagination > li:last-child > li > span,
.pagination > rubix-page-item:last-child > a,
.pagination > rubix-page-item:last-child > span,
.pagination > rubix-page-item:last-child > li > a,
.pagination > rubix-page-item:last-child > li > span {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}

.pagination > li > a:hover,
.pagination > li > a:focus,
.pagination > li > span:hover,
.pagination > li > span:focus,
.pagination > rubix-page-item > li > a:hover,
.pagination > rubix-page-item > li > a:focus,
.pagination > rubix-page-item > li > span:hover,
.pagination > rubix-page-item > li > span:focus {
  z-index: 2;
  color: #2e6b5e;
  background-color: #eeeeee;
  border-color: #ddd;
}

.pagination > .active > a,
.pagination > .active > a:hover,
.pagination > .active > a:focus,
.pagination > .active > span,
.pagination > .active > span:hover,
.pagination > .active > span:focus,
.pagination > rubix-page-item > .active > a,
.pagination > rubix-page-item > .active > a:hover,
.pagination > rubix-page-item > .active > a:focus,
.pagination > rubix-page-item > .active > span,
.pagination > rubix-page-item > .active > span:hover,
.pagination > rubix-page-item > .active > span:focus {
  z-index: 3;
  color: #fff;
  background-color: #428bca;
  border-color: #428bca;
  cursor: default;
}

.pagination > .disabled > span,
.pagination > .disabled > span:hover,
.pagination > .disabled > span:focus,
.pagination > .disabled > a,
.pagination > .disabled > a:hover,
.pagination > .disabled > a:focus,
.pagination > rubix-page-item .disabled > span,
.pagination > rubix-page-item .disabled > span:hover,
.pagination > rubix-page-item .disabled > span:focus,
.pagination > rubix-page-item .disabled > a,
.pagination > rubix-page-item .disabled > a:hover,
.pagination > rubix-page-item .disabled > a:focus {
  pointer-events: none;
  color: #777777;
  background-color: #fff;
  border-color: #ddd;
  cursor: not-allowed;
}

.pagination-lg > li > a,
.pagination-lg > li > span {
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33333;
}

.pagination-lg > li:first-child > a,
.pagination-lg > li:first-child > span {
  border-bottom-left-radius: 6px;
  border-top-left-radius: 6px;
}

.pagination-lg > li:last-child > a,
.pagination-lg > li:last-child > span {
  border-bottom-right-radius: 6px;
  border-top-right-radius: 6px;
}

.pagination-sm > li > a,
.pagination-sm > li > span {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.pagination-sm > li:first-child > a,
.pagination-sm > li:first-child > span {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.pagination-sm > li:last-child > a,
.pagination-sm > li:last-child > span {
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.pager {
  padding-left: 0;
  margin: 25px 0;
  list-style: none;
  text-align: center;
}

.pager:before,
.pager:after {
  content: " ";
  display: table;
}

.pager:after {
  clear: both;
}

.pager li {
  display: inline;
}

.pager li > a,
.pager li > span {
  display: inline-block;
  padding: 5px 14px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 15px;
}

.pager li > a:hover,
.pager li > a:focus {
  text-decoration: none;
  background-color: #eeeeee;
}

.pager .next > a,
.pager .next > span {
  float: right;
}

.pager .previous > a,
.pager .previous > span {
  float: left;
}

.pager .disabled > a,
.pager .disabled > a:hover,
.pager .disabled > a:focus,
.pager .disabled > span {
  color: #777777;
  background-color: #fff;
  cursor: not-allowed;
}

.label {
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}

.label:empty {
  display: none;
}

.btn .label {
  position: relative;
  top: -1px;
}

a.label:hover,
a.label:focus {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}

.label-default {
  background-color: #777777;
}

.label-default[href]:hover,
.label-default[href]:focus {
  background-color: #5e5e5e;
}

.label-primary {
  background-color: #428bca;
}

.label-primary[href]:hover,
.label-primary[href]:focus {
  background-color: #3071a9;
}

.label-success {
  background-color: #5cb85c;
}

.label-success[href]:hover,
.label-success[href]:focus {
  background-color: #449d44;
}

.label-info {
  background-color: #5bc0de;
}

.label-info[href]:hover,
.label-info[href]:focus {
  background-color: #31b0d5;
}

.label-warning {
  background-color: #f0ad4e;
}

.label-warning[href]:hover,
.label-warning[href]:focus {
  background-color: #ec971f;
}

.label-danger {
  background-color: #d9534f;
}

.label-danger[href]:hover,
.label-danger[href]:focus {
  background-color: #c9302c;
}

.badge {
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  line-height: 1;
  vertical-align: middle;
  white-space: nowrap;
  text-align: center;
  background-color: #777777;
  border-radius: 10px;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.btn-xs .badge,
.btn-group-xs > .btn .badge,
.btn-group-xs > .btn .badge {
  top: 0;
  padding: 1px 5px;
}

.list-group-item.active .badge,
.nav-pills > .active > a .badge {
  color: #2eb398;
  background-color: #fff;
}

.list-group-item .badge {
  top: 3px;
  float: right;
  position: relative;
}

.list-group-item .badge + .badge {
  margin-right: 5px;
}

.nav-pills > li > a > .badge {
  margin-left: 3px;
}

a.badge:hover,
a.badge:focus {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}

.jumbotron {
  padding-top: 30px;
  padding-bottom: 30px;
  margin-bottom: 30px;
  color: inherit;
  background-color: #eeeeee;
}

.jumbotron h1,
.jumbotron .h1 {
  color: inherit;
}

.jumbotron p {
  margin-bottom: 15px;
  font-size: 21px;
  font-weight: 200;
}

.jumbotron > hr {
  border-top-color: #d5d5d5;
}

.container .jumbotron,
.container-fluid .jumbotron {
  border-radius: 6px;
  padding-left: 25px;
  padding-right: 25px;
}

.jumbotron .container {
  max-width: 100%;
}

@media screen and (min-width: 990px) {
  .jumbotron {
    padding-top: 48px;
    padding-bottom: 48px;
  }

  .container .jumbotron,
  .container-fluid .jumbotron {
    padding-left: 60px;
    padding-right: 60px;
  }

  .jumbotron h1,
  .jumbotron .h1 {
    font-size: 63px;
  }
}

.thumbnail {
  display: block;
  padding: 4px;
  margin-bottom: 25px;
  line-height: 1.78571;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  -webkit-transition: border 0.2s ease-in-out;
  transition: border 0.2s ease-in-out;
}

.thumbnail > img,
.thumbnail a > img {
  display: block;
  max-width: 100%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}

.thumbnail .caption {
  padding: 9px;
  color: #333333;
}

a.thumbnail:hover,
a.thumbnail:focus,
a.thumbnail.active {
  border-color: #2eb398;
}

.alert {
  padding: 15px;
  margin-bottom: 25px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.alert h4 {
  margin-top: 0;
  color: inherit;
}

.alert .alert-link {
  font-weight: bold;
}

.alert > p,
.alert > ul {
  margin-bottom: 0;
}

.alert > p + p {
  margin-top: 5px;
}

.alert-dismissable,
.alert-dismissible {
  padding-right: 35px;
}

.alert-dismissable .close,
.alert-dismissible .close {
  position: relative;
  top: -2px;
  right: -21px;
  color: inherit;
}

.alert-success {
  background-color: #dff0d8;
  border-color: #d6e9c6;
  color: #3c763d;
}

.alert-success hr {
  border-top-color: #c9e2b3;
}

.alert-success .alert-link {
  color: #2b542c;
}

.alert-info {
  background-color: #d9edf7;
  border-color: #bce8f1;
  color: #31708f;
}

.alert-info hr {
  border-top-color: #a6e1ec;
}

.alert-info .alert-link {
  color: #245269;
}

.alert-warning {
  background-color: #fcf8e3;
  border-color: #faebcc;
  color: #8a6d3b;
}

.alert-warning hr {
  border-top-color: #f7e1b5;
}

.alert-warning .alert-link {
  color: #66512c;
}

.alert-danger {
  background-color: #f2dede;
  border-color: #ebccd1;
  color: #a94442;
}

.alert-danger hr {
  border-top-color: #e4b9c0;
}

.alert-danger .alert-link {
  color: #843534;
}

@-webkit-keyframes progress-bar-spatientes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}

@keyframes progress-bar-spatientes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}

.progress {
  overflow: hidden;
  height: 25px;
  margin-bottom: 25px;
  background-color: #f5f5f5;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

.progress-bar {
  float: left;
  width: 0%;
  height: 100%;
  font-size: 12px;
  line-height: 25px;
  color: #fff;
  text-align: center;
  background-color: #428bca;
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: width 0.6s ease;
  transition: width 0.6s ease;
}

.progress-spatiented .progress-bar,
.progress-bar-spatiented {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 40px 40px;
}

.progress.active .progress-bar,
.progress-bar.active {
  -webkit-animation: progress-bar-spatientes 2s linear infinite;
  animation: progress-bar-spatientes 2s linear infinite;
}

.progress-bar-success {
  background-color: #5cb85c;
}

.progress-spatiented .progress-bar-success {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
}

.progress-bar-info {
  background-color: #5bc0de;
}

.progress-spatiented .progress-bar-info {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
}

.progress-bar-warning {
  background-color: #f0ad4e;
}

.progress-spatiented .progress-bar-warning {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
}

.progress-bar-danger {
  background-color: #d9534f;
}

.progress-spatiented .progress-bar-danger {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
}

.progress-collapse-bottom {
  margin-bottom: 0;
}

.media {
  margin-top: 15px;
}

.media:first-child {
  margin-top: 0;
}

.media,
.media-body {
  zoom: 1;
  overflow: hidden;
}

.media-body {
  width: 10000px;
}

.media-object {
  display: block;
}

.media-object.img-thumbnail {
  max-width: none;
}

.media-right,
.media > .pull-right {
  padding-left: 10px;
}

.media-left,
.media > .pull-left {
  padding-right: 10px;
}

.media-left,
.media-right,
.media-body {
  display: table-cell;
  vertical-align: top;
}

.media-middle {
  vertical-align: middle;
}

.media-bottom {
  vertical-align: bottom;
}

.media-heading {
  margin-top: 0;
  margin-bottom: 5px;
}

.media-list {
  padding-left: 0;
  list-style: none;
}

.list-group {
  margin-bottom: 20px;
  padding-left: 0;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}

.list-group > .list-group-item:first-child {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.list-group > .list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.list-group > rubix-list-group-item:first-child > .list-group-item {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.list-group > rubix-list-group-item:last-child > .list-group-item {
  margin-bottom: 0;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

a.list-group-item,
button.list-group-item {
  color: #555;
}

a.list-group-item .list-group-item-heading,
button.list-group-item .list-group-item-heading {
  color: #333;
}

a.list-group-item:hover,
a.list-group-item:focus,
button.list-group-item:hover,
button.list-group-item:focus {
  text-decoration: none;
  color: #555;
  background-color: #f5f5f5;
}

button.list-group-item {
  width: 100%;
  text-align: left;
}

.list-group-item.disabled,
.list-group-item.disabled:hover,
.list-group-item.disabled:focus {
  background-color: #eeeeee;
  color: #777777;
  cursor: not-allowed;
}

.list-group-item.disabled .list-group-item-heading,
.list-group-item.disabled:hover .list-group-item-heading,
.list-group-item.disabled:focus .list-group-item-heading {
  color: inherit;
}

.list-group-item.disabled .list-group-item-text,
.list-group-item.disabled:hover .list-group-item-text,
.list-group-item.disabled:focus .list-group-item-text {
  color: #777777;
}

.list-group-item.active,
.list-group-item.active:hover,
.list-group-item.active:focus {
  z-index: 2;
  color: #fff;
  background-color: #428bca;
  border-color: #428bca;
}

.list-group-item.active .list-group-item-heading,
.list-group-item.active .list-group-item-heading > small,
.list-group-item.active .list-group-item-heading > .small,
.list-group-item.active:hover .list-group-item-heading,
.list-group-item.active:hover .list-group-item-heading > small,
.list-group-item.active:hover .list-group-item-heading > .small,
.list-group-item.active:focus .list-group-item-heading,
.list-group-item.active:focus .list-group-item-heading > small,
.list-group-item.active:focus .list-group-item-heading > .small {
  color: inherit;
}

.list-group-item.active .list-group-item-text,
.list-group-item.active:hover .list-group-item-text,
.list-group-item.active:focus .list-group-item-text {
  color: #e1edf7;
}

.list-group-item-success {
  color: #3c763d;
  background-color: #dff0d8;
}

a.list-group-item-success,
button.list-group-item-success {
  color: #3c763d;
}

a.list-group-item-success .list-group-item-heading,
button.list-group-item-success .list-group-item-heading {
  color: inherit;
}

a.list-group-item-success:hover,
a.list-group-item-success:focus,
button.list-group-item-success:hover,
button.list-group-item-success:focus {
  color: #3c763d;
  background-color: #d0e9c6;
}

a.list-group-item-success.active,
a.list-group-item-success.active:hover,
a.list-group-item-success.active:focus,
button.list-group-item-success.active,
button.list-group-item-success.active:hover,
button.list-group-item-success.active:focus {
  color: #fff;
  background-color: #3c763d;
  border-color: #3c763d;
}

.list-group-item-info {
  color: #31708f;
  background-color: #d9edf7;
}

a.list-group-item-info,
button.list-group-item-info {
  color: #31708f;
}

a.list-group-item-info .list-group-item-heading,
button.list-group-item-info .list-group-item-heading {
  color: inherit;
}

a.list-group-item-info:hover,
a.list-group-item-info:focus,
button.list-group-item-info:hover,
button.list-group-item-info:focus {
  color: #31708f;
  background-color: #c4e3f3;
}

a.list-group-item-info.active,
a.list-group-item-info.active:hover,
a.list-group-item-info.active:focus,
button.list-group-item-info.active,
button.list-group-item-info.active:hover,
button.list-group-item-info.active:focus {
  color: #fff;
  background-color: #31708f;
  border-color: #31708f;
}

.list-group-item-warning {
  color: #8a6d3b;
  background-color: #fcf8e3;
}

a.list-group-item-warning,
button.list-group-item-warning {
  color: #8a6d3b;
}

a.list-group-item-warning .list-group-item-heading,
button.list-group-item-warning .list-group-item-heading {
  color: inherit;
}

a.list-group-item-warning:hover,
a.list-group-item-warning:focus,
button.list-group-item-warning:hover,
button.list-group-item-warning:focus {
  color: #8a6d3b;
  background-color: #faf2cc;
}

a.list-group-item-warning.active,
a.list-group-item-warning.active:hover,
a.list-group-item-warning.active:focus,
button.list-group-item-warning.active,
button.list-group-item-warning.active:hover,
button.list-group-item-warning.active:focus {
  color: #fff;
  background-color: #8a6d3b;
  border-color: #8a6d3b;
}

.list-group-item-danger {
  color: #a94442;
  background-color: #f2dede;
}

a.list-group-item-danger,
button.list-group-item-danger {
  color: #a94442;
}

a.list-group-item-danger .list-group-item-heading,
button.list-group-item-danger .list-group-item-heading {
  color: inherit;
}

a.list-group-item-danger:hover,
a.list-group-item-danger:focus,
button.list-group-item-danger:hover,
button.list-group-item-danger:focus {
  color: #a94442;
  background-color: #ebcccc;
}

a.list-group-item-danger.active,
a.list-group-item-danger.active:hover,
a.list-group-item-danger.active:focus,
button.list-group-item-danger.active,
button.list-group-item-danger.active:hover,
button.list-group-item-danger.active:focus {
  color: #fff;
  background-color: #a94442;
  border-color: #a94442;
}

.list-group-item-heading {
  margin-top: 0;
  margin-bottom: 5px;
}

.list-group-item-text {
  margin-bottom: 0;
  line-height: 1.3;
}

.panel {
  margin-bottom: 25px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.panel-body {
  padding: 25px;
}

.panel-body:before,
.panel-body:after {
  content: " ";
  display: table;
}

.panel-body:after {
  clear: both;
}

.panel-heading {
  padding: 12.5px 25px;
  border-bottom: 1px solid transparent;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.panel-heading > .dropdown .dropdown-toggle {
  color: inherit;
}

.panel-title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 16px;
  color: inherit;
}

.panel-title > a,
.panel-title > small,
.panel-title > .small,
.panel-title > small > a,
.panel-title > .small > a {
  color: inherit;
}

.panel-footer {
  padding: 12.5px 25px;
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.panel > .list-group,
.panel > .panel-collapse > .list-group,
.panel > rubix-list-group > .list-group {
  margin-bottom: 0;
}

.panel > .list-group .list-group-item,
.panel > .panel-collapse > .list-group .list-group-item,
.panel > rubix-list-group > .list-group .list-group-item {
  border-width: 1px 0;
  border-radius: 0;
}

.panel
  > rubix-list-group
  > .list-group:first-child
  rubix-list-group-item:first-child
  .list-group-item {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}

.panel
  > rubix-list-group
  > .list-group:last-child
  rubix-list-group-item:last-child
  .list-group-item {
  border-bottom: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.panel > .list-group:first-child .list-group-item:first-child,
.panel
  > .panel-collapse
  > .list-group:first-child
  .list-group-item:first-child {
  border-top: 0;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.panel > .list-group:last-child .list-group-item:last-child,
.panel > .panel-collapse > .list-group:last-child .list-group-item:last-child {
  border-bottom: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.panel
  .panel-heading
  + .panel-collapse
  > .list-group
  .list-group-item:first-child {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}

.panel-heading + .list-group .list-group-item:first-child {
  border-top-width: 0;
}

.list-group + .panel-footer {
  border-top-width: 0;
}

.panel > .table,
.panel > .table-responsive > .table,
.panel > .panel-collapse > .table {
  margin-bottom: 0;
}

.panel > .table caption,
.panel > .table-responsive > .table caption,
.panel > .panel-collapse > .table caption {
  padding-left: 25px;
  padding-right: 25px;
}

.panel > .table:first-child,
.panel > .table-responsive:first-child > .table:first-child {
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.panel > .table:first-child > thead:first-child > tr:first-child,
.panel > .table:first-child > tbody:first-child > tr:first-child,
.panel
  > .table-responsive:first-child
  > .table:first-child
  > thead:first-child
  > tr:first-child,
.panel
  > .table-responsive:first-child
  > .table:first-child
  > tbody:first-child
  > tr:first-child {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.panel > .table:first-child > thead:first-child > tr:first-child td:first-child,
.panel > .table:first-child > thead:first-child > tr:first-child th:first-child,
.panel > .table:first-child > tbody:first-child > tr:first-child td:first-child,
.panel > .table:first-child > tbody:first-child > tr:first-child th:first-child,
.panel
  > .table-responsive:first-child
  > .table:first-child
  > thead:first-child
  > tr:first-child
  td:first-child,
.panel
  > .table-responsive:first-child
  > .table:first-child
  > thead:first-child
  > tr:first-child
  th:first-child,
.panel
  > .table-responsive:first-child
  > .table:first-child
  > tbody:first-child
  > tr:first-child
  td:first-child,
.panel
  > .table-responsive:first-child
  > .table:first-child
  > tbody:first-child
  > tr:first-child
  th:first-child {
  border-top-left-radius: 3px;
}

.panel > .table:first-child > thead:first-child > tr:first-child td:last-child,
.panel > .table:first-child > thead:first-child > tr:first-child th:last-child,
.panel > .table:first-child > tbody:first-child > tr:first-child td:last-child,
.panel > .table:first-child > tbody:first-child > tr:first-child th:last-child,
.panel
  > .table-responsive:first-child
  > .table:first-child
  > thead:first-child
  > tr:first-child
  td:last-child,
.panel
  > .table-responsive:first-child
  > .table:first-child
  > thead:first-child
  > tr:first-child
  th:last-child,
.panel
  > .table-responsive:first-child
  > .table:first-child
  > tbody:first-child
  > tr:first-child
  td:last-child,
.panel
  > .table-responsive:first-child
  > .table:first-child
  > tbody:first-child
  > tr:first-child
  th:last-child {
  border-top-right-radius: 3px;
}

.panel > .table:last-child,
.panel > .table-responsive:last-child > .table:last-child {
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.panel > .table:last-child > tbody:last-child > tr:last-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child,
.panel
  > .table-responsive:last-child
  > .table:last-child
  > tbody:last-child
  > tr:last-child,
.panel
  > .table-responsive:last-child
  > .table:last-child
  > tfoot:last-child
  > tr:last-child {
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.panel > .table:last-child > tbody:last-child > tr:last-child td:first-child,
.panel > .table:last-child > tbody:last-child > tr:last-child th:first-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child,
.panel
  > .table-responsive:last-child
  > .table:last-child
  > tbody:last-child
  > tr:last-child
  td:first-child,
.panel
  > .table-responsive:last-child
  > .table:last-child
  > tbody:last-child
  > tr:last-child
  th:first-child,
.panel
  > .table-responsive:last-child
  > .table:last-child
  > tfoot:last-child
  > tr:last-child
  td:first-child,
.panel
  > .table-responsive:last-child
  > .table:last-child
  > tfoot:last-child
  > tr:last-child
  th:first-child {
  border-bottom-left-radius: 3px;
}

.panel > .table:last-child > tbody:last-child > tr:last-child td:last-child,
.panel > .table:last-child > tbody:last-child > tr:last-child th:last-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child,
.panel
  > .table-responsive:last-child
  > .table:last-child
  > tbody:last-child
  > tr:last-child
  td:last-child,
.panel
  > .table-responsive:last-child
  > .table:last-child
  > tbody:last-child
  > tr:last-child
  th:last-child,
.panel
  > .table-responsive:last-child
  > .table:last-child
  > tfoot:last-child
  > tr:last-child
  td:last-child,
.panel
  > .table-responsive:last-child
  > .table:last-child
  > tfoot:last-child
  > tr:last-child
  th:last-child {
  border-bottom-right-radius: 3px;
}

.panel > .panel-body + .table,
.panel > rubix-bpanel-body + .table,
.panel > .panel-body + .table-responsive,
.panel > rubix-bpanel-body + .table-responsive,
.panel > .table + .panel-body,
.panel > .table + rubix-bpanel-body,
.panel > .table-responsive + .panel-body,
.panel > .table-responsive + rubix-bpanel-body {
  border-top: 1px solid #ddd;
}

.panel > .table > tbody:first-child > tr:first-child th,
.panel > .table > tbody:first-child > tr:first-child td {
  border-top: 0;
}

.panel > .table-bordered,
.panel > .table-responsive > .table-bordered {
  border: 0;
}

.panel > .table-bordered > thead > tr > th:first-child,
.panel > .table-bordered > thead > tr > td:first-child,
.panel > .table-bordered > tbody > tr > th:first-child,
.panel > .table-bordered > tbody > tr > td:first-child,
.panel > .table-bordered > tfoot > tr > th:first-child,
.panel > .table-bordered > tfoot > tr > td:first-child,
.panel > .table-responsive > .table-bordered > thead > tr > th:first-child,
.panel > .table-responsive > .table-bordered > thead > tr > td:first-child,
.panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,
.panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {
  border-left: 0;
}

.panel > .table-bordered > thead > tr > th:last-child,
.panel > .table-bordered > thead > tr > td:last-child,
.panel > .table-bordered > tbody > tr > th:last-child,
.panel > .table-bordered > tbody > tr > td:last-child,
.panel > .table-bordered > tfoot > tr > th:last-child,
.panel > .table-bordered > tfoot > tr > td:last-child,
.panel > .table-responsive > .table-bordered > thead > tr > th:last-child,
.panel > .table-responsive > .table-bordered > thead > tr > td:last-child,
.panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,
.panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {
  border-right: 0;
}

.panel > .table-bordered > thead > tr:first-child > td,
.panel > .table-bordered > thead > tr:first-child > th,
.panel > .table-bordered > tbody > tr:first-child > td,
.panel > .table-bordered > tbody > tr:first-child > th,
.panel > .table-responsive > .table-bordered > thead > tr:first-child > td,
.panel > .table-responsive > .table-bordered > thead > tr:first-child > th,
.panel > .table-responsive > .table-bordered > tbody > tr:first-child > td,
.panel > .table-responsive > .table-bordered > tbody > tr:first-child > th {
  border-bottom: 0;
}

.panel > .table-bordered > tbody > tr:last-child > td,
.panel > .table-bordered > tbody > tr:last-child > th,
.panel > .table-bordered > tfoot > tr:last-child > td,
.panel > .table-bordered > tfoot > tr:last-child > th,
.panel > .table-responsive > .table-bordered > tbody > tr:last-child > td,
.panel > .table-responsive > .table-bordered > tbody > tr:last-child > th,
.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td,
.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th {
  border-bottom: 0;
}

.panel > .table-responsive {
  border: 0;
  margin-bottom: 0;
}

.panel-group {
  margin-bottom: 25px;
}

.panel-group .collapse-link {
  height: 42px;
  display: block;
  line-height: 42px;
  margin-top: -12.5px;
  margin-bottom: -12.5px;
}

.panel-group .panel {
  margin-bottom: 0;
  border-radius: 4px;
}

.panel-group .panel + .panel {
  margin-top: 5px;
}

.panel-group rubix-bpanel {
  margin-bottom: 0;
  border-radius: 4px;
}

.panel-group rubix-bpanel + rubix-bpanel > .panel {
  margin-top: 5px;
}

.panel-group .panel-heading {
  border-bottom: 0;
}

.panel-group .panel-heading + .panel-collapse > .panel-body,
.panel-group .panel-heading + .panel-collapse > .list-group {
  border-top: 1px solid #ddd;
}

.panel-group .panel-footer {
  border-top: 0;
}

.panel-group .panel-footer + .panel-collapse .panel-body {
  border-bottom: 1px solid #ddd;
}

.panel-default {
  border-color: #ddd;
}

.panel-default > .panel-heading {
  color: #333333;
  background-color: #f5f5f5;
  border-color: #ddd;
}

.panel-default > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #ddd;
}

.panel-default > .panel-heading .badge {
  color: #f5f5f5;
  background-color: #333333;
}

.panel-default > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #ddd;
}

.panel-primary {
  border-color: #428bca;
}

.panel-primary > .panel-heading {
  color: #fff;
  background-color: #428bca;
  border-color: #428bca;
}

.panel-primary > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #428bca;
}

.panel-primary > .panel-heading .badge {
  color: #428bca;
  background-color: #fff;
}

.panel-primary > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #428bca;
}

.panel-success {
  border-color: #d6e9c6;
}

.panel-success > .panel-heading {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}

.panel-success > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #d6e9c6;
}

.panel-success > .panel-heading .badge {
  color: #dff0d8;
  background-color: #3c763d;
}

.panel-success > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #d6e9c6;
}

.panel-info {
  border-color: #bce8f1;
}

.panel-info > .panel-heading {
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}

.panel-info > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #bce8f1;
}

.panel-info > .panel-heading .badge {
  color: #d9edf7;
  background-color: #31708f;
}

.panel-info > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #bce8f1;
}

.panel-warning {
  border-color: #faebcc;
}

.panel-warning > .panel-heading {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
}

.panel-warning > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #faebcc;
}

.panel-warning > .panel-heading .badge {
  color: #fcf8e3;
  background-color: #8a6d3b;
}

.panel-warning > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #faebcc;
}

.panel-danger {
  border-color: #ebccd1;
}

.panel-danger > .panel-heading {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
}

.panel-danger > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #ebccd1;
}

.panel-danger > .panel-heading .badge {
  color: #f2dede;
  background-color: #a94442;
}

.panel-danger > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #ebccd1;
}

.panel-title > a {
  height: 42px;
  display: block;
  line-height: 42px;
  margin-top: -12.5px;
  margin-bottom: -12.5px;
}

.embed-responsive {
  position: relative;
  display: block;
  height: 0;
  padding: 0;
  overflow: hidden;
}

.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  border: 0;
}

.embed-responsive-16by9 {
  padding-bottom: 56.25%;
}

.embed-responsive-4by3 {
  padding-bottom: 75%;
}

.well {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}

.well blockquote {
  border-color: #ddd;
  border-color: rgba(0, 0, 0, 0.15);
}

.well-lg {
  padding: 24px;
  border-radius: 6px;
}

.well-sm {
  padding: 9px;
  border-radius: 3px;
}

.close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.2;
  filter: alpha(opacity=20);
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
  opacity: 0.5;
  filter: alpha(opacity=50);
}

button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
}

.modal-open {
  overflow: hidden;
}

.modal {
  display: none;
  overflow: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}

.modal.fade .modal-dialog {
  -webkit-transform: translate(0, -25%);
  -ms-transform: translate(0, -25%);
  transform: translate(0, -25%);
  -webkit-transition: -webkit-transform 0.3s ease-out;
  transition: -webkit-transform 0.3s ease-out;
  transition: transform 0.3s ease-out;
  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
}

.modal.in .modal-dialog {
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}

.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}

.modal-content {
  position: relative;
  background-color: #fff;
  border: 1px solid #999;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  background-clip: padding-box;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}

.modal-backdrop.fade {
  opacity: 0;
  filter: alpha(opacity=0);
}

.modal-backdrop.in {
  opacity: 0.5;
  filter: alpha(opacity=50);
}

.modal-header {
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
}

.modal-header:before,
.modal-header:after {
  content: " ";
  display: table;
}

.modal-header:after {
  clear: both;
}

.modal-header .close {
  margin-top: -2px;
}

.modal-title {
  margin: 0;
  line-height: 1.78571;
}

.modal-body {
  position: relative;
  padding: 15px;
}

.modal-footer {
  padding: 15px;
  text-align: right;
  border-top: 1px solid #e5e5e5;
}

.modal-footer:before,
.modal-footer:after {
  content: " ";
  display: table;
}

.modal-footer:after {
  clear: both;
}

.modal-footer .btn + .btn {
  margin-left: 5px;
  margin-bottom: 0;
}

.modal-footer .btn-group .btn + .btn {
  margin-left: -1px;
}

.modal-footer .btn-block + .btn-block {
  margin-left: 0;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 990px) {
  .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }

  .modal-content {
    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  }

  .modal-sm {
    width: 300px;
  }
}

@media (min-width: 1152px) {
  .modal-lg {
    width: 900px;
  }
}

.modal-container {
  position: relative;
}

.modal-container .modal,
.modal-container .modal-backdrop {
  position: absolute;
}

body > .modal-backdrop {
  z-index: -1;
}

.static-modal .modal {
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
  z-index: 1;
  position: relative;
}

.modal-container {
  position: relative;
}

.modal-container .modal,
.modal-container .modal-backdrop {
  position: absolute;
}

.tooltip {
  position: absolute;
  z-index: 1000000000000000013287555072;
  display: block;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  letter-spacing: normal;
  line-break: auto;
  line-height: 1.78571;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  white-space: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  font-size: 12px;
  opacity: 0;
  filter: alpha(opacity=0);
}

.tooltip.in {
  opacity: 0.9;
  filter: alpha(opacity=90);
}

.tooltip.top {
  margin-top: -3px;
  padding: 5px 0;
}

.tooltip.right {
  margin-left: 3px;
  padding: 0 5px;
}

.tooltip.bottom {
  margin-top: 3px;
  padding: 5px 0;
}

.tooltip.left {
  margin-left: -3px;
  padding: 0 5px;
}

.tooltip-inner {
  max-width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 4px;
}

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}

.tooltip.top-left .tooltip-arrow {
  bottom: 0;
  right: 5px;
  margin-bottom: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}

.tooltip.top-right .tooltip-arrow {
  bottom: 0;
  left: 5px;
  margin-bottom: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}

.tooltip.right .tooltip-arrow {
  top: 50%;
  left: 0;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #000;
}

.tooltip.left .tooltip-arrow {
  top: 50%;
  right: 0;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #000;
}

.tooltip.bottom .tooltip-arrow {
  top: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}

.tooltip.bottom-left .tooltip-arrow {
  top: 0;
  right: 5px;
  margin-top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}

.tooltip.bottom-right .tooltip-arrow {
  top: 0;
  left: 5px;
  margin-top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: none;
  max-width: 276px;
  padding: 1px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  letter-spacing: normal;
  line-break: auto;
  line-height: 1.78571;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  white-space: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  font-size: 14px;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}

.popover.top {
  margin-top: -10px;
}

.popover.right {
  margin-left: 10px;
}

.popover.bottom {
  margin-top: 10px;
}

.popover.left {
  margin-left: -10px;
}

.popover-title {
  margin: 0;
  padding: 8px 14px;
  font-size: 14px;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-radius: 5px 5px 0 0;
}

.popover-content {
  padding: 9px 14px;
}

.popover > .arrow,
.popover > .arrow:after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.popover > .arrow {
  border-width: 11px;
}

.popover > .arrow:after {
  border-width: 10px;
  content: "";
}

.popover.top > .arrow {
  left: 50%;
  margin-left: -11px;
  border-bottom-width: 0;
  border-top-color: #999999;
  border-top-color: rgba(0, 0, 0, 0.25);
  bottom: -11px;
}

.popover.top > .arrow:after {
  content: " ";
  bottom: 1px;
  margin-left: -10px;
  border-bottom-width: 0;
  border-top-color: #fff;
}

.popover.right > .arrow {
  top: 50%;
  left: -11px;
  margin-top: -11px;
  border-left-width: 0;
  border-right-color: #999999;
  border-right-color: rgba(0, 0, 0, 0.25);
}

.popover.right > .arrow:after {
  content: " ";
  left: 1px;
  bottom: -10px;
  border-left-width: 0;
  border-right-color: #fff;
}

.popover.bottom > .arrow {
  left: 50%;
  margin-left: -11px;
  border-top-width: 0;
  border-bottom-color: #999999;
  border-bottom-color: rgba(0, 0, 0, 0.25);
  top: -11px;
}

.popover.bottom > .arrow:after {
  content: " ";
  top: 1px;
  margin-left: -10px;
  border-top-width: 0;
  border-bottom-color: #fff;
}

.popover.left > .arrow {
  top: 50%;
  right: -11px;
  margin-top: -11px;
  border-right-width: 0;
  border-left-color: #999999;
  border-left-color: rgba(0, 0, 0, 0.25);
}

.popover.left > .arrow:after {
  content: " ";
  right: 1px;
  border-right-width: 0;
  border-left-color: #fff;
  bottom: -10px;
}

.carousel {
  position: relative;
}

.carousel-inner {
  position: relative;
  overflow: hidden;
  width: 100%;
}

.carousel-inner > .item {
  display: none;
  position: relative;
  -webkit-transition: 0.6s ease-in-out left;
  transition: 0.6s ease-in-out left;
}

.carousel-inner > .item > img,
.carousel-inner > .item > a > img {
  display: block;
  max-width: 100%;
  height: auto;
  line-height: 1;
}

@media all and (transform-3d), (-webkit-transform-3d) {
  .carousel-inner > .item {
    -webkit-transition: -webkit-transform 0.6s ease-in-out;
    transition: -webkit-transform 0.6s ease-in-out;
    transition: transform 0.6s ease-in-out;
    transition: transform 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000px;
    perspective: 1000px;
  }

  .carousel-inner > .item.next,
  .carousel-inner > .item.active.right {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    left: 0;
  }

  .carousel-inner > .item.prev,
  .carousel-inner > .item.active.left {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
    left: 0;
  }

  .carousel-inner > .item.next.left,
  .carousel-inner > .item.prev.right,
  .carousel-inner > .item.active {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    left: 0;
  }
}

.carousel-inner > .active,
.carousel-inner > .next,
.carousel-inner > .prev {
  display: block;
}

.carousel-inner > .active {
  left: 0;
}

.carousel-inner > .next,
.carousel-inner > .prev {
  position: absolute;
  top: 0;
  width: 100%;
}

.carousel-inner > .next {
  left: 100%;
}

.carousel-inner > .prev {
  left: -100%;
}

.carousel-inner > .next.left,
.carousel-inner > .prev.right {
  left: 0;
}

.carousel-inner > .active.left {
  left: -100%;
}

.carousel-inner > .active.right {
  left: 100%;
}

.carousel-control {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 15%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  font-size: 20px;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
  background-color: transparent;
}

.carousel-control.left {
  background-image: -webkit-gradient(
    linear,
    left top, right top,
    from(rgba(0, 0, 0, 0.5)),
    to(rgba(0, 0, 0, 0.0001))
  );
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0.0001) 100%
  );
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);
}

.carousel-control.right {
  left: auto;
  right: 0;
  background-image: -webkit-gradient(
    linear,
    left top, right top,
    from(rgba(0, 0, 0, 0.0001)),
    to(rgba(0, 0, 0, 0.5))
  );
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.0001) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);
}

.carousel-control:hover,
.carousel-control:focus {
  outline: 0;
  color: #fff;
  text-decoration: none;
  opacity: 0.9;
  filter: alpha(opacity=90);
}

.carousel-control .icon-prev,
.carousel-control .icon-next,
.carousel-control .glyphicon-chevron-left,
.carousel-control .glyphicon-chevron-right {
  position: absolute;
  top: 50%;
  margin-top: -10px;
  z-index: 5;
  display: inline-block;
}

.carousel-control .icon-prev,
.carousel-control .glyphicon-chevron-left {
  left: 50%;
  margin-left: -10px;
}

.carousel-control .icon-next,
.carousel-control .glyphicon-chevron-right {
  right: 50%;
  margin-right: -10px;
}

.carousel-control .icon-prev,
.carousel-control .icon-next {
  width: 20px;
  height: 20px;
  line-height: 1;
  font-family: serif;
}

.carousel-control .icon-prev:before {
  content: "\\2039";
}

.carousel-control .icon-next:before {
  content: "\\203a";
}

.carousel-indicators {
  position: absolute;
  bottom: 10px;
  left: 50%;
  z-index: 15;
  width: 60%;
  margin-left: -30%;
  padding-left: 0;
  list-style: none;
  text-align: center;
}

.carousel-indicators li {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 1px;
  text-indent: -999px;
  border: 1px solid #fff;
  border-radius: 10px;
  cursor: pointer;
  background-color: #000 \\9;
  background-color: transparent;
}

.carousel-indicators .active {
  margin: 0;
  width: 12px;
  height: 12px;
  background-color: #fff;
}

.carousel-caption {
  position: absolute;
  left: 15%;
  right: 15%;
  bottom: 20px;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}

.carousel-caption .btn {
  text-shadow: none;
}

@media screen and (min-width: 990px) {
  .carousel-control .glyphicon-chevron-left,
  .carousel-control .glyphicon-chevron-right,
  .carousel-control .icon-prev,
  .carousel-control .icon-next {
    width: 30px;
    height: 30px;
    margin-top: -10px;
    font-size: 30px;
  }

  .carousel-control .glyphicon-chevron-left,
  .carousel-control .icon-prev {
    margin-left: -10px;
  }

  .carousel-control .glyphicon-chevron-right,
  .carousel-control .icon-next {
    margin-right: -10px;
  }

  .carousel-caption {
    left: 20%;
    right: 20%;
    padding-bottom: 30px;
  }

  .carousel-indicators {
    bottom: 20px;
  }
}

.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}

.clearfix:after {
  clear: both;
}

.center-block {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.pull-right {
  float: right !important;
}

.pull-left {
  float: left !important;
}

.hide {
  display: none !important;
}

.show {
  display: block !important;
}

.invisible {
  visibility: hidden;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.hidden {
  display: none !important;
}

.affix {
  position: fixed;
}

@-ms-viewport {
  width: device-width;
}

.visible-xs {
  display: none !important;
}

.visible-sm {
  display: none !important;
}

.visible-md {
  display: none !important;
}

.visible-lg {
  display: none !important;
}

.visible-xs-block,
.visible-xs-inline,
.visible-xs-inline-block,
.visible-sm-block,
.visible-sm-inline,
.visible-sm-inline-block,
.visible-md-block,
.visible-md-inline,
.visible-md-inline-block,
.visible-lg-block,
.visible-lg-inline,
.visible-lg-inline-block {
  display: none !important;
}

@media (max-width: 989px) {
  .visible-xs {
    display: block !important;
  }

  table.visible-xs {
    display: table !important;
  }

  tr.visible-xs {
    display: table-row !important;
  }

  th.visible-xs,
  td.visible-xs {
    display: table-cell !important;
  }
}

@media (max-width: 989px) {
  .visible-xs-block {
    display: block !important;
  }
}

@media (max-width: 989px) {
  .visible-xs-inline {
    display: inline !important;
  }
}

@media (max-width: 989px) {
  .visible-xs-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 990px) and (max-width: 1151px) {
  .visible-sm {
    display: block !important;
  }

  table.visible-sm {
    display: table !important;
  }

  tr.visible-sm {
    display: table-row !important;
  }

  th.visible-sm,
  td.visible-sm {
    display: table-cell !important;
  }
}

@media (min-width: 990px) and (max-width: 1151px) {
  .visible-sm-block {
    display: block !important;
  }
}

@media (min-width: 990px) and (max-width: 1151px) {
  .visible-sm-inline {
    display: inline !important;
  }
}

@media (min-width: 990px) and (max-width: 1151px) {
  .visible-sm-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 1152px) and (max-width: 1365px) {
  .visible-md {
    display: block !important;
  }

  table.visible-md {
    display: table !important;
  }

  tr.visible-md {
    display: table-row !important;
  }

  th.visible-md,
  td.visible-md {
    display: table-cell !important;
  }
}

@media (min-width: 1152px) and (max-width: 1365px) {
  .visible-md-block {
    display: block !important;
  }
}

@media (min-width: 1152px) and (max-width: 1365px) {
  .visible-md-inline {
    display: inline !important;
  }
}

@media (min-width: 1152px) and (max-width: 1365px) {
  .visible-md-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 1366px) {
  .visible-lg {
    display: block !important;
  }

  table.visible-lg {
    display: table !important;
  }

  tr.visible-lg {
    display: table-row !important;
  }

  th.visible-lg,
  td.visible-lg {
    display: table-cell !important;
  }
}

@media (min-width: 1366px) {
  .visible-lg-block {
    display: block !important;
  }
}

@media (min-width: 1366px) {
  .visible-lg-inline {
    display: inline !important;
  }
}

@media (min-width: 1366px) {
  .visible-lg-inline-block {
    display: inline-block !important;
  }
}

@media (max-width: 989px) {
  .hidden-xs {
    display: none !important;
  }
}

@media (min-width: 990px) and (max-width: 1151px) {
  .hidden-sm {
    display: none !important;
  }
}

@media (min-width: 1152px) and (max-width: 1365px) {
  .hidden-md {
    display: none !important;
  }
}

@media (min-width: 1366px) {
  .hidden-lg {
    display: none !important;
  }
}

.visible-print {
  display: none !important;
}

@media print {
  .visible-print {
    display: block !important;
  }

  table.visible-print {
    display: table !important;
  }

  tr.visible-print {
    display: table-row !important;
  }

  th.visible-print,
  td.visible-print {
    display: table-cell !important;
  }
}

.visible-print-block {
  display: none !important;
}

@media print {
  .visible-print-block {
    display: block !important;
  }
}

.visible-print-inline {
  display: none !important;
}

@media print {
  .visible-print-inline {
    display: inline !important;
  }
}

.visible-print-inline-block {
  display: none !important;
}

@media print {
  .visible-print-inline-block {
    display: inline-block !important;
  }
}

@media print {
  .hidden-print {
    display: none !important;
  }
}

.form-group {
  position: relative;
}

.form-group .control-label ~ .form-control-feedback {
  top: 30px;
}

.form-group .control-label.sr-only ~ .form-control-feedback,
.form-group
  .bootstrap-datetimepicker-widget
  .control-label.btn[data-action="incrementHours"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .form-group
  .control-label.btn[data-action="incrementHours"]
  after
  ~ .form-control-feedback,
.form-group
  .bootstrap-datetimepicker-widget
  .control-label.btn[data-action="incrementMinutes"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .form-group
  .control-label.btn[data-action="incrementMinutes"]
  after
  ~ .form-control-feedback,
.form-group
  .bootstrap-datetimepicker-widget
  .control-label.btn[data-action="decrementHours"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .form-group
  .control-label.btn[data-action="decrementHours"]
  after
  ~ .form-control-feedback,
.form-group
  .bootstrap-datetimepicker-widget
  .control-label.btn[data-action="decrementMinutes"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .form-group
  .control-label.btn[data-action="decrementMinutes"]
  after
  ~ .form-control-feedback,
.form-group
  .bootstrap-datetimepicker-widget
  .control-label.btn[data-action="showHours"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .form-group
  .control-label.btn[data-action="showHours"]
  after
  ~ .form-control-feedback,
.form-group
  .bootstrap-datetimepicker-widget
  .control-label.btn[data-action="showMinutes"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .form-group
  .control-label.btn[data-action="showMinutes"]
  after
  ~ .form-control-feedback,
.form-group
  .bootstrap-datetimepicker-widget
  .control-label.btn[data-action="togglePeriod"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .form-group
  .control-label.btn[data-action="togglePeriod"]
  after
  ~ .form-control-feedback,
.form-group
  .bootstrap-datetimepicker-widget
  .control-label.btn[data-action="clear"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .form-group
  .control-label.btn[data-action="clear"]
  after
  ~ .form-control-feedback,
.form-group
  .bootstrap-datetimepicker-widget
  .control-label.btn[data-action="today"]
  after
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .form-group
  .control-label.btn[data-action="today"]
  after
  ~ .form-control-feedback,
.form-group
  .bootstrap-datetimepicker-widget
  .control-label.picker-switchafter
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  .form-group
  .control-label.picker-switchafter
  ~ .form-control-feedback,
.form-group
  .bootstrap-datetimepicker-widget
  table
  th.control-label.prevafter
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  table
  .form-group
  th.control-label.prevafter
  ~ .form-control-feedback,
.form-group
  .bootstrap-datetimepicker-widget
  table
  th.control-label.nextafter
  ~ .form-control-feedback,
.bootstrap-datetimepicker-widget
  table
  .form-group
  th.control-label.nextafter
  ~ .form-control-feedback {
  top: 0px;
}

.form-group [class^="col-"] .form-control-feedback {
  right: 25px;
}

.form-inline .form-group .form-control-feedback {
  top: 30px;
}

@media (min-width: 990px) {
  .form-inline .form-group .form-control-feedback {
    top: 0px;
  }
}

.form-horizontal .form-group .form-control-feedback {
  top: 0px;
}

.form-control {
  color: #444;
  height: 30px;
  padding: 0 12px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  border-width: 2px;
  letter-spacing: 0.5px;
  border-radius: 0 !important;
}

.form-control:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.form-control.plain {
  border-top: none;
  border-left: none;
  border-right: none;
}

.input-group-addon {
  border: none;
  color: #89949b;
  border-radius: 0 !important;
}

.form-control-feedback {
  width: 30px;
  height: 30px;
  line-height: 30px !important;
}

.input-group > .form-control-feedback {
  top: 0;
}

select[multiple],
select[size] {
  padding: 12px;
}

input[type="file"] {
  display: block;
  line-height: 0px;
}

.help-block {
  color: #bbb;
}

.form-control.inline,
.help-block.inline {
  margin: 0;
  width: auto;
  margin-right: 5px;
  display: inline-block;
}

@media (min-width: 990px) {
  .form-horizontal .control-label {
    padding: 0;
    line-height: 30px;
  }
}

.input-group-addon.plain {
  padding: 0;
  border: none;
  background: none;
}

.input-group-addon.plain > button {
  height: 30px;
  border-radius: 0;
}

.form-control-static {
  padding: 0;
  line-height: 30px;
}

.input-lg,
.input-group-lg > .form-control,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .btn,
.form-horizontal .form-group-lg .form-control,
.input-group-lg > .form-control,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .btn {
  height: 46px;
  padding: 10px 16px;
}

.input-sm,
.input-group-sm > .form-control,
.input-group-sm > .input-group-addon,
.input-group-sm > .input-group-btn > .btn,
.form-horizontal .form-group-sm .form-control,
.input-group-sm > .form-control,
.input-group-sm > .input-group-addon,
.input-group-sm > .input-group-btn > .btn {
  height: 25px !important;
  padding-top: 2px;
  margin-top: 8px;
}

.input-lg,
.input-group-lg > .form-control,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .btn,
.form-horizontal .form-group-lg .form-control,
.input-group-lg > .form-control,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .btn,
.form-horizontal .form-group-lg .form-control,
.input-group-lg > .form-control,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .btn {
  height: 50px;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.form-horizontal .radio,
.form-horizontal .checkbox,
.form-horizontal .radio-inline,
.form-horizontal .checkbox-inline {
  padding-top: 3px;
  padding-bottom: 3px;
}

.list-group-item:hover,
.list-group-item:focus {
  padding: 10px 15px;
  color: #555 !important;
  border: 1px solid #ddd !important;
  background-color: #f5f5f5 !important;
}

.form-inline .control-label {
  display: inline-block;
}

rubix-input-group {
  display: inline-block;
  position: relative;
}

.radio input[type="radio"],
.radio-inline input[type="radio"] {
  margin-top: 6px;
}

.checkbox input[type="checkbox"],
.checkbox-inline input[type="checkbox"] {
  margin-top: 6px;
}

.panel-xs-1 {
  width: 8.33333%;
}

.panel-xs-2 {
  width: 16.66667%;
}

.panel-xs-3 {
  width: 25%;
}

.panel-xs-4 {
  width: 33.33333%;
}

.panel-xs-5 {
  width: 41.66667%;
}

.panel-xs-6 {
  width: 50%;
}

.panel-xs-7 {
  width: 58.33333%;
}

.panel-xs-8 {
  width: 66.66667%;
}

.panel-xs-9 {
  width: 75%;
}

.panel-xs-10 {
  width: 83.33333%;
}

.panel-xs-11 {
  width: 91.66667%;
}

.panel-xs-12 {
  width: 100%;
}

@media (min-width: 990px) {
  .panel-sm-1 {
    width: 8.33333%;
  }

  .panel-sm-2 {
    width: 16.66667%;
  }

  .panel-sm-3 {
    width: 25%;
  }

  .panel-sm-4 {
    width: 33.33333%;
  }

  .panel-sm-5 {
    width: 41.66667%;
  }

  .panel-sm-6 {
    width: 50%;
  }

  .panel-sm-7 {
    width: 58.33333%;
  }

  .panel-sm-8 {
    width: 66.66667%;
  }

  .panel-sm-9 {
    width: 75%;
  }

  .panel-sm-10 {
    width: 83.33333%;
  }

  .panel-sm-11 {
    width: 91.66667%;
  }

  .panel-sm-12 {
    width: 100%;
  }
}

@media (min-width: 1152px) {
  .panel-md-1 {
    width: 8.33333%;
  }

  .panel-md-2 {
    width: 16.66667%;
  }

  .panel-md-3 {
    width: 25%;
  }

  .panel-md-4 {
    width: 33.33333%;
  }

  .panel-md-5 {
    width: 41.66667%;
  }

  .panel-md-6 {
    width: 50%;
  }

  .panel-md-7 {
    width: 58.33333%;
  }

  .panel-md-8 {
    width: 66.66667%;
  }

  .panel-md-9 {
    width: 75%;
  }

  .panel-md-10 {
    width: 83.33333%;
  }

  .panel-md-11 {
    width: 91.66667%;
  }

  .panel-md-12 {
    width: 100%;
  }
}

@media (min-width: 1366px) {
  .panel-lg-1 {
    width: 8.33333%;
  }

  .panel-lg-2 {
    width: 16.66667%;
  }

  .panel-lg-3 {
    width: 25%;
  }

  .panel-lg-4 {
    width: 33.33333%;
  }

  .panel-lg-5 {
    width: 41.66667%;
  }

  .panel-lg-6 {
    width: 50%;
  }

  .panel-lg-7 {
    width: 58.33333%;
  }

  .panel-lg-8 {
    width: 66.66667%;
  }

  .panel-lg-9 {
    width: 75%;
  }

  .panel-lg-10 {
    width: 83.33333%;
  }

  .panel-lg-11 {
    width: 91.66667%;
  }

  .panel-lg-12 {
    width: 100%;
  }
}

.panel-collapse-bottom {
  margin-bottom: 0 !important;
}

.panel-gutter-bottom {
  margin-bottom: 50px !important;
}

.rubix-panel-container-with-controls {
  position: relative;
}

.rubix-panel-container {
  overflow: hidden;
  background: white;
  position: relative;
  border-radius: 8px;
  margin-bottom: 25px;
}

.rubix-panel-container.noOverflow {
  overflow: auto;
}

html.no-touchevents
  .rubix-panel-container-with-controls:hover
  > .rubix-panel-controls,
html.no-touchevents
  .rubix-panel-container-with-controls:focus
  > .rubix-panel-controls,
html.no-touchevents
  .rubix-panel-container-with-controls.active
  > .rubix-panel-controls {
  top: -20px;
}

.rubix-panel-controls {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  top: 0;
  z-index: 0;
  background: white;
  position: absolute;
  color: #89949b;
  right: 12.5px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 0px 12.5px 5px 12.5px;
}

.rubix-panel-controls button {
  top: -2px;
  padding: 0;
  border: none;
  opacity: 0.5;
  color: inherit;
  background: none;
  position: relative;
}

.rubix-panel-controls button:hover,
.rubix-panel-controls button:focus,
.rubix-panel-controls button:active,
.rubix-panel-controls button:active:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  opacity: 1;
  border: none;
  outline: none;
  color: inherit;
  background: none;
}

.rubix-panel-controls button .rubix-icon {
  font-size: 14px;
}

.rubix-panel-controls > button ~ button,
.rubix-panel-controls > rubix-button ~ rubix-button {
  padding-left: 10px;
}

.rubix-panel {
  position: relative;
}

.rubix-panel-header,
rubix-panel-header {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.rubix-panel-header[class*="bg-"],
rubix-panel-header[class*="bg-"] {
  margin-bottom: 12.5px;
}

.rubix-panel-header ~ .rubix-panel-body,
.rubix-panel-header ~ rubix-panel-body > .rubix-panel-body,
rubix-panel-header ~ .rubix-panel-body,
rubix-panel-header ~ rubix-panel-body > .rubix-panel-body {
  padding-top: 0;
}

.rubix-panel-body {
  min-height: 35px;
  padding-top: 25px;
}

.rubix-panel-footer,
rubix-panel-footer {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.rubix-panel-footer[class*="bg-"],
rubix-panel-footer[class*="bg-"] {
  margin-top: 12.5px;
}

.rubix-panel-header div.tab-container,
.rubix-panel-header rubix-nav,
.rubix-panel-footer div.tab-container,
.rubix-panel-footer rubix-nav,
.rubix-panel-left div.tab-container,
.rubix-panel-left rubix-nav,
.rubix-panel-right div.tab-container,
.rubix-panel-right rubix-nav {
  width: 100%;
  display: table;
}

.rubix-panel-header .nav,
.rubix-panel-footer .nav,
.rubix-panel-left .nav,
.rubix-panel-right .nav {
  border: none;
  display: table-row;
}

.rubix-panel-header .nav:before,
.rubix-panel-header .nav:after,
.rubix-panel-footer .nav:before,
.rubix-panel-footer .nav:after,
.rubix-panel-left .nav:before,
.rubix-panel-left .nav:after,
.rubix-panel-right .nav:before,
.rubix-panel-right .nav:after {
  display: none;
}

.rubix-panel-header .nav rubix-menu,
.rubix-panel-header .nav rubix-nav-item,
.rubix-panel-header .nav > li,
.rubix-panel-footer .nav rubix-menu,
.rubix-panel-footer .nav rubix-nav-item,
.rubix-panel-footer .nav > li,
.rubix-panel-left .nav rubix-menu,
.rubix-panel-left .nav rubix-nav-item,
.rubix-panel-left .nav > li,
.rubix-panel-right .nav rubix-menu,
.rubix-panel-right .nav rubix-nav-item,
.rubix-panel-right .nav > li {
  display: table-cell;
  float: none;
  margin: 0;
  vertical-align: middle;
}

.rubix-panel-header .nav > li,
.rubix-panel-footer .nav > li,
.rubix-panel-left .nav > li,
.rubix-panel-right .nav > li {
  width: 1%;
}

.rubix-panel-header .nav rubix-menu > li,
.rubix-panel-header .nav rubix-nav-item > li,
.rubix-panel-footer .nav rubix-menu > li,
.rubix-panel-footer .nav rubix-nav-item > li,
.rubix-panel-left .nav rubix-menu > li,
.rubix-panel-left .nav rubix-nav-item > li,
.rubix-panel-right .nav rubix-menu > li,
.rubix-panel-right .nav rubix-nav-item > li {
  width: 100%;
}

.rubix-panel-header .nav rubix-menu > li > a,
.rubix-panel-header .nav rubix-nav-item > li > a,
.rubix-panel-header .nav > li > a,
.rubix-panel-footer .nav rubix-menu > li > a,
.rubix-panel-footer .nav rubix-nav-item > li > a,
.rubix-panel-footer .nav > li > a,
.rubix-panel-left .nav rubix-menu > li > a,
.rubix-panel-left .nav rubix-nav-item > li > a,
.rubix-panel-left .nav > li > a,
.rubix-panel-right .nav rubix-menu > li > a,
.rubix-panel-right .nav rubix-nav-item > li > a,
.rubix-panel-right .nav > li > a {
  margin: 0;
  width: 100.1%;
  color: inherit;
  opacity: 0.8;
  line-height: 3;
  border-color: transparent;
  outline: 1px solid inherit;
  border-right: 1px solid rgba(0, 0, 0, 0.07);
}

.rubix-panel-header .nav > li > a,
.rubix-panel-footer .nav > li > a,
.rubix-panel-left .nav > li > a,
.rubix-panel-right .nav > li > a {
  outline: none;
}

.rubix-panel-header .nav rubix-menu:not(:first-child):not(:last-child) > li > a,
.rubix-panel-header
  .nav
  rubix-nav-item:not(:first-child):not(:last-child)
  > li
  > a,
.rubix-panel-header .nav > li:not(:first-child):not(:last-child) > a,
.rubix-panel-footer .nav rubix-menu:not(:first-child):not(:last-child) > li > a,
.rubix-panel-footer
  .nav
  rubix-nav-item:not(:first-child):not(:last-child)
  > li
  > a,
.rubix-panel-footer .nav > li:not(:first-child):not(:last-child) > a,
.rubix-panel-left .nav rubix-menu:not(:first-child):not(:last-child) > li > a,
.rubix-panel-left
  .nav
  rubix-nav-item:not(:first-child):not(:last-child)
  > li
  > a,
.rubix-panel-left .nav > li:not(:first-child):not(:last-child) > a,
.rubix-panel-right .nav rubix-menu:not(:first-child):not(:last-child) > li > a,
.rubix-panel-right
  .nav
  rubix-nav-item:not(:first-child):not(:last-child)
  > li
  > a,
.rubix-panel-right .nav > li:not(:first-child):not(:last-child) > a {
  border-radius: 0;
}

.rubix-panel-header .nav rubix-menu:last-child,
.rubix-panel-header .nav rubix-nav-item:last-child,
.rubix-panel-footer .nav rubix-menu:last-child,
.rubix-panel-footer .nav rubix-nav-item:last-child,
.rubix-panel-left .nav rubix-menu:last-child,
.rubix-panel-left .nav rubix-nav-item:last-child,
.rubix-panel-right .nav rubix-menu:last-child,
.rubix-panel-right .nav rubix-nav-item:last-child {
  border-color: transparent;
}

.rubix-panel-header .nav rubix-menu > li > a:hover,
.rubix-panel-header .nav rubix-menu > li > a:focus,
.rubix-panel-header .nav rubix-nav-item > li > a:hover,
.rubix-panel-header .nav rubix-nav-item > li > a:focus,
.rubix-panel-header .nav > li > a:hover,
.rubix-panel-header .nav > li > a:focus,
.rubix-panel-footer .nav rubix-menu > li > a:hover,
.rubix-panel-footer .nav rubix-menu > li > a:focus,
.rubix-panel-footer .nav rubix-nav-item > li > a:hover,
.rubix-panel-footer .nav rubix-nav-item > li > a:focus,
.rubix-panel-footer .nav > li > a:hover,
.rubix-panel-footer .nav > li > a:focus,
.rubix-panel-left .nav rubix-menu > li > a:hover,
.rubix-panel-left .nav rubix-menu > li > a:focus,
.rubix-panel-left .nav rubix-nav-item > li > a:hover,
.rubix-panel-left .nav rubix-nav-item > li > a:focus,
.rubix-panel-left .nav > li > a:hover,
.rubix-panel-left .nav > li > a:focus,
.rubix-panel-right .nav rubix-menu > li > a:hover,
.rubix-panel-right .nav rubix-menu > li > a:focus,
.rubix-panel-right .nav rubix-nav-item > li > a:hover,
.rubix-panel-right .nav rubix-nav-item > li > a:focus,
.rubix-panel-right .nav > li > a:hover,
.rubix-panel-right .nav > li > a:focus {
  opacity: 1;
  background: transparent;
}

.rubix-panel-header .nav rubix-menu > li.active > a,
.rubix-panel-header .nav rubix-nav-item > li.active > a,
.rubix-panel-header .nav > li.active > a,
.rubix-panel-footer .nav rubix-menu > li.active > a,
.rubix-panel-footer .nav rubix-nav-item > li.active > a,
.rubix-panel-footer .nav > li.active > a,
.rubix-panel-left .nav rubix-menu > li.active > a,
.rubix-panel-left .nav rubix-nav-item > li.active > a,
.rubix-panel-left .nav > li.active > a,
.rubix-panel-right .nav rubix-menu > li.active > a,
.rubix-panel-right .nav rubix-nav-item > li.active > a,
.rubix-panel-right .nav > li.active > a {
  opacity: 1;
  background: white;
  color: #89949b;
}

.rubix-panel-header .plain.nav rubix-menu > li > a,
.rubix-panel-header .plain.nav rubix-nav-item > li > a,
.rubix-panel-header .plain.nav > li > a,
.rubix-panel-footer .plain.nav rubix-menu > li > a,
.rubix-panel-footer .plain.nav rubix-nav-item > li > a,
.rubix-panel-footer .plain.nav > li > a,
.rubix-panel-left .plain.nav rubix-menu > li > a,
.rubix-panel-left .plain.nav rubix-nav-item > li > a,
.rubix-panel-left .plain.nav > li > a,
.rubix-panel-right .plain.nav rubix-menu > li > a,
.rubix-panel-right .plain.nav rubix-nav-item > li > a,
.rubix-panel-right .plain.nav > li > a {
  border-color: transparent;
}

.rubix-panel-header .plain.nav > li > a,
.rubix-panel-footer .plain.nav > li > a,
.rubix-panel-left .plain.nav > li > a,
.rubix-panel-right .plain.nav > li > a {
  margin-top: -2px;
  margin-bottom: -2px;
}

.rubix-panel-header .plain.nav rubix-menu > li > a,
.rubix-panel-header .plain.nav rubix-nav-item > li > a,
.rubix-panel-header .plain.nav > li > a,
.rubix-panel-footer .plain.nav rubix-menu > li > a,
.rubix-panel-footer .plain.nav rubix-nav-item > li > a,
.rubix-panel-footer .plain.nav > li > a,
.rubix-panel-left .plain.nav rubix-menu > li > a,
.rubix-panel-left .plain.nav rubix-nav-item > li > a,
.rubix-panel-left .plain.nav > li > a,
.rubix-panel-right .plain.nav rubix-menu > li > a,
.rubix-panel-right .plain.nav rubix-nav-item > li > a,
.rubix-panel-right .plain.nav > li > a {
  background-color: transparent;
}

.rubix-panel-header .plain.nav rubix-menu > li > a:hover,
.rubix-panel-header .plain.nav rubix-menu > li > a:focus,
.rubix-panel-header .plain.nav rubix-nav-item > li > a:hover,
.rubix-panel-header .plain.nav rubix-nav-item > li > a:focus,
.rubix-panel-header .plain.nav > li > a:hover,
.rubix-panel-header .plain.nav > li > a:focus,
.rubix-panel-footer .plain.nav rubix-menu > li > a:hover,
.rubix-panel-footer .plain.nav rubix-menu > li > a:focus,
.rubix-panel-footer .plain.nav rubix-nav-item > li > a:hover,
.rubix-panel-footer .plain.nav rubix-nav-item > li > a:focus,
.rubix-panel-footer .plain.nav > li > a:hover,
.rubix-panel-footer .plain.nav > li > a:focus,
.rubix-panel-left .plain.nav rubix-menu > li > a:hover,
.rubix-panel-left .plain.nav rubix-menu > li > a:focus,
.rubix-panel-left .plain.nav rubix-nav-item > li > a:hover,
.rubix-panel-left .plain.nav rubix-nav-item > li > a:focus,
.rubix-panel-left .plain.nav > li > a:hover,
.rubix-panel-left .plain.nav > li > a:focus,
.rubix-panel-right .plain.nav rubix-menu > li > a:hover,
.rubix-panel-right .plain.nav rubix-menu > li > a:focus,
.rubix-panel-right .plain.nav rubix-nav-item > li > a:hover,
.rubix-panel-right .plain.nav rubix-nav-item > li > a:focus,
.rubix-panel-right .plain.nav > li > a:hover,
.rubix-panel-right .plain.nav > li > a:focus {
  background-color: transparent;
  border-color: transparent;
  color: white;
}

.rubix-panel-header .plain.nav rubix-menu > li.active > a,
.rubix-panel-header .plain.nav rubix-nav-item > li.active > a,
.rubix-panel-header .plain.nav > li.active > a,
.rubix-panel-footer .plain.nav rubix-menu > li.active > a,
.rubix-panel-footer .plain.nav rubix-nav-item > li.active > a,
.rubix-panel-footer .plain.nav > li.active > a,
.rubix-panel-left .plain.nav rubix-menu > li.active > a,
.rubix-panel-left .plain.nav rubix-nav-item > li.active > a,
.rubix-panel-left .plain.nav > li.active > a,
.rubix-panel-right .plain.nav rubix-menu > li.active > a,
.rubix-panel-right .plain.nav rubix-nav-item > li.active > a,
.rubix-panel-right .plain.nav > li.active > a {
  background-color: transparent;
  border-color: transparent;
  color: white;
}

.rubix-panel-header .plain.nav rubix-menu > li.active > a:before,
.rubix-panel-header .plain.nav rubix-nav-item > li.active > a:before,
.rubix-panel-header .plain.nav > li.active > a:before,
.rubix-panel-footer .plain.nav rubix-menu > li.active > a:before,
.rubix-panel-footer .plain.nav rubix-nav-item > li.active > a:before,
.rubix-panel-footer .plain.nav > li.active > a:before,
.rubix-panel-left .plain.nav rubix-menu > li.active > a:before,
.rubix-panel-left .plain.nav rubix-nav-item > li.active > a:before,
.rubix-panel-left .plain.nav > li.active > a:before,
.rubix-panel-right .plain.nav rubix-menu > li.active > a:before,
.rubix-panel-right .plain.nav rubix-nav-item > li.active > a:before,
.rubix-panel-right .plain.nav > li.active > a:before {
  content: " ";
  left: 50%;
  bottom: 0;
  width: 6px;
  display: block;
  margin-left: -7px;
  position: absolute;
  border-bottom: 6px solid #fff;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
}

.rubix-panel-header .nav rubix-menu:first-child > li > a,
.rubix-panel-header .nav rubix-nav-item:first-child > li > a,
.rubix-panel-header .nav > li:first-child > a,
.rubix-panel-left .nav rubix-menu:first-child > li > a,
.rubix-panel-left .nav rubix-nav-item:first-child > li > a,
.rubix-panel-left .nav > li:first-child > a {
  border-radius: 0;
  border-top-left-radius: 8px;
}

.rubix-panel-header .nav rubix-menu:last-child > li > a,
.rubix-panel-header .nav rubix-nav-item:last-child > li > a,
.rubix-panel-header .nav > li:last-child > a,
.rubix-panel-left .nav rubix-menu:last-child > li > a,
.rubix-panel-left .nav rubix-nav-item:last-child > li > a,
.rubix-panel-left .nav > li:last-child > a {
  border-radius: 0;
  border-right: none;
  border-top-right-radius: 8px;
}

.rubix-panel-footer .plain.nav rubix-menu > li,
.rubix-panel-footer .plain.nav rubix-nav-item > li,
.rubix-panel-right .plain.nav rubix-menu > li,
.rubix-panel-right .plain.nav rubix-nav-item > li {
  margin-bottom: 0;
  margin-top: -1px;
}

.rubix-panel-footer .plain.nav rubix-menu > li.active > a:before,
.rubix-panel-footer .plain.nav rubix-nav-item > li.active > a:before,
.rubix-panel-footer .plain.nav > li.active > a:before,
.rubix-panel-right .plain.nav rubix-menu > li.active > a:before,
.rubix-panel-right .plain.nav rubix-nav-item > li.active > a:before,
.rubix-panel-right .plain.nav > li.active > a:before {
  top: 0;
  bottom: auto;
  border-bottom: none;
  border-top: 6px solid #fff;
}

.rubix-panel-footer .nav rubix-menu:first-child > li > a,
.rubix-panel-footer .nav rubix-nav-item:first-child > li > a,
.rubix-panel-footer .nav > li:first-child > a,
.rubix-panel-right .nav rubix-menu:first-child > li > a,
.rubix-panel-right .nav rubix-nav-item:first-child > li > a,
.rubix-panel-right .nav > li:first-child > a {
  border-radius: 0;
  border-bottom-left-radius: 8px;
}

.rubix-panel-footer .nav rubix-menu:last-child > li > a,
.rubix-panel-footer .nav rubix-nav-item:last-child > li > a,
.rubix-panel-footer .nav > li:last-child > a,
.rubix-panel-right .nav rubix-menu:last-child > li > a,
.rubix-panel-right .nav rubix-nav-item:last-child > li > a,
.rubix-panel-right .nav > li:last-child > a {
  border-radius: 0;
  border-right: none;
  border-bottom-right-radius: 8px;
}

.rubix-panel.horizontal {
  overflow: hidden;
  border-radius: 8px;
}

.rubix-panel.horizontal .rubix-panel-left li > a,
.rubix-panel.horizontal rubix-panel-left li > a,
.rubix-panel.horizontal .rubix-panel-right li > a,
.rubix-panel.horizontal rubix-panel-right li > a {
  border-radius: 0px !important;
}

.rubix-panel.horizontal .rubix-panel-left li > a:after,
.rubix-panel.horizontal rubix-panel-left li > a:after,
.rubix-panel.horizontal .rubix-panel-right li > a:after,
.rubix-panel.horizontal rubix-panel-right li > a:after {
  display: none;
}

.rubix-panel + .rubix-panel.horizontal {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

@media (min-width: 990px) {
  .panel-tab-container .rubix-panel-header,
  .panel-tab-container .rubix-panel-footer {
    width: 100.1%;
    display: table;
  }

  .rubix-panel.horizontal {
    width: 100.1%;
    display: table;
    table-layout: fixed;
  }

  .rubix-panel.horizontal .rubix-panel-left li > a,
  .rubix-panel.horizontal rubix-panel-left li > a,
  .rubix-panel.horizontal .rubix-panel-right li > a,
  .rubix-panel.horizontal rubix-panel-right li > a {
    border: none;
  }

  .rubix-panel.horizontal > div {
    display: table-row;
  }

  .rubix-panel.horizontal .rubix-panel-left,
  .rubix-panel.horizontal rubix-panel-left,
  .rubix-panel.horizontal .rubix-panel-body,
  .rubix-panel.horizontal rubix-panel-body,
  .rubix-panel.horizontal .rubix-panel-right,
  .rubix-panel.horizontal rubix-panel-right {
    display: table-cell;
    vertical-align: top;
  }

  .rubix-panel.horizontal rubix-panel-left rubix-nav-item,
  .rubix-panel.horizontal rubix-panel-right rubix-nav-item,
  .rubix-panel.horizontal .rubix-panel-left > ul,
  .rubix-panel.horizontal .rubix-panel-right > ul,
  .rubix-panel.horizontal .rubix-panel-left > ul > li,
  .rubix-panel.horizontal .rubix-panel-right > ul > li {
    display: block;
  }

  .rubix-panel.horizontal .rubix-panel-left > ul > li,
  .rubix-panel.horizontal .rubix-panel-right > ul > li {
    width: 100%;
  }

  .rubix-panel.horizontal rubix-panel-left rubix-nav-item > li,
  .rubix-panel.horizontal rubix-panel-right rubix-nav-item > li {
    margin: 0;
  }

  .rubix-panel.horizontal
    .rubix-panel-left
    .nav-tabs.plain
    li.active
    > a:before {
    left: auto;
    right: -3px;
    bottom: 45%;
    -webkit-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
            transform: rotate(-90deg);
  }

  .rubix-panel.horizontal
    .rubix-panel-right
    .nav-tabs.plain
    li.active
    > a:before {
    top: 45%;
    left: 3px;
    -webkit-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
            transform: rotate(-90deg);
  }

  .rubix-panel-body ul[role="tablist"].nav {
    padding-left: 25px;
    margin-left: -25px;
    margin-right: -50px;
  }

  .rubix-panel-body ul[role="tablist"].nav.nav-stacked {
    margin-right: -25px;
  }
}

.rubix-panel-container.panel-plain {
  background: none !important;
}

.rubix-panel-header.nav-inline .nav-tabs > li > a {
  padding: 2px 25px !important;
  height: auto !important;
  line-height: 2;
  display: block;
  border-bottom: 0px;
  border: none;
  margin-bottom: -1px;
}

.rubix-panel-header.nav-inline .nav-tabs > li.active > a {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.left-tag,
.right-tag {
  position: relative;
  display: inline-block;
  text-decoration: none;
  border: none !important;
}

.left-tag:before,
.right-tag:before {
  top: 0;
  width: 0;
  height: 0;
  content: "";
  position: absolute;
  border-style: solid;
  border-color: transparent;
}

.left-tag {
  margin-left: 12px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 0 10px 0 8px !important;
  margin-bottom: 12.5px;
}

.left-tag:before {
  left: -12px;
  float: left;
  border-right-color: inherit;
  border-width: 12px 12px 12px 0;
}

.right-tag {
  margin-right: 12px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  padding: 0 8px 0 10px !important;
  margin-bottom: 12.5px;
}

.right-tag:before {
  right: -12px;
  float: right;
  border-left-color: inherit;
  border-width: 12px 0 12px 12px;
}

.terms {
  height: 200px;
  overflow: auto;
  background: #fff;
  padding: 25px;
}

.rubix-timeline-view {
  padding: 25px;
  padding-right: 0px;
  margin-left: 37.5px;
  border-left: 2px solid #eee;
  margin-bottom: -25px;
}

.rubix-panel-body > .rubix-timeline-view {
  margin-top: -25px;
}

.rubix-panel-header ~ .rubix-panel-body > .rubix-timeline-view {
  margin-top: 0;
}

.rubix-timeline-item {
  position: relative;
}

.rubix-timeline-title {
  font-size: 12px;
  background: #eee;
  padding: 4px 15px;
  font-weight: bold;
  display: inline-block;
  border-radius: 8px;
}

.rubix-timeline-icon {
  width: 30px;
  height: 30px;
  left: -41.5px;
  font-size: 16px;
  padding: 0px 7px;
  background: #eee;
  line-height: 28px;
  position: absolute;
  border-radius: 100px;
  display: inline-block;
}

.rubix-timeline-avatar {
  left: -41.5px;
}

.rubix-timeline-body > ul {
  padding: 0;
  list-style-type: none;
  border-bottom: 2px solid #eee;
  margin-bottom: 25px;
  margin-top: 12.5px;
}

.rubix-timeline-body > ul > li {
  padding-right: 25px;
  padding-bottom: 25px;
}

.rubix-timeline-body > ul > li:before {
  left: -30px;
  content: " ";
  margin-top: 8px;
  position: absolute;
  border-radius: 100px;
  border: 4px solid #eee;
  -webkit-box-shadow: 0px 0px 0px 6px #fff;
          box-shadow: 0px 0px 0px 6px #fff;
}

.rubix-timeline-view ~ .rubix-timeline-view {
  margin-top: 0;
  padding-top: 0;
}

.rubix-timeline-view.rubix-timeline-with-header {
  padding-top: 0;
}

.rubix-timeline-view.rubix-timeline-with-header > .rubix-timeline-item {
  position: relative;
}

.rubix-timeline-view.rubix-timeline-with-header
  > .rubix-timeline-item
  > .rubix-timeline-header {
  height: 50px;
  padding-top: 10px;
  position: relative;
  padding-left: 23px;
  margin-left: -64.5px;
}

.rubix-timeline-view.rubix-timeline-with-header
  > .rubix-timeline-item
  > .rubix-timeline-header
  > .rubix-timeline-icon,
.rubix-timeline-view.rubix-timeline-with-header
  > .rubix-timeline-item
  > .rubix-timeline-header
  > .rubix-timeline-title {
  left: 0;
  position: relative;
}

.rubix-timeline-view.rubix-timeline-with-header
  > .rubix-timeline-item
  > .rubix-timeline-header[class^="bg-"]
  > .rubix-timeline-title,
.rubix-timeline-view.rubix-timeline-with-header
  > .rubix-timeline-item
  > .rubix-timeline-header[class*=" bg-"]
  > .rubix-timeline-title {
  padding: 0 10px;
  background: none !important;
}

.rubix-timeline-view.rubix-timeline-with-header
  > .rubix-timeline-item
  > .rubix-timeline-body
  > ul {
  border: none;
  margin-bottom: 0;
}

.rubix-timeline-view.rubix-timeline-centered {
  margin-left: 45%;
}

.rubix-timeline-view.rubix-timeline-centered .rubix-timeline-body > ul {
  border: none;
  margin-bottom: 0;
}

.rubix-timeline-view.rubix-timeline-centered .rubix-timeline-body > ul > li {
  float: right;
  display: block;
}

.rubix-timeline-view.rubix-timeline-centered
  .rubix-timeline-body
  > ul
  > li:before,
.rubix-timeline-view.rubix-timeline-centered
  .rubix-timeline-body
  > ul
  > li:after {
  clear: both;
  content: " ";
  display: table;
}

.rubix-timeline-view.rubix-timeline-centered
  .rubix-timeline-body
  > ul
  > li:nth-child(odd) {
  width: 100%;
  float: left;
  margin-left: -100%;
  padding-left: 25px;
  padding-right: 50px;
}

.alternate .rubix-timeline-view {
  margin: 0;
  padding: 0;
  border: none;
  margin-top: -25px;
}

.alternate .rubix-timeline-view:before {
  left: 50%;
  height: 100%;
  content: " ";
  position: absolute;
  padding-right: 0px;
  border-left: 2px solid #eee;
}

.alternate .rubix-timeline-view .rubix-timeline-item {
  padding-top: 25px;
}

.alternate
  .rubix-timeline-view.rubix-timeline-with-header
  .rubix-timeline-item {
  padding-top: 0;
}

.alternate .rubix-timeline-view .rubix-timeline-item:nth-child(odd) {
  padding-bottom: 25px;
}

.alternate .rubix-timeline-view .rubix-timeline-header {
  margin: 0;
  left: auto;
  padding-left: 0;
  text-align: center;
}

.alternate .rubix-timeline-view .rubix-timeline-header > .rubix-timeline-icon {
  top: 1px;
  left: auto;
  padding-right: 0;
  position: relative;
  border-radius: 8px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.alternate .rubix-timeline-view .rubix-timeline-header > .rubix-timeline-title {
  height: 30px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.alternate
  .rubix-timeline-view
  .rubix-timeline-header[class^="bg-"]
  > .rubix-timeline-icon,
.alternate
  .rubix-timeline-view
  .rubix-timeline-header[class*=" bg-"]
  > .rubix-timeline-icon {
  background: none;
}

.alternate .rubix-timeline-view .rubix-timeline-body > ul {
  border: none;
}

.alternate .rubix-timeline-view .rubix-timeline-body > ul > li {
  width: 100%;
  position: relative;
  display: inline-block;
}

.alternate .rubix-timeline-view .rubix-timeline-body > ul > li:before {
  left: 50%;
  position: absolute;
}

.alternate .rubix-timeline-view .rubix-timeline-body > ul > li:nth-child(odd) {
  padding-right: 50%;
  right: 25px;
  padding-left: 50px;
}

.alternate
  .rubix-timeline-view
  .rubix-timeline-body
  > ul
  > li:nth-child(odd):before {
  margin-left: 22px;
}

.alternate .rubix-timeline-view .rubix-timeline-body > ul > li.left {
  padding-right: 50% !important;
  right: 25px !important;
  padding-left: 50px !important;
}

.alternate .rubix-timeline-view .rubix-timeline-body > ul > li.left:before {
  margin-left: 22px !important;
}

.alternate .rubix-timeline-view .rubix-timeline-body > ul > li:nth-child(even) {
  padding-left: 50%;
  right: -25px;
  padding-right: 50px;
}

.alternate
  .rubix-timeline-view
  .rubix-timeline-body
  > ul
  > li:nth-child(even):before {
  margin-left: -28px;
}

.alternate .rubix-timeline-view .rubix-timeline-body > ul > li.right {
  padding-left: 50% !important;
  right: -25px !important;
  padding-right: 50px !important;
}

.alternate .rubix-timeline-view .rubix-timeline-body > ul > li.right:before {
  margin-left: -28px !important;
}

.pricing-table {
  padding: 0;
  background: white;
  margin-bottom: 25px;
}

.pricing-table.preferred {
  z-index: 1;
  left: -1px;
  border: 1px solid gray;
}

@media (min-width: 990px) {
  .pricing-table {
    border-right: 1px solid #e9f0f5;
  }

  .pricing-table:last-child {
    border: none;
  }
}

.pricing-table.preferred ~ .pricing-table {
  left: -1px;
}

.pricing-table-header {
  color: #8ba0af;
  background: #d2e0eb;
}

.pricing-table-header > h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 300;
  padding-top: 25px;
  padding-bottom: 25px;
}

.pricing-table-price {
  color: inherit;
  background: #d2e0eb;
  margin-top: 25px;
}

.pricing-table-price h2 {
  left: 50%;
  width: 85px;
  margin: auto;
  height: 85px;
  font-size: 24px;
  line-height: 75px;
  position: absolute;
  background: inherit;
  margin-left: -42.5px;
  border-radius: 100px;
  border: 5px solid white;
  margin-top: -12.5px;
}

.pricing-table-body {
  margin-bottom: 25px;
  margin-top: 50px;
}

.pricing-table-feature {
  margin: 0 25px;
  padding: 12.5px;
}

.pricing-btn-container {
  padding: 25px;
  padding-bottom: 0;
  padding-top: 12.5px;
}

.pricing-btn-container > button {
  width: 100%;
  border-radius: 8px;
}

.pricing-btn-container > button.btn-lightblue50:hover,
.pricing-btn-container > button.btn-lightblue50:focus {
  background: #8ba0af;
  border-color: #8ba0af;
}

.radio input[type="radio"],
.radio-inline input[type="radio"] {
  margin-top: 6px;
}

.checkbox input[type="checkbox"],
.checkbox-inline input[type="checkbox"] {
  margin-top: 6px;
}

.popover {
  z-index: 999999999;
}

.label,
.badge {
  font-size: 75%;
}

label {
  display: block;
}

label.inline {
  display: inline-block;
}

#app-container {
  display: block;
}

#container {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  min-height: 100vh;
  background: #fff;
}

div#__bs_notify__ {
  z-index: 10000000000000000 !important;
  background-color: #6788ff !important;
}

.ps-container .ps-scrollbar-x-rail {
  position: absolute;
  /* please don't change 'position' */
  bottom: 3px;
  /* there must be 'bottom' for ps-scrollbar-x-rail */
  height: 6px;
  opacity: 0;
  filter: alpha(opacity=0);
  -webkit-transition: background-color 0.2s ease, opacity 0.2s ease;
  transition: background-color 0.2s ease, opacity 0.2s ease;
}

.ps-container:hover .ps-scrollbar-x-rail,
.ps-container.hover .ps-scrollbar-x-rail {
  opacity: 0.6;
  filter: alpha(opacity=60);
}

.ps-container .ps-scrollbar-x-rail:hover,
.ps-container .ps-scrollbar-x-rail.hover {
  background-color: white;
  opacity: 0.9;
  filter: alpha(opacity=90);
}

.ps-container .ps-scrollbar-x-rail.in-scrolling {
  background-color: white;
  opacity: 0.9;
  filter: alpha(opacity=90);
}

.ps-container .ps-scrollbar-y-rail {
  position: absolute;
  /* please don't change 'position' */
  right: 3px;
  /* there must be 'right' for ps-scrollbar-y-rail */
  width: 6px;
  opacity: 0;
  filter: alpha(opacity=0);
  -webkit-transition: background-color 0.2s ease, opacity 0.2s ease;
  transition: background-color 0.2s ease, opacity 0.2s ease;
}

.ps-container:hover .ps-scrollbar-y-rail,
.ps-container.hover .ps-scrollbar-y-rail {
  opacity: 0.6;
  filter: alpha(opacity=60);
}

.ps-container .ps-scrollbar-y-rail:hover,
.ps-container .ps-scrollbar-y-rail.hover {
  background-color: white;
  opacity: 0.9;
  filter: alpha(opacity=90);
}

.ps-container .ps-scrollbar-y-rail.in-scrolling {
  background-color: white;
  opacity: 0.9;
  filter: alpha(opacity=90);
}

.ps-container .ps-scrollbar-x {
  position: absolute;
  /* please don't change 'position' */
  bottom: 0;
  /* there must be 'bottom' for ps-scrollbar-x */
  height: 6px;
  background-color: #aaa;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.ps-container.ie6 .ps-scrollbar-x {
  font-size: 0;
  /* fixed scrollbar height in xp sp3 ie6 */
}

.ps-container .ps-scrollbar-x-rail:hover .ps-scrollbar-x,
.ps-container .ps-scrollbar-x-rail.hover .ps-scrollbar-x {
  background-color: #999;
}

.ps-container .ps-scrollbar-y {
  position: absolute;
  /* please don't change 'position' */
  right: 0;
  /* there must be 'right' for ps-scrollbar-y */
  width: 6px;
  background-color: #aaa;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.ps-container.ie6 .ps-scrollbar-y {
  font-size: 0;
  /* fixed scrollbar height in xp sp3 ie6 */
}

.ps-container .ps-scrollbar-y-rail:hover .ps-scrollbar-y,
.ps-container .ps-scrollbar-y-rail.hover .ps-scrollbar-y {
  background-color: #999;
}

.ps-container.ie .ps-scrollbar-x,
.ps-container.ie .ps-scrollbar-y {
  visibility: hidden;
}

.ps-container.ie:hover .ps-scrollbar-x,
.ps-container.ie:hover .ps-scrollbar-y,
.ps-container.ie.hover .ps-scrollbar-x,
.ps-container.ie.hover .ps-scrollbar-y {
  visibility: visible;
}

.doc-sidebar {
  padding: 25px;
  overflow: auto !important;
}

.doc-sidebar-link {
  display: block;
  margin-left: -25px;
  margin-right: -25px;
  border: none !important;
  padding: 5px 12.5px 5px 25px;
}

.doc-sidebar-group-links a {
  padding-left: 37.5px;
}

.doc-sidebar-group-name {
  font-size: 12px;
  cursor: pointer;
  max-width: 250px;
  font-weight: bold;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  position: relative;
  margin-top: 12.5px;
  margin-left: -25px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 5px;
  margin-right: -25px;
  word-wrap: break-word;
  text-transform: uppercase;
  color: rgba(137, 148, 155, 0.6);
}

.doc-sidebar-group-name:hover,
.doc-sidebar-group-name.minus {
  color: #89949b;
}

.doc-sidebar-group-name:before {
  top: -4px;
  left: 10px;
  content: "+";
  font-size: 16px;
  position: absolute;
}

.doc-sidebar-group-name.minus:before {
  top: -8px;
  left: 12px;
  content: "-";
  font-size: 20px;
}

.doc-sidebar-link:hover {
  color: white;
  background: #28514e;
}

.doc-sidebar-link.active {
  background: #2eb398;
  color: white;
}

.bs-example {
  background: white;
  position: relative;
  margin-bottom: -8px;
  border: 1px solid #ddd;
  padding: 45px 15px 15px;
  border-radius: 4px 4px 0 0;
}

.bs-example:after {
  top: 15px;
  left: 15px;
  color: #959595;
  font-size: 12px;
  font-weight: 700;
  content: "Example";
  position: absolute;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.bs-example + pre {
  font-size: 14px;
  border-color: #ddd;
  border-radius: 0 0 4px 4px !important;
}

.upgrade-guide-item {
  padding-left: 12.5px;
  list-style-type: disc;
}

.bs-example .dropdown-menu.open {
  position: static;
  display: block;
  margin-bottom: 5px;
  clear: left;
}

.bs-example.tooltip-static .tooltip {
  margin: 5px 10px;
  position: relative;
  display: inline-block;
}

.bs-example.bs-example-popover-contained {
  height: 200px;
}

.bs-example.bs-example-popover-scroll {
  height: 200px;
  overflow: scroll;
}

.show-grid [class^="col-"] {
  background: #eee;
  padding-top: 10px;
  padding-bottom: 10px;
  border: 1px solid #ddd;
}

.bs-example .container {
  width: auto;
  max-width: 900px;
}

a[role="menuitem"] > .container-fluid {
  margin: -4px -25px;
  padding: 4px 25px;
}

.icon-1-and-quarter-x {
  font-size: 125%;
}

.icon-1-and-half-x {
  font-size: 150%;
}

.icon-1x {
  font-size: 100%;
}

.icon-2-and-quarter-x {
  font-size: 250%;
}

.icon-2-and-half-x {
  font-size: 300%;
}

.icon-2x {
  font-size: 200%;
}

.icon-3-and-quarter-x {
  font-size: 375%;
}

.icon-3-and-half-x {
  font-size: 450%;
}

.icon-3x {
  font-size: 300%;
}

.icon-4-and-quarter-x {
  font-size: 500%;
}

.icon-4-and-half-x {
  font-size: 600%;
}

.icon-4x {
  font-size: 400%;
}

.icon-rotate-45 {
  -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
          transform: rotate(45deg);
}

.icon-rotate-90 {
  -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
          transform: rotate(90deg);
}

.icon-rotate-135 {
  -webkit-transform: rotate(135deg);
      -ms-transform: rotate(135deg);
          transform: rotate(135deg);
}

.icon-rotate-180 {
  -webkit-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
          transform: rotate(180deg);
}

.icon-rotate-225 {
  -webkit-transform: rotate(225deg);
      -ms-transform: rotate(225deg);
          transform: rotate(225deg);
}

.icon-rotate-270 {
  -webkit-transform: rotate(270deg);
      -ms-transform: rotate(270deg);
          transform: rotate(270deg);
}

.icon-rotate-315 {
  -webkit-transform: rotate(315deg);
      -ms-transform: rotate(315deg);
          transform: rotate(315deg);
}

.icon-rotate-360 {
  -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
          transform: rotate(360deg);
}

@media (max-width: 989px) {
  .col-xs-only-gutter-top {
    margin-top: 25px;
  }

  .col-xs-only-gutter-left {
    margin-left: 25px;
  }

  .col-xs-only-gutter-right {
    margin-right: 25px;
  }

  .col-xs-only-gutter-bottom {
    margin-bottom: 25px;
  }

  .col-xs-only-collapse-top {
    padding-top: 0;
  }

  .col-xs-only-collapse-left {
    padding-left: 0;
  }

  .col-xs-only-collapse-right {
    padding-right: 0;
  }

  .col-xs-only-collapse-bottom {
    padding-bottom: 0;
  }
}

@media (min-width: 990px) and (max-width: 1151px) {
  .col-sm-only-gutter-top {
    margin-top: 25px;
  }

  .col-sm-only-gutter-left {
    margin-left: 25px;
  }

  .col-sm-only-gutter-right {
    margin-right: 25px;
  }

  .col-sm-only-gutter-bottom {
    margin-bottom: 25px;
  }

  .col-sm-only-collapse-top {
    padding-top: 0;
  }

  .col-sm-only-collapse-left {
    padding-left: 0;
  }

  .col-sm-only-collapse-right {
    padding-right: 0;
  }

  .col-sm-only-collapse-bottom {
    padding-bottom: 0;
  }
}

@media (min-width: 1152px) and (max-width: 1365px) {
  .col-md-only-gutter-top {
    margin-top: 25px;
  }

  .col-md-only-gutter-left {
    margin-left: 25px;
  }

  .col-md-only-gutter-right {
    margin-right: 25px;
  }

  .col-md-only-gutter-bottom {
    margin-bottom: 25px;
  }

  .col-md-only-collapse-top {
    padding-top: 0;
  }

  .col-md-only-collapse-left {
    padding-left: 0;
  }

  .col-md-only-collapse-right {
    padding-right: 0;
  }

  .col-md-only-collapse-bottom {
    padding-bottom: 0;
  }
}

@media (min-width: 1366px) {
  .col-lg-only-gutter-top {
    margin-top: 25px;
  }

  .col-lg-only-gutter-left {
    margin-left: 25px;
  }

  .col-lg-only-gutter-right {
    margin-right: 25px;
  }

  .col-lg-only-gutter-bottom {
    margin-bottom: 25px;
  }

  .col-lg-only-collapse-top {
    padding-top: 0;
  }

  .col-lg-only-collapse-left {
    padding-left: 0;
  }

  .col-lg-only-collapse-right {
    padding-right: 0;
  }

  .col-lg-only-collapse-bottom {
    padding-bottom: 0;
  }
}

.col-xs-gutter-top {
  margin-top: 25px;
}

.col-xs-gutter-left {
  margin-left: 25px;
}

.col-xs-gutter-right {
  margin-right: 25px;
}

.col-xs-gutter-bottom {
  margin-bottom: 25px;
}

.col-xs-collapse-top {
  padding-top: 0;
}

.col-xs-collapse-left {
  padding-left: 0;
}

.col-xs-collapse-right {
  padding-right: 0;
}

.col-xs-collapse-bottom {
  padding-bottom: 0;
}

@media (min-width: 990px) {
  .col-sm-gutter-top {
    margin-top: 25px;
  }

  .col-sm-gutter-left {
    margin-left: 25px;
  }

  .col-sm-gutter-right {
    margin-right: 25px;
  }

  .col-sm-gutter-bottom {
    margin-bottom: 25px;
  }

  .col-sm-collapse-top {
    padding-top: 0;
  }

  .col-sm-collapse-left {
    padding-left: 0;
  }

  .col-sm-collapse-right {
    padding-right: 0;
  }

  .col-sm-collapse-bottom {
    padding-bottom: 0;
  }
}

@media (min-width: 1152px) {
  .col-md-gutter-top {
    margin-top: 25px;
  }

  .col-md-gutter-left {
    margin-left: 25px;
  }

  .col-md-gutter-right {
    margin-right: 25px;
  }

  .col-md-gutter-bottom {
    margin-bottom: 25px;
  }

  .col-md-collapse-top {
    padding-top: 0;
  }

  .col-md-collapse-left {
    padding-left: 0;
  }

  .col-md-collapse-right {
    padding-right: 0;
  }

  .col-md-collapse-bottom {
    padding-bottom: 0;
  }
}

@media (min-width: 1366px) {
  .col-lg-gutter-top {
    margin-top: 25px;
  }

  .col-lg-gutter-left {
    margin-left: 25px;
  }

  .col-lg-gutter-right {
    margin-right: 25px;
  }

  .col-lg-gutter-bottom {
    margin-bottom: 25px;
  }

  .col-lg-collapse-top {
    padding-top: 0;
  }

  .col-lg-collapse-left {
    padding-left: 0;
  }

  .col-lg-collapse-right {
    padding-right: 0;
  }

  .col-lg-collapse-bottom {
    padding-bottom: 0;
  }
}

/* columns of same height styles */
.container-xs-height {
  width: 100.1%;
  display: table;
  table-layout: fixed;
  padding-left: 0px;
  padding-right: 0px;
}

.container-xs-heightbefore,
.container-xs-height:after {
  clear: none;
  content: none;
  display: none;
}

.row-xs-height {
  display: table-row;
}

.row-xs-heightbefore,
.row-xs-height:after {
  clear: none;
  content: none;
  display: none;
}

.col-xs-height {
  vertical-align: top;
  display: table-cell;
  float: none;
}

@media (min-width: 990px) {
  .container-sm-height {
    width: 100.1%;
    display: table;
    table-layout: fixed;
    padding-left: 0px;
    padding-right: 0px;
  }

  .container-sm-heightbefore,
  .container-sm-height:after {
    clear: none;
    content: none;
    display: none;
  }

  .row-sm-height {
    display: table-row;
  }

  .row-sm-heightbefore,
  .row-sm-height:after {
    clear: none;
    content: none;
    display: none;
  }

  .col-sm-height {
    vertical-align: top;
    display: table-cell;
    float: none;
  }
}

@media (min-width: 1152px) {
  .container-md-height {
    width: 100.1%;
    display: table;
    table-layout: fixed;
    padding-left: 0px;
    padding-right: 0px;
  }

  .container-md-heightbefore,
  .container-md-height:after {
    clear: none;
    content: none;
    display: none;
  }

  .row-md-height {
    display: table-row;
  }

  .row-md-heightbefore,
  .row-md-height:after {
    clear: none;
    content: none;
    display: none;
  }

  .col-md-height {
    vertical-align: top;
    display: table-cell;
    float: none;
  }
}

@media (min-width: 1366px) {
  .container-lg-height {
    width: 100.1%;
    display: table;
    table-layout: fixed;
    padding-left: 0px;
    padding-right: 0px;
  }

  .container-lg-heightbefore,
  .container-lg-height:after {
    clear: none;
    content: none;
    display: none;
  }

  .row-lg-height {
    display: table-row;
  }

  .row-lg-heightbefore,
  .row-lg-height:after {
    clear: none;
    content: none;
    display: none;
  }

  .col-lg-height {
    vertical-align: top;
    display: table-cell;
    float: none;
  }
}

/* vertical alignment styles */
.col-top {
  vertical-align: top;
}

.col-middle {
  vertical-align: middle;
}

.col-bottom {
  vertical-align: bottom;
}

/* fix firefox responsive images */
.img-responsive {
  width: 100%;
}

.grid-collapse {
  padding: 0;
}

.grid-collapse > rubix-row > .row,
.grid-collapse .row {
  margin: 0;
}

.grid-collapse > rubix-row > .row > rubix-col > [class^="col-"],
.grid-collapse > rubix-row > .row > [class^="col-"],
.grid-collapse .row > rubix-col > [class^="col-"],
.grid-collapse .row > [class^="col-"] {
  padding: 0;
}

.grid-gutter {
  margin: 25px;
}

.grid-gutter-top {
  margin-top: 25px;
}

.grid-gutter-left {
  margin-left: 25px;
}

.grid-gutter-right {
  margin-right: 25px;
}

.grid-gutter-bottom {
  margin-bottom: 25px;
}

.trumbowyg-box,
.trumbowyg-editor {
  border: none !important;
}

.trumbowyg-box {
  color: #333 !important;
  border-top: 1px solid #d7e0e2 !important;
}

.trumbowyg-editor {
  border-bottom: 1px solid #d7e0e2 !important;
}

.trumbowyg-button-pane {
  background: #ffffff !important;
}

.trumbowyg-button-group button {
  margin-bottom: 0 !important;
}

.trumbowyg-button-group button:hover,
.trumbowyg-button-group button:focus,
.trumbowyg-button-group button.trumbowyg-active {
  background: #d7e0e2 !important;
}

body.flash {
  display: none;
}

.slider-track,
.slider-handle,
.slider-selection,
.slider.slider-disabled .slider-track,
.slider.slider-disabled .slider-handle {
  -webkit-filter: none;
          filter: none;
  -webkit-box-shadow: none;
          box-shadow: none;
  border-radius: 0;
  background-image: none;
  background-repeat: none;
}

.slider-selection {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border-radius: 4px;
}

.slider-track {
  background: #f0f0f0;
}

.slider-handle {
  background: #3a94a5;
}

.slider.slider-disabled .slider-track {
  background: #e5e5e5;
}

.bootstrap-datetimepicker-widget a[data-action] {
  border: none;
  display: inline;
}

.bootstrap-datetimepicker-widget button[data-action] {
  padding: 2px 15px;
}

.bootstrap-datetimepicker-widget td a[data-action="togglePicker"] {
  border: 0;
  display: block;
  cursor: pointer;
  border-radius: 20px;
  padding: 12px !important;
}

.bootstrap-datetimepicker-widget td a[data-action="togglePicker"] span {
  margin: 0;
  padding: 5px;
  font-size: 180%;
  background: none;
  width: 54px !important;
  height: auto !important;
  line-height: 1 !important;
}

.bootstrap-datetimepicker-widget th.picker-switch {
  background: #eeeeee;
}

.bootstrap-datetimepicker-widget .picker-switch.accordion-toggle {
  background: #f5f5f5 !important;
}

.bootstrap-datetimepicker-widget table td.today:before {
  content: "";
  display: inline-block;
  border-top-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 4px;
  right: 4px;
  border-left: 7px solid transparent;
  border-bottom: 7px solid #428bca;
}

.datetimepicker-inline {
  width: 100%;
  padding: 25px;
  display: table;
}

html[dir="rtl"] [class^="icon-"].float-right-rtl,
html[dir="rtl"] [class*=" icon-"].float-right-rtl {
  position: relative;
  /*@noflip*/
  float: right;
}

body {
  opacity: 1;
  -webkit-transition: all 0.7s ease;
  transition: all 0.7s ease;
}

body.fade-out {
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  opacity: 0;
}

#app-preloader > .preloader {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  background: #e9edf2;
  z-index: 99999999999;
}

#app-preloader > .preloader > img {
  margin: auto;
  display: block;
  margin-top: 150px;
  position: relative;
}

@keyframes vex-flipin-horizontal {
  0% {
    opacity: 0;
    transform: rotateY(-90deg);
    -webkit-transform: rotateY(-90deg);
    -moz-transform: rotateY(-90deg);
    -ms-transform: rotateY(-90deg);
    -o-transform: rotateY(-90deg);
  }
  100% {
    opacity: 1;
    transform: rotateY(0deg);
    -webkit-transform: rotateY(0deg);
    -moz-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    -o-transform: rotateY(0deg);
  }
}

@-webkit-keyframes vex-flipin-horizontal {
  0% {
    opacity: 0;
    transform: rotateY(-90deg);
    -webkit-transform: rotateY(-90deg);
    -moz-transform: rotateY(-90deg);
    -ms-transform: rotateY(-90deg);
    -o-transform: rotateY(-90deg);
  }
  100% {
    opacity: 1;
    transform: rotateY(0deg);
    -webkit-transform: rotateY(0deg);
    -moz-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    -o-transform: rotateY(0deg);
  }
}

@keyframes vex-flipout-horizontal {
  0% {
    opacity: 1;
    transform: rotateY(0deg);
    -webkit-transform: rotateY(0deg);
    -moz-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    -o-transform: rotateY(0deg);
  }
  100% {
    opacity: 0;
    transform: rotateY(90deg);
    -webkit-transform: rotateY(90deg);
    -moz-transform: rotateY(90deg);
    -ms-transform: rotateY(90deg);
    -o-transform: rotateY(90deg);
  }
}

@-webkit-keyframes vex-flipout-horizontal {
  0% {
    opacity: 1;
    transform: rotateY(0deg);
    -webkit-transform: rotateY(0deg);
    -moz-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    -o-transform: rotateY(0deg);
  }
  100% {
    opacity: 0;
    transform: rotateY(90deg);
    -webkit-transform: rotateY(90deg);
    -moz-transform: rotateY(90deg);
    -ms-transform: rotateY(90deg);
    -o-transform: rotateY(90deg);
  }
}

.vex.vex-theme-flat-attack {
  -webkit-perspective: 1300px;
  -ms-perspective: 1300px;
  -o-perspective: 1300px;
  perspective: 1300px;
  -webkit-perspective-origin: 50% 150px;
  -ms-perspective-origin: 50% 150px;
  -o-perspective-origin: 50% 150px;
  perspective-origin: 50% 150px;
  padding-top: 100px;
  padding-bottom: 100px;
  font-size: 1.5em;
}

.vex.vex-theme-flat-attack.vex-closing .vex-content {
  animation: vex-flipout-horizontal 0.5s;
  -webkit-animation: vex-flipout-horizontal 0.5s;
  -moz-animation: vex-flipout-horizontal 0.5s;
  -ms-animation: vex-flipout-horizontal 0.5s;
  -o-animation: vex-flipout-horizontal 0.5s;
  -webkit-backface-visibility: hidden;
}

.vex.vex-theme-flat-attack .vex-content {
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  animation: vex-flipin-horizontal 0.5s;
  -webkit-animation: vex-flipin-horizontal 0.5s;
  -moz-animation: vex-flipin-horizontal 0.5s;
  -ms-animation: vex-flipin-horizontal 0.5s;
  -o-animation: vex-flipin-horizontal 0.5s;
  -webkit-backface-visibility: hidden;
}

.vex.vex-theme-flat-attack .vex-content {
  font-family: "Open Sans", sans-serif;
  font-weight: 200;
  background: white;
  color: #444444;
  padding: 2em 2em 3em 2em;
  line-height: 1.5em;
  position: relative;
  margin: 0 auto;
  max-width: 100%;
  width: 600px;
}

.vex.vex-theme-flat-attack .vex-content h1,
.vex.vex-theme-flat-attack .vex-content h2,
.vex.vex-theme-flat-attack .vex-content h3,
.vex.vex-theme-flat-attack .vex-content h4,
.vex.vex-theme-flat-attack .vex-content h5,
.vex.vex-theme-flat-attack .vex-content h6,
.vex.vex-theme-flat-attack .vex-content p,
.vex.vex-theme-flat-attack .vex-content ul,
.vex.vex-theme-flat-attack .vex-content li {
  color: inherit;
}

.vex.vex-theme-flat-attack .vex-close {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.vex.vex-theme-flat-attack .vex-close:before {
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
  line-height: 1px;
  padding-top: 0.5em;
  display: block;
  font-size: 2em;
  text-indent: 1px;
  overflow: hidden;
  height: 1.25em;
  width: 1.25em;
  text-align: center;
  top: 0;
  right: 0;
  color: white;
  background: #666666;
}

.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-message {
  margin-bottom: 0.5em;
}

.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input {
  margin-bottom: 0.5em;
}

.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input textarea,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="date"],
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="datetime"],
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="datetime-local"],
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="email"],
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="month"],
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="number"],
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="password"],
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="search"],
.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type="tel"],
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="text"],
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="time"],
.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input input[type="url"],
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="week"] {
  border-radius: 3px;
  background: #f0f0f0;
  width: 100%;
  padding: 0.25em 0.67em;
  border: 0;
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  min-height: 2.5em;
  margin: 0 0 0.25em;
}

.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-input textarea:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="date"]:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="datetime"]:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="datetime-local"]:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="email"]:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="month"]:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="number"]:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="password"]:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="search"]:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="tel"]:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="text"]:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="time"]:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="url"]:focus,
.vex.vex-theme-flat-attack
  .vex-dialog-form
  .vex-dialog-input
  input[type="week"]:focus {
  -webkit-box-shadow: inset 0 0 0 2px #666666;
  box-shadow: inset 0 0 0 2px #666666;
  outline: none;
}

.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-buttons {
  *zoom: 1;
  padding-top: 1em;
  margin-bottom: -3em;
  margin-left: -2em;
  margin-right: -2em;
}

.vex.vex-theme-flat-attack .vex-dialog-form .vex-dialog-buttons:after {
  content: "";
  display: table;
  clear: both;
}

.vex.vex-theme-flat-attack .vex-dialog-button {
  border-radius: 0;
  border: 0;
  margin: 0;
  float: right;
  padding: 0.5em 1em;
  font-size: 1.13em;
  text-transform: uppercase;
  font-weight: 200;
  letter-spacing: 0.1em;
  line-height: 1em;
  font-family: inherit;
}

.vex.vex-theme-flat-attack .vex-dialog-button.vex-last {
  margin-left: 0;
}

.vex.vex-theme-flat-attack .vex-dialog-button:focus {
  outline: none;
}

.vex.vex-theme-flat-attack .vex-dialog-button.vex-dialog-button-primary {
  background: #666666;
  color: white;
}

.vex.vex-theme-flat-attack .vex-dialog-button.vex-dialog-button-primary:focus {
  -webkit-box-shadow: inset 0 3px rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 3px rgba(0, 0, 0, 0.2);
}

.vex.vex-theme-flat-attack .vex-dialog-button.vex-dialog-button-secondary {
  background: white;
  color: #cccccc;
}

.vex.vex-theme-flat-attack
  .vex-dialog-button.vex-dialog-button-secondary:focus {
  -webkit-box-shadow: inset 0 3px #aaaaaa;
  box-shadow: inset 0 3px #aaaaaa;
  background: #eeeeee;
  color: #777777;
}

.vex.vex-theme-flat-attack .vex-dialog-button.vex-dialog-button-secondary:hover,
.vex.vex-theme-flat-attack
  .vex-dialog-button.vex-dialog-button-secondary:active {
  color: #777777;
}

.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink .vex-close:before {
  background: #ff7ea7;
}

.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  textarea:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="date"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="datetime"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="datetime-local"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="email"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="month"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="number"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="password"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="search"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="tel"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="text"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="time"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="url"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-input
  input[type="week"]:focus {
  -webkit-box-shadow: inset 0 0 0 2px #ff7ea7;
  box-shadow: inset 0 0 0 2px #ff7ea7;
}

.vex.vex-theme-flat-attack.vex-theme-flat-attack-pink
  .vex-dialog-form
  .vex-dialog-buttons
  .vex-dialog-button.vex-dialog-button-primary {
  background: #ff7ea7;
}

.vex.vex-theme-flat-attack.vex-theme-flat-attack-red .vex-close:before {
  background: #ce4a55;
}

.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  textarea:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="date"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="datetime"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="datetime-local"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="email"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="month"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="number"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="password"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="search"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="tel"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="text"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="time"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="url"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-input
  input[type="week"]:focus {
  -webkit-box-shadow: inset 0 0 0 2px #ce4a55;
  box-shadow: inset 0 0 0 2px #ce4a55;
}

.vex.vex-theme-flat-attack.vex-theme-flat-attack-red
  .vex-dialog-form
  .vex-dialog-buttons
  .vex-dialog-button.vex-dialog-button-primary {
  background: #ce4a55;
}

.vex.vex-theme-flat-attack.vex-theme-flat-attack-green .vex-close:before {
  background: #34b989;
}

.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  textarea:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="date"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="datetime"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="datetime-local"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="email"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="month"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="number"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="password"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="search"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="tel"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="text"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="time"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="url"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-input
  input[type="week"]:focus {
  -webkit-box-shadow: inset 0 0 0 2px #34b989;
  box-shadow: inset 0 0 0 2px #34b989;
}

.vex.vex-theme-flat-attack.vex-theme-flat-attack-green
  .vex-dialog-form
  .vex-dialog-buttons
  .vex-dialog-button.vex-dialog-button-primary {
  background: #34b989;
}

.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue .vex-close:before {
  background: #477fa5;
}

.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  textarea:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="date"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="datetime"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="datetime-local"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="email"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="month"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="number"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="password"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="search"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="tel"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="text"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="time"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="url"]:focus,
.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-input
  input[type="week"]:focus {
  -webkit-box-shadow: inset 0 0 0 2px #477fa5;
  box-shadow: inset 0 0 0 2px #477fa5;
}

.vex.vex-theme-flat-attack.vex-theme-flat-attack-blue
  .vex-dialog-form
  .vex-dialog-buttons
  .vex-dialog-button.vex-dialog-button-primary {
  background: #477fa5;
}

.vex-loading-spinner.vex-theme-flat-attack {
  height: 4em;
  width: 4em;
}

@-webkit-keyframes ui-spinner-rotate-right {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes ui-spinner-rotate-left {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes ui-spinner-rotate-right {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}

@keyframes ui-spinner-rotate-left {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}

.messenger-spinner {
  position: relative;
  border-radius: 100%;
}

ul.messenger.messenger-spinner-active .messenger-spinner .messenger-spinner {
  display: block;
}

.messenger-spinner .messenger-spinner-side {
  width: 50%;
  height: 100%;
  overflow: hidden;
  position: absolute;
}

.messenger-spinner .messenger-spinner-side .messenger-spinner-fill {
  border-radius: 999px;
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
}

.messenger-spinner .messenger-spinner-side-left {
  left: 0;
}

.messenger-spinner .messenger-spinner-side-left .messenger-spinner-fill {
  left: 100%;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  -webkit-animation-name: ui-spinner-rotate-left;
  animation-name: ui-spinner-rotate-left;
  -webkit-transform-origin: 0 50%;
  -ms-transform-origin: 0 50%;
  transform-origin: 0 50%;
}

.messenger-spinner .messenger-spinner-side-right {
  left: 50%;
}

.messenger-spinner .messenger-spinner-side-right .messenger-spinner-fill {
  left: -100%;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  -webkit-animation-name: ui-spinner-rotate-right;
  animation-name: ui-spinner-rotate-right;
  -webkit-transform-origin: 100% 50%;
  -ms-transform-origin: 100% 50%;
  transform-origin: 100% 50%;
}

ul.messenger-theme-flat {
  border-radius: 4px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
      user-select: none;
  background: #404040;
}

ul.messenger-theme-flat.messenger-empty {
  display: none;
}

ul.messenger-theme-flat .messenger-message {
  -webkit-box-shadow: inset 0px 1px rgba(255, 255, 255, 0.13),
    inset 48px 0px 0px #292929;
  box-shadow: inset 0px 1px rgba(255, 255, 255, 0.13),
    inset 48px 0px 0px #292929;
  border-radius: 0px;
  position: relative;
  border: 0px;
  margin-bottom: 0px;
  font-size: 13px;
  background: transparent;
  color: #f0f0f0;
  font-weight: 500;
  padding: 10px 30px 13px 65px;
}

ul.messenger-theme-flat .messenger-message .messenger-close {
  position: absolute;
  top: 0px;
  right: 0px;
  color: #888888;
  opacity: 1;
  font-weight: bold;
  display: block;
  font-size: 20px;
  line-height: 20px;
  padding: 8px 10px 7px 7px;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
}

ul.messenger-theme-flat .messenger-message .messenger-close:hover {
  color: #bbbbbb;
}

ul.messenger-theme-flat .messenger-message .messenger-close:active {
  color: #777777;
}

ul.messenger-theme-flat .messenger-message .messenger-actions {
  float: none;
  margin-top: 10px;
}

ul.messenger-theme-flat .messenger-message .messenger-actions a {
  border-radius: 4px;
  text-decoration: none;
  color: #aaaaaa;
  background: #2e2e2e;
  display: inline-block;
  padding: 10px;
  margin-right: 10px;
  padding: 4px 11px 6px;
  text-transform: capitalize;
}

ul.messenger-theme-flat .messenger-message .messenger-actions a:hover {
  color: #f0f0f0;
  background: #2e2e2e;
}

ul.messenger-theme-flat .messenger-message .messenger-actions a:active {
  background: #292929;
  color: #aaaaaa;
}

ul.messenger-theme-flat
  .messenger-message
  .messenger-actions
  .messenger-phrase {
  display: none;
}

ul.messenger-theme-flat .messenger-message .messenger-message-inner:before {
  border-radius: 50%;
  position: absolute;
  left: 17px;
  display: block;
  content: " ";
  top: 50%;
  margin-top: -8px;
  height: 13px;
  width: 13px;
  z-index: 20;
}

ul.messenger-theme-flat
  .messenger-message.alert-success
  .messenger-message-inner:before {
  background: #5fca4a;
}

ul.messenger-theme-flat
  .messenger-message.alert-info
  .messenger-message-inner:before {
  background: #61c4b8;
}

ul.messenger-theme-flat
  .messenger-message.alert-error
  .messenger-message-inner:before {
  background: #dd6a45;
}

ul.messenger-theme-flat
  .messenger-message.alert-error.messenger-retry-soon
  .messenger-spinner {
  width: 32px;
  height: 32px;
  background: transparent;
}

ul.messenger-theme-flat
  .messenger-message.alert-error.messenger-retry-soon
  .messenger-spinner
  .messenger-spinner-side
  .messenger-spinner-fill {
  background: #dd6a45;
  -webkit-animation-duration: 20s;
  animation-duration: 20s;
  opacity: 1;
}

ul.messenger-theme-flat
  .messenger-message.alert-error.messenger-retry-soon
  .messenger-spinner:after {
  content: "";
  background: #292929;
  position: absolute;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  top: 3px;
  left: 3px;
  display: block;
}

ul.messenger-theme-flat
  .messenger-message.alert-error.messenger-retry-later
  .messenger-spinner {
  width: 32px;
  height: 32px;
  background: transparent;
}

ul.messenger-theme-flat
  .messenger-message.alert-error.messenger-retry-later
  .messenger-spinner
  .messenger-spinner-side
  .messenger-spinner-fill {
  background: #dd6a45;
  -webkit-animation-duration: 600s;
  animation-duration: 600s;
  opacity: 1;
}

ul.messenger-theme-flat
  .messenger-message.alert-error.messenger-retry-later
  .messenger-spinner:after {
  content: "";
  background: #292929;
  position: absolute;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  top: 3px;
  left: 3px;
  display: block;
}

ul.messenger-theme-flat
  .messenger-message-slot.messenger-last
  .messenger-message {
  border-radius: 4px 4px 0px 0px;
  -webkit-box-shadow: inset 48px 0px 0px #292929;
  box-shadow: inset 48px 0px 0px #292929;
}

ul.messenger-theme-flat
  .messenger-message-slot.messenger-first
  .messenger-message {
  border-radius: 0px 0px 4px 4px;
  -webkit-box-shadow: inset 0px 1px rgba(255, 255, 255, 0.13),
    inset 48px 0px 0px #292929;
  box-shadow: inset 0px 1px rgba(255, 255, 255, 0.13),
    inset 48px 0px 0px #292929;
}

ul.messenger-theme-flat
  .messenger-message-slot.messenger-first.messenger-last
  .messenger-message {
  border-radius: 4px;
  -webkit-box-shadow: inset 48px 0px 0px #292929;
  box-shadow: inset 48px 0px 0px #292929;
}

ul.messenger-theme-flat .messenger-spinner {
  display: block;
  position: absolute;
  left: 7px;
  top: 50%;
  margin-top: -18px;
  z-index: 999;
  height: 32px;
  width: 32px;
  z-index: 10;
}

/* Ion.RangeSlider, Flat UI Skin
// css version 1.9.2
// © 2013-2014 Denis Ineshin | IonDen.com
// ===================================================================================================================*/
/* =====================================================================================================================
// Skin details */
.irs-line-mid,
.irs-line-left,
.irs-line-right,
.irs-diapason,
.irs-slider {
  background: url("/public/imgs/common/sprite-skin-flat.png") repeat-x;
}

.irs {
  height: 40px;
}

.irs-with-grid {
  height: 60px;
}

.irs-line {
  height: 12px;
  top: 25px;
}

.irs-line-left {
  height: 12px;
  background-position: 0 -30px;
}

.irs-line-mid {
  height: 12px;
  background-position: 0 0;
}

.irs-line-right {
  height: 12px;
  background-position: 100% -30px;
}

.irs-diapason {
  height: 12px;
  top: 25px;
  background-position: 0 -60px;
}

.irs-slider {
  width: 16px;
  height: 18px;
  top: 22px;
  background-position: 0 -90px;
}

#irs-active-slider,
.irs-slider:hover {
  background-position: 0 -120px;
}

.irs-min,
.irs-max {
  color: #999;
  font-size: 10px;
  line-height: 1.333;
  text-shadow: none;
  top: 0;
  padding: 1px 3px;
  background: #e1e4e9;
  border-radius: 4px;
}

.irs-from,
.irs-to,
.irs-single {
  color: #fff;
  font-size: 10px;
  line-height: 1.333;
  text-shadow: none;
  padding: 1px 5px;
  background: #ed5565;
  border-radius: 4px;
}

.irs-from:after,
.irs-to:after,
.irs-single:after {
  position: absolute;
  display: block;
  content: "";
  bottom: -6px;
  left: 50%;
  width: 0;
  height: 0;
  margin-left: -3px;
  overflow: hidden;
  border: 3px solid transparent;
  border-top-color: #ed5565;
}

.irs-grid-pol {
  background: #e1e4e9;
}

.irs-grid-text {
  color: #999;
}

.bs-example > .dropdown > .dropdown-toggle {
  float: left;
}

.bs-example > .dropdown > .dropdown-menu {
  clear: left;
  display: block;
  position: static;
  margin-bottom: 5px;
}

.btn-default {
  background: #b4b7b9;
  color: white;
  border-color: #b4b7b9;
}

.btn-default.btn-outlined {
  color: #b4b7b9;
  background: none;
}

.btn-default.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}

.btn-default.btn-outlined.btn-onlyOnHover:hover,
.btn-default.btn-outlined.btn-onlyOnHover:focus,
.btn-default.btn-outlined.btn-onlyOnHover.active {
  color: white;
}

.btn-default.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}

.btn-default.btn-outlined.btn-inverse:hover,
.btn-default.btn-outlined.btn-inverse:focus,
.btn-default.btn-outlined.btn-inverse.active {
  color: #b4b7b9;
  background: white;
}

.btn-default.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-default.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-default.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #b4b7b9;
  color: white;
  border-color: #b4b7b9;
}

.btn-default.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-default.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-default.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #85898d;
  border-color: #666b6e;
}

.btn-default:focus,
.btn-default.focus,
.btn-default:hover,
.btn-default.active {
  color: white;
  background: #ced0d2;
  border-color: #ced0d2;
}

.btn-default:active,
.btn-default.active,
.btn-default[aria-expanded="true"],
.btn-default.active:hover,
.btn-default.active:focus,
.btn-default[aria-expanded="true"]:hover,
.btn-default[aria-expanded="true"]:focus,
.open > .btn-default.dropdown-toggle {
  color: white;
  background: #85898d;
  border-color: #666b6e;
  background-image: none;
}

.btn-default.dropdown-toggle + ul li.active a {
  color: white;
  background: #b4b7b9;
}

.btn-default.disabled,
.btn-default[disabled],
fieldset[disabled] .btn-default {
  pointer-events: none;
}

.btn-default .badge {
  color: #b4b7b9;
  background-color: #b4b7b9;
}

.btn-text {
  background: #89949b;
  color: white;
  border-color: #89949b;
}

.btn-text.btn-outlined {
  color: #89949b;
  background: none;
}

.btn-text.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}

.btn-text.btn-outlined.btn-onlyOnHover:hover,
.btn-text.btn-outlined.btn-onlyOnHover:focus,
.btn-text.btn-outlined.btn-onlyOnHover.active {
  color: white;
}

.btn-text.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}

.btn-text.btn-outlined.btn-inverse:hover,
.btn-text.btn-outlined.btn-inverse:focus,
.btn-text.btn-outlined.btn-inverse.active {
  color: #89949b;
  background: white;
}

.btn-text.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-text.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-text.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #89949b;
  color: white;
  border-color: #89949b;
}

.btn-text.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-text.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-text.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #5c666c;
  border-color: #40474b;
}

.btn-text:focus,
.btn-text.focus,
.btn-text:hover,
.btn-text.active {
  color: white;
  background: #a5adb2;
  border-color: #a5adb2;
}

.btn-text:active,
.btn-text.active,
.btn-text[aria-expanded="true"],
.btn-text.active:hover,
.btn-text.active:focus,
.btn-text[aria-expanded="true"]:hover,
.btn-text[aria-expanded="true"]:focus,
.open > .btn-text.dropdown-toggle {
  color: white;
  background: #5c666c;
  border-color: #40474b;
  background-image: none;
}

.btn-text.dropdown-toggle + ul li.active a {
  color: white;
  background: #89949b;
}

.btn-text.disabled,
.btn-text[disabled],
fieldset[disabled] .btn-text {
  pointer-events: none;
}

.btn-text .badge {
  color: #89949b;
  background-color: #89949b;
}

.menu-text ul li.active a,
.menu-text ul li.active a:hover {
  color: white;
  background: #89949b !important;
}

.nav-text > li.active > a,
.nav-text > rubix-menu > li.active > a,
.nav-text > rubix-nav-item > li.active > a {
  color: white;
  background: #89949b;
  border-color: #89949b;
}

.tab-text {
  border-color: #89949b;
}

.tab-text > li.active > a {
  border-color: #89949b;
  border-bottom-color: transparent;
}

.tab-text.nav-pills > li.active > a {
  background: #89949b;
  color: white;
}

.rubix-panel-header.nav-inline .nav-text > li.active > a {
  border: 1px solid #89949b;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-text > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-text {
  background: #89949b !important;
}

.bg-text table td,
.bg-text th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-text:focus {
  background: #89949b !important;
}

.bg-hover-text:hover {
  background: #89949b !important;
}

.fg-text {
  color: #89949b;
}

.fg-text .nav-tabs > li.active > a {
  color: #89949b;
}

.fg-tab-active-text .nav-tabs > li.active > a {
  color: #89949b !important;
}

.fg-focus-text:focus {
  color: #89949b;
}

.fg-hover-text:hover {
  color: #89949b;
}

.border-text {
  border-color: #89949b !important;
}

.border-text .rubix-timeline-body > ul {
  border-color: #89949b;
}

.border-text.rubix-timeline-view:before {
  border-color: #89949b;
}

.border-hover-text:hover {
  border-color: #89949b !important;
}

.border-focus-text:focus {
  border-color: #89949b !important;
}

.tl-text .rubix-timeline-body > ul > li:before {
  border-color: #89949b;
}

.list-bg-text > .list-group-item.active {
  background: #89949b !important;
  color: white !important;
}

.list-fg-text > .list-group-item {
  color: #89949b;
}

@media print {
  #sidebar {
    display: none !important;
  }

  #navbar {
    display: none !important;
  }

  #body {
    background: white;
    left: 0 !important;
    width: 100% !important;
    margin-top: 0 !important;
    margin-left: 0 !important;
  }

  .rubix-panel-controls {
    display: none !important;
  }
}

@keyframes vex-fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes vex-fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes vex-fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-webkit-keyframes vex-fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes vex-rotation {
  0% {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
    -webkit-transform: rotate(359deg);
    -moz-transform: rotate(359deg);
    -ms-transform: rotate(359deg);
    -o-transform: rotate(359deg);
  }
}

@-webkit-keyframes vex-rotation {
  0% {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
    -webkit-transform: rotate(359deg);
    -moz-transform: rotate(359deg);
    -ms-transform: rotate(359deg);
    -o-transform: rotate(359deg);
  }
}

.vex,
.vex *,
.vex *:before,
.vex *:after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.vex {
  position: fixed;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 9999999999999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.vex-overlay {
  background: black;
  filter: alpha(opacity=40);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
}

.vex-overlay {
  animation: vex-fadein 0.5s;
  -webkit-animation: vex-fadein 0.5s;
  -moz-animation: vex-fadein 0.5s;
  -ms-animation: vex-fadein 0.5s;
  -o-animation: vex-fadein 0.5s;
  -webkit-backface-visibility: hidden;
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.vex.vex-closing .vex-overlay {
  animation: vex-fadeout 0.5s;
  -webkit-animation: vex-fadeout 0.5s;
  -moz-animation: vex-fadeout 0.5s;
  -ms-animation: vex-fadeout 0.5s;
  -o-animation: vex-fadeout 0.5s;
  -webkit-backface-visibility: hidden;
}

.vex-content {
  animation: vex-fadein 0.5s;
  -webkit-animation: vex-fadein 0.5s;
  -moz-animation: vex-fadein 0.5s;
  -ms-animation: vex-fadein 0.5s;
  -o-animation: vex-fadein 0.5s;
  -webkit-backface-visibility: hidden;
  background: white;
}

.vex.vex-closing .vex-content {
  animation: vex-fadeout 0.5s;
  -webkit-animation: vex-fadeout 0.5s;
  -moz-animation: vex-fadeout 0.5s;
  -ms-animation: vex-fadeout 0.5s;
  -o-animation: vex-fadeout 0.5s;
  -webkit-backface-visibility: hidden;
}

.vex-close:before {
  font-family: Arial, sans-serif;
  content: "\\00D7";
}

.vex-dialog-form {
  margin: 0;
}

.vex-dialog-button {
  -webkit-appearance: none;
  cursor: pointer;
}

.vex-loading-spinner {
  animation: vex-rotation 0.7s linear infinite;
  -webkit-animation: vex-rotation 0.7s linear infinite;
  -moz-animation: vex-rotation 0.7s linear infinite;
  -ms-animation: vex-rotation 0.7s linear infinite;
  -o-animation: vex-rotation 0.7s linear infinite;
  -webkit-backface-visibility: hidden;
  -webkit-box-shadow: 0 0 1em rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 1em rgba(0, 0, 0, 0.1);
  position: fixed;
  z-index: 1112;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2em;
  width: 2em;
  background: white;
}

body.vex-open {
  overflow: hidden;
}

/*-- Chart --*/
.c3 svg {
  font: 10px sans-serif;
}

.c3 path,
.c3 line {
  fill: none;
  stroke: #000;
}

.c3 text {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.c3-legend-item-tile,
.c3-xgrid-focus,
.c3-ygrid,
.c3-event-rect,
.c3-bars path {
  shape-rendering: crispEdges;
}

.c3-chart-arc path {
  stroke: #fff;
}

.c3-chart-arc text {
  fill: #fff;
  font-size: 13px;
}

/*-- Axis --*/
/*-- Grid --*/
.c3-grid line {
  stroke: #aaa;
}

.c3-grid text {
  fill: #aaa;
}

.c3-xgrid,
.c3-ygrid {
  stroke-dasharray: 3 3;
}

/*-- Text on Chart --*/
.c3-text.c3-empty {
  fill: #808080;
  font-size: 2em;
}

/*-- Line --*/
.c3-line {
  stroke-width: 1px;
}

/*-- Point --*/
.c3-circle._expanded_ {
  stroke-width: 1px;
  stroke: white;
}

.c3-selected-circle {
  fill: white;
  stroke-width: 2px;
}

/*-- Bar --*/
.c3-bar {
  stroke-width: 0;
}

.c3-bar._expanded_ {
  fill-opacity: 0.75;
}

/*-- Arc --*/
.c3-chart-arcs-title {
  font-size: 1.3em;
}

/*-- Focus --*/
.c3-target.c3-focused path.c3-line,
.c3-target.c3-focused path.c3-step {
  stroke-width: 2px;
}

/*-- Region --*/
.c3-region {
  fill: steelblue;
  fill-opacity: 0.1;
}

/*-- Brush --*/
.c3-brush .extent {
  fill-opacity: 0.1;
}

/*-- Select - Drag --*/
/*-- Legend --*/
.c3-legend-item {
  font-size: 12px;
}

.c3-legend-background {
  opacity: 0.75;
  fill: white;
  stroke: lightgray;
  stroke-width: 1;
}

/*-- Tooltip --*/
.c3-tooltip {
  border-collapse: collapse;
  border-spacing: 0;
  background-color: #fff;
  empty-cells: show;
  -webkit-box-shadow: 7px 7px 12px -9px #777777;
          box-shadow: 7px 7px 12px -9px #777777;
  opacity: 0.9;
}

.c3-tooltip tr {
  border: 1px solid #ccc;
}

.c3-tooltip th {
  background-color: #242424;
  font-size: 14px;
  padding: 2px 5px;
  text-align: left;
  color: #fff;
}

.c3-tooltip td {
  font-size: 13px;
  padding: 3px 6px;
  background-color: #fff;
  border-left: 1px dotted #999;
}

.c3-tooltip td > span {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 6px;
}

.c3-tooltip td.value {
  text-align: right;
}

.c3-area {
  stroke-width: 0;
  opacity: 0.2;
}

.c3-chart-arcs .c3-chart-arcs-background {
  fill: #e0e0e0;
  stroke: none;
}

.c3-chart-arcs .c3-chart-arcs-gauge-unit {
  fill: #000;
  font-size: 16px;
}

.c3-chart-arcs .c3-chart-arcs-gauge-max {
  fill: #777;
}

.c3-chart-arcs .c3-chart-arcs-gauge-min {
  fill: #777;
}

.c3-chart-arc .c3-gauge-value {
  fill: #000;
  font-size: 28px;
}

code[class*="language-"],
pre[class*="language-"] {
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
  -ms-hyphens: none;
  hyphens: none;
  white-space: pre;
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
  font-family: Menlo, Monaco, "Courier New", monospace;
  font-size: 15px;
  line-height: 1.5;
  color: #dccf8f;
  text-shadow: 0;
  margin-bottom: 25px;
}

pre[class*="language-"],
:not(pre) > code[class*="language-"] {
  border-radius: 5px;
  border: 1px solid #000;
  color: #dccf8f;
  background: #181914;
}

pre[class*="language-"] {
  padding: 12px;
}

:not(pre) > code[class*="language-"] {
  padding: 2px 6px;
}

code[class*="language-"] .namespace,
pre[class*="language-"] .namespace {
  opacity: 0.7;
}

code[class*="language-"] .token.comment,
code[class*="language-"] .token.prolog,
code[class*="language-"] .token.doctype,
code[class*="language-"] .token.cdata,
pre[class*="language-"] .token.comment,
pre[class*="language-"] .token.prolog,
pre[class*="language-"] .token.doctype,
pre[class*="language-"] .token.cdata {
  color: #586e75;
  font-style: italic;
}

code[class*="language-"] .token.null,
code[class*="language-"] .token.operator,
code[class*="language-"] .token.boolean,
pre[class*="language-"] .token.null,
pre[class*="language-"] .token.operator,
pre[class*="language-"] .token.boolean {
  color: #dccf8f;
}

code[class*="language-"] .token.number,
code[class*="language-"] .token.string,
pre[class*="language-"] .token.string,
pre[class*="language-"] .token.number {
  color: #468966;
}

code[class*="language-"] .token.attr-name,
pre[class*="language-"] .token.attr-name {
  color: #b89859;
}

code[class*="language-"] .token.entity,
code[class*="language-"] .token.url,
.language-css code[class*="language-"] .token.string,
.style code[class*="language-"] .token.string,
pre[class*="language-"] .token.entity,
pre[class*="language-"] .token.url,
.language-css pre[class*="language-"] .token.string,
.style pre[class*="language-"] .token.string {
  color: #dccf8f;
}

code[class*="language-"] .token.selector,
pre[class*="language-"] .token.selector {
  color: #859900;
}

code[class*="language-"] .token.atrule,
code[class*="language-"] code[class*="language-"] .token.keyword,
code[class*="language-"] .token.control,
code[class*="language-"] .token.directive,
code[class*="language-"] .token.important,
code[class*="language-"] .token.unit,
pre[class*="language-"] .token.atrule,
pre[class*="language-"] .token.keyword,
pre[class*="language-"] .token.control,
pre[class*="language-"] .token.directive,
pre[class*="language-"] .token.important,
pre[class*="language-"] .token.unit {
  color: #cb4b16;
}

.token.attr-value,
pre[class*="language-"] .token.attr-value {
  color: #468966;
}

code[class*="language-"] .token.placeholder,
code[class*="language-"] .token.variable,
pre[class*="language-"] .token.placeholder,
pre[class*="language-"] .token.variable {
  color: #b58900;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
code[class*="language-"] .token.property,
pre[class*="language-"] .token.property {
  color: #b89859;
}

code[class*="language-"] .token.tag,
pre[class*="language-"] .token.tag {
  color: #ffb03b;
}

code[class*="language-"] .token.important,
code[class*="language-"] .token.statement,
pre[class*="language-"] .token.important,
pre[class*="language-"] .token.statement {
  /* font-weight: bold; */
  color: #dc322f;
}

code[class*="language-"] .token.punctuation,
pre[class*="language-"] .token.punctuation {
  color: #dccf8f;
}

code[class*="language-"] .token.entity,
pre[class*="language-"] .token.entity {
  cursor: help;
}

code[class*="language-"] .token.debug,
pre[class*="language-"] .token.debug {
  color: red;
}

.pojoaque-colors {
  color: #586e75;
  color: #b64926;
  color: #468966;
  color: #ffb03b;
  color: #b58900;
  color: #b89859;
  color: #dccf8f;
  color: #d3a60c;
  color: #cb4b16;
  color: #dc322f;
  color: #073642;
  color: #181914;
}

/* jquery.Jcrop.css v0.9.12 - MIT License */
/*
  The outer-most container in a typical Jcrop instance
  If you are having difficulty with formatting related to styles
  on a parent element, place any fixes here or in a like selector

  You can also style this element if you want to add a border, etc
  A better method for styling can be seen below with .jcrop-light
  (Add a class to the holder and style elements for that extended class)
*/
.jcrop-holder {
  direction: ltr;
  text-align: left;
}

/* Selection Border */
.jcrop-vline,
.jcrop-hline {
  background: #ffffff url("/public/imgs/common/jcrop/Jcrop.gif");
  font-size: 0;
  position: absolute;
}

.jcrop-vline {
  height: 100%;
  width: 1px !important;
}

.jcrop-vline.right {
  right: 0;
}

.jcrop-hline {
  height: 1px !important;
  width: 100%;
}

.jcrop-hline.bottom {
  bottom: 0;
}

/* Invisible click targets */
.jcrop-tracker {
  height: 100%;
  width: 100%;
  /* "turn off" link highlight */
  -webkit-tap-highlight-color: transparent;
  /* disable callout, image save panel */
  -webkit-touch-callout: none;
  /* disable cut copy paste */
  -webkit-user-select: none;
}

/* Selection Handles */
.jcrop-handle {
  background-color: #333333;
  border: 1px #eeeeee solid;
  width: 7px;
  height: 7px;
  font-size: 1px;
}

.jcrop-handle.ord-n {
  left: 50%;
  margin-left: -4px;
  margin-top: -4px;
  top: 0;
}

.jcrop-handle.ord-s {
  bottom: 0;
  left: 50%;
  margin-bottom: -4px;
  margin-left: -4px;
}

.jcrop-handle.ord-e {
  margin-right: -4px;
  margin-top: -4px;
  right: 0;
  top: 50%;
}

.jcrop-handle.ord-w {
  left: 0;
  margin-left: -4px;
  margin-top: -4px;
  top: 50%;
}

.jcrop-handle.ord-nw {
  left: 0;
  margin-left: -4px;
  margin-top: -4px;
  top: 0;
}

.jcrop-handle.ord-ne {
  margin-right: -4px;
  margin-top: -4px;
  right: 0;
  top: 0;
}

.jcrop-handle.ord-se {
  bottom: 0;
  margin-bottom: -4px;
  margin-right: -4px;
  right: 0;
}

.jcrop-handle.ord-sw {
  bottom: 0;
  left: 0;
  margin-bottom: -4px;
  margin-left: -4px;
}

/* Dragbars */
.jcrop-dragbar.ord-n,
.jcrop-dragbar.ord-s {
  height: 7px;
  width: 100%;
}

.jcrop-dragbar.ord-e,
.jcrop-dragbar.ord-w {
  height: 100%;
  width: 7px;
}

.jcrop-dragbar.ord-n {
  margin-top: -4px;
}

.jcrop-dragbar.ord-s {
  bottom: 0;
  margin-bottom: -4px;
}

.jcrop-dragbar.ord-e {
  margin-right: -4px;
  right: 0;
}

.jcrop-dragbar.ord-w {
  margin-left: -4px;
}

/* The "jcrop-light" class/extension */
.jcrop-light .jcrop-vline,
.jcrop-light .jcrop-hline {
  background: #ffffff;
  filter: alpha(opacity=70) !important;
  opacity: 0.7 !important;
}

.jcrop-light .jcrop-handle {
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  background-color: #000000;
  border-color: #ffffff;
  border-radius: 3px;
}

/* The "jcrop-dark" class/extension */
.jcrop-dark .jcrop-vline,
.jcrop-dark .jcrop-hline {
  background: #000000;
  filter: alpha(opacity=70) !important;
  opacity: 0.7 !important;
}

.jcrop-dark .jcrop-handle {
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  background-color: #ffffff;
  border-color: #000000;
  border-radius: 3px;
}

/* Simple macro to turn off the antlines */
.solid-line .jcrop-vline,
.solid-line .jcrop-hline {
  background: #ffffff;
}

/* Fix for twitter bootstrap et al. */
.jcrop-holder img,
img.jcrop-preview {
  max-width: none;
}

.morris-hover {
  position: absolute;
  z-index: 1000;
}

.morris-hover.morris-default-style {
  border-radius: 10px;
  padding: 6px;
  color: #666;
  background: rgba(255, 255, 255, 0.8);
  border: solid 2px rgba(230, 230, 230, 0.8);
  font-family: sans-serif;
  font-size: 12px;
  text-align: center;
}

.morris-hover.morris-default-style .morris-hover-row-label {
  font-weight: bold;
  margin: 0.25em 0;
}

.morris-hover.morris-default-style .morris-hover-point {
  white-space: nowrap;
  margin: 0.1em 0;
}

/* required styles */
.leaflet-map-pane,
.leaflet-tile,
.leaflet-marker-icon,
.leaflet-marker-shadow,
.leaflet-tile-pane,
.leaflet-tile-container,
.leaflet-overlay-pane,
.leaflet-shadow-pane,
.leaflet-marker-pane,
.leaflet-popup-pane,
.leaflet-overlay-pane svg,
.leaflet-zoom-box,
.leaflet-image-layer,
.leaflet-layer {
  position: absolute;
  left: 0;
  top: 0;
}

.leaflet-container {
  overflow: hidden;
  -ms-touch-action: none;
}

.leaflet-tile,
.leaflet-marker-icon,
.leaflet-marker-shadow {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
      user-select: none;
  -webkit-user-drag: none;
}

.leaflet-marker-icon,
.leaflet-marker-shadow {
  display: block;
}

/* map is broken in FF if you have max-width: 100% on tiles */
.leaflet-container img {
  max-width: none !important;
}

/* stupid Android 2 doesn't understand "max-width: none" properly */
.leaflet-container img.leaflet-image-layer {
  max-width: 15000px !important;
}

.leaflet-tile {
  -webkit-filter: inherit;
          filter: inherit;
  visibility: hidden;
}

.leaflet-tile-loaded {
  visibility: inherit;
}

.leaflet-zoom-box {
  width: 0;
  height: 0;
}

/* workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=888319 */
.leaflet-overlay-pane svg {
  -moz-user-select: none;
}

.leaflet-tile-pane {
  z-index: 2;
}

.leaflet-objects-pane {
  z-index: 3;
}

.leaflet-overlay-pane {
  z-index: 4;
}

.leaflet-shadow-pane {
  z-index: 5;
}

.leaflet-marker-pane {
  z-index: 6;
}

.leaflet-popup-pane {
  z-index: 7;
}

.leaflet-vml-shape {
  width: 1px;
  height: 1px;
}

.lvml {
  behavior: url(#default#VML);
  display: inline-block;
  position: absolute;
}

/* control positioning */
.leaflet-control {
  position: relative;
  z-index: 7;
  pointer-events: auto;
}

.leaflet-top,
.leaflet-bottom {
  position: absolute;
  z-index: 1000;
  pointer-events: none;
}

.leaflet-top {
  top: 0;
}

.leaflet-right {
  right: 0;
}

.leaflet-bottom {
  bottom: 0;
}

.leaflet-left {
  left: 0;
}

.leaflet-control {
  float: left;
  clear: both;
}

.leaflet-right .leaflet-control {
  float: right;
}

.leaflet-top .leaflet-control {
  margin-top: 10px;
}

.leaflet-bottom .leaflet-control {
  margin-bottom: 10px;
}

.leaflet-left .leaflet-control {
  margin-left: 10px;
}

.leaflet-right .leaflet-control {
  margin-right: 10px;
}

/* zoom and fade animations */
.leaflet-fade-anim .leaflet-tile,
.leaflet-fade-anim .leaflet-popup {
  opacity: 0;
  -webkit-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}

.leaflet-fade-anim .leaflet-tile-loaded,
.leaflet-fade-anim .leaflet-map-pane .leaflet-popup {
  opacity: 1;
}

.leaflet-zoom-anim .leaflet-zoom-animated {
  -webkit-transition: -webkit-transform 0.25s cubic-bezier(0, 0, 0.25, 1);
  transition: -webkit-transform 0.25s cubic-bezier(0, 0, 0.25, 1);
  transition: transform 0.25s cubic-bezier(0, 0, 0.25, 1);
  transition: transform 0.25s cubic-bezier(0, 0, 0.25, 1), -webkit-transform 0.25s cubic-bezier(0, 0, 0.25, 1);
}

.leaflet-zoom-anim .leaflet-tile,
.leaflet-pan-anim .leaflet-tile,
.leaflet-touching .leaflet-zoom-animated {
  -webkit-transition: none;
  transition: none;
}

.leaflet-zoom-anim .leaflet-zoom-hide {
  visibility: hidden;
}

/* cursors */
.leaflet-clickable {
  cursor: pointer;
}

.leaflet-container {
  cursor: -webkit-grab;
  cursor: -moz-grab;
}

.leaflet-popup-pane,
.leaflet-control {
  cursor: auto;
}

.leaflet-dragging .leaflet-container,
.leaflet-dragging .leaflet-clickable {
  cursor: move;
  cursor: -webkit-grabbing;
  cursor: -moz-grabbing;
}

/* visual tweaks */
.leaflet-container {
  background: #ddd;
  outline: 0;
}

.leaflet-container a {
  color: #0078a8;
}

.leaflet-container a.leaflet-active {
  outline: 2px solid orange;
}

.leaflet-zoom-box {
  border: 2px dotted #38f;
  background: rgba(255, 255, 255, 0.5);
}

/* general typography */
.leaflet-container {
  font: 12px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
}

/* general toolbar styles */
.leaflet-bar {
  -webkit-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);
          box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);
  border-radius: 4px;
}

.leaflet-bar a,
.leaflet-bar a:hover {
  background-color: #fff;
  border-bottom: 1px solid #ccc;
  width: 26px;
  height: 26px;
  line-height: 26px;
  display: block;
  text-align: center;
  text-decoration: none;
  color: black;
}

.leaflet-bar a,
.leaflet-control-layers-toggle {
  background-position: 50% 50%;
  background-repeat: no-repeat;
  display: block;
}

.leaflet-bar a:hover {
  background-color: #f4f4f4;
}

.leaflet-bar a:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.leaflet-bar a:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom: none;
}

.leaflet-bar a.leaflet-disabled {
  cursor: default;
  background-color: #f4f4f4;
  color: #bbb;
}

.leaflet-touch .leaflet-bar a {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

/* zoom control */
.leaflet-control-zoom-in,
.leaflet-control-zoom-out {
  font: bold 18px "Lucida Console", Monaco, monospace;
  text-indent: 1px;
}

.leaflet-control-zoom-out {
  font-size: 20px;
}

.leaflet-touch .leaflet-control-zoom-in {
  font-size: 22px;
}

.leaflet-touch .leaflet-control-zoom-out {
  font-size: 24px;
}

/* layers control */
.leaflet-control-layers {
  -webkit-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
          box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
  background: #fff;
  border-radius: 5px;
}

.leaflet-control-layers-toggle {
  background-image: url("/public/imgs/common/leaflet/layers.png");
  width: 36px;
  height: 36px;
}

.leaflet-retina .leaflet-control-layers-toggle {
  background-image: url("/public/imgs/common/leaflet/layers-2x.png");
  background-size: 26px 26px;
}

.leaflet-touch .leaflet-control-layers-toggle {
  width: 44px;
  height: 44px;
}

.leaflet-control-layers .leaflet-control-layers-list,
.leaflet-control-layers-expanded .leaflet-control-layers-toggle {
  display: none;
}

.leaflet-control-layers-expanded .leaflet-control-layers-list {
  display: block;
  position: relative;
}

.leaflet-control-layers-expanded {
  padding: 6px 10px 6px 6px;
  color: #333;
  background: #fff;
}

.leaflet-control-layers-selector {
  margin-top: 2px;
  position: relative;
  top: 1px;
}

.leaflet-control-layers label {
  display: block;
}

.leaflet-control-layers-separator {
  height: 0;
  border-top: 1px solid #ddd;
  margin: 5px -10px 5px -6px;
}

/* attribution and scale controls */
.leaflet-container .leaflet-control-attribution {
  background: #fff;
  background: rgba(255, 255, 255, 0.7);
  margin: 0;
}

.leaflet-control-attribution,
.leaflet-control-scale-line {
  padding: 0 5px;
  color: #333;
}

.leaflet-control-attribution a {
  text-decoration: none;
}

.leaflet-control-attribution a:hover {
  text-decoration: underline;
}

.leaflet-container .leaflet-control-attribution,
.leaflet-container .leaflet-control-scale {
  font-size: 11px;
}

.leaflet-left .leaflet-control-scale {
  margin-left: 5px;
}

.leaflet-bottom .leaflet-control-scale {
  margin-bottom: 5px;
}

.leaflet-control-scale-line {
  border: 2px solid #777;
  border-top: none;
  line-height: 1.1;
  padding: 2px 5px 1px;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  -webkit-box-sizing: content-box;
          box-sizing: content-box;
  background: #fff;
  background: rgba(255, 255, 255, 0.5);
}

.leaflet-control-scale-line:not(:first-child) {
  border-top: 2px solid #777;
  border-bottom: none;
  margin-top: -2px;
}

.leaflet-control-scale-line:not(:first-child):not(:last-child) {
  border-bottom: 2px solid #777;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
